const messages = {
  ar: {
    translations: {
      courses: {
        close: "إغلاق",
        commentsFeed: "تعليقات المستخدمين",
        feedEmpty: "لا توجد تعليقات بعد.",
        coverLabel: "صورة الغلاف (اختياري — بدونها نستخدم صورة الفيديو المصغرة)",
        firstVideo: "رابط فيديو يوتيوب (اختياري)",
        firstVideoHelp: "ينشئ الدرس الأول بهذا الفيديو. يمكنك إضافة دروس أخرى لاحقًا.",
        newPrefix: "جديد",
        editPrefix: "تعديل",
        pageTitleLabel: "اسم الصفحة",
        itemLabelLabel: "اسم العنصر (مفرد)",
        buttonPreview: "سيظهر الزر",
        uploadCover: "رفع صورة",
        coverUploaded: "تم رفع الصورة.",
        emptyAdmin: "لا يوجد شيء بعد. انقر على",
        emptyAdmin2: "لإنشاء الأول.",
        noLessonsAdmin: "لا تحتوي هذه الدورة على دروس بعد. انقر على \"درس جديد\" لإضافة فيديو يوتيوب أو PDF أو نص.",
        noLessonsUser: "لا توجد دروس منشورة في هذه الدورة بعد.",
        commentsHint: "اترك سؤالك هنا — يرد الفريق هنا مباشرة.",
        editPage: "تعديل اسم ووصف الصفحة",
        backTo: "العودة إلى",
        title: "الدورات",
        newCourse: "دورة جديدة",
        editCourse: "تعديل الدورة",
        courseTitle: "العنوان",
        description: "الوصف",
        coverUrl: "رابط صورة الغلاف",
        companies: "الشركات التي لديها وصول",
        companiesSelected: "شركة/شركات",
        status: "الحالة",
        active: "نشط",
        inactive: "غير نشط",
        save: "حفظ",
        cancel: "إلغاء",
        remove: "إزالة",
        removed: "تمت إزالة الدورة.",
        saved: "تم حفظ الدورة.",
        removeConfirm: "إزالة هذه الدورة ودروسها؟",
        titleRequired: "أدخل عنوانًا.",
        empty: "لا توجد دورات متاحة بعد.",
        back: "العودة إلى الدورات",
        lessons: "الدروس",
        lessonsShort: "دروس",
        noLessons: "لا توجد دروس بعد.",
        newLesson: "درس جديد",
        editLesson: "تعديل الدرس",
        lessonTitle: "عنوان الدرس",
        lessonKind: "النوع",
        kindVideo: "فيديو (يوتيوب)",
        kindPdf: "PDF",
        kindText: "نص",
        videoUrl: "رابط يوتيوب",
        pdfUrl: "رابط PDF",
        lessonBody: "نص داعم / محتوى",
        lessonSaved: "تم حفظ الدرس.",
        lessonRemoved: "تمت إزالة الدرس.",
        lessonTitleRequired: "أدخل عنوان الدرس.",
        removeLessonConfirm: "إزالة هذا الدرس؟",
        openPdf: "فتح PDF",
        badVideo: "رابط فيديو غير صالح.",
        comments: "التعليقات",
        noComments: "كن أول من يعلّق.",
        writeComment: "اكتب تعليقًا...",
        writeReply: "اكتب ردًا...",
        reply: "رد",
        send: "إرسال",
        removeCommentConfirm: "إزالة هذا التعليق؟",
        editDesc: "تعديل الوصف",
        descSaved: "تم حفظ الوصف.",
        descPlaceholder: "اكتب وصف منطقة الدورات...",
        noDesc: "منطقة الدورات والتدريب."
      },
      salesAgents: {
        fieldLabel: "اسم الحقل",
        fieldKey: "المفتاح",
        fieldType: "النوع",
        fieldRequired: "مطلوب",
        addField: "إضافة حقل",
        schedulingOn: "السماح بالجدولة",
        meet: "إنشاء رابط Meet",
        title: "وكلاء المبيعات",
        new: "وكيل جديد",
        name: "اسم الوكيل",
        nameRequired: "أدخل اسم الوكيل.",
        prompt: "موجه المحادثة",
        template: "القالب الأولي",
        identification: "التعريف",
        fields: "ما يجب أن يكتشفه الوكيل",
        extraction: "كيف يقرأ الذكاء الاصطناعي المحادثة",
        knowledge: "المعرفة والوسائط",
        knowledgeUpload: "رفع الوسائط",
        knowledgeEmpty: "لا توجد وسائط بعد.",
        knowledgeUploaded: "تم رفع الوسائط.",
        knowledgeRemoved: "تمت إزالة العنصر.",
        knowledgeRemoveConfirm: "إزالة هذا العنصر؟",
        onQualify: "عند التأهيل",
        onDisqualify: "عند الاستبعاد",
        scheduling: "الجدولة",
        tag: "وسم",
        kanban: "مرحلة كانبان",
        queue: "قائمة الانتظار",
        user: "الموظف",
        transfer: "تحويل إلى إنسان",
        duplicate: "تكرار",
        duplicated: "تم تكرار الوكيل.",
        remove: "إزالة",
        removed: "تمت إزالة الوكيل.",
        save: "حفظ",
        saved: "تم حفظ الوكيل!",
        cancel: "إلغاء",
        activeOn: "نشط",
        activeOff: "متوقف",
        none: "لا شيء",
        empty: "لم يتم تكوين وكلاء مبيعات بعد.",
        minValue: "الحد الأدنى للقيمة",
        maxValue: "الحد الأقصى للقيمة",
        duration: "المدة (دقيقة)"
      },
      agentTemplates: {
        title: "قوالب الوكيل",
        new: "قالب جديد",
        label: "اسم القالب",
        labelRequired: "أدخل اسم القالب.",
        description: "وصف قصير",
        scope: "ينطبق على",
        scopeBoth: "كلاهما",
        scopeConversation: "محادثة",
        scopeCommercial: "تجاري",
        niche: "المجال (اختياري)",
        promptTitle: "موجه المحادثة",
        extractionTitle: "تعليمات الاستخراج (وكيل المبيعات)",
        duplicate: "تكرار",
        duplicated: "تم تكرار القالب.",
        remove: "إزالة",
        removed: "تمت إزالة القالب.",
        removeConfirm: "إزالة هذا القالب؟",
        save: "حفظ",
        saved: "تم حفظ القالب!",
        cancel: "رجوع",
        empty: "لا توجد قوالب بعد.",
        systemLocked: "قالب النظام (للقراءة فقط)"
      },
      whatsappQuality: {
        title: "جودة الرقم",
        connection: "الاتصال",
        official: "جودة ميتا (واجهة رسمية)",
        notes: "ملاحظات",
        checkedAt: "آخر فحص",
        refresh: "تحديث الآن",
        close: "إغلاق",
        empty: "لا توجد بيانات."
      },
      geoReport: {
        contactsTitle: "جهات الاتصال",
        contactsHelp: "كل جهة اتصال مع الموقع المستنتج من الرقم. استخدم الفلتر للتحقق.",
        searchPlaceholder: "ابحث بالاسم أو الرقم...",
        filterLocation: "الموقع",
        allLocations: "كل المواقع",
        noContacts: "لا توجد جهات اتصال لهذا الفلتر.",
        contactName: "الاسم",
        contactNumber: "الرقم",
        contactState: "الولاية",
        contactRegion: "المنطقة",
        contactCountry: "الدولة",
        exportPdf: "تصدير PDF",
        exporting: "جارٍ الإنشاء...",
        regions: { north: "الشمال", northeast: "الشمال الشرقي", midwest: "الوسط الغربي", southeast: "الجنوب الشرقي", south: "الجنوب" },
        title: "جهات الاتصال حسب المنطقة",
        start: "البداية",
        end: "النهاية",
        filter: "تصفية",
        totalContacts: "جهات الاتصال في الفترة",
        mapped: "تم تحديد موقعها",
        unmapped: "غير محددة",
        byRegion: "جهات الاتصال حسب المنطقة",
        inferred: "التوزيع مستنتج من رمز المنطقة/الدولة للرقم. الأرقام المنقولة والخطوط المؤسسية قد تظهر في منطقة خاطئة.",
        topStates: "أهم الولايات",
        topStatesHelp: "الولايات الـ12 الأكثر جهات اتصال في الفترة.",
        noStates: "لم يتم تحديد أي جهة اتصال برازيلية في الفترة.",
        otherCountries: "دول أخرى",
        countriesHelp: "جهات اتصال برمز دولة خارج البرازيل.",
        noInternational: "لم يتم اكتشاف أي جهة اتصال دولية."
      },
      utmLinks: {
        newLink: "رابط حملة جديد",
        preview: "معاينة الرابط",
        previewEmpty: "اختر اتصالاً أو أدخل الرقم لعرض الرابط.",
        useConnection: "استخدام رقم من اتصال",
        useManual: "إدخال الرقم يدويًا",
        noConnections: "لا يوجد اتصال برقم متاح.",
        reportMoved: "تقرير الإعلانات أصبح في التقارير ← تقرير الإعلانات.",
        title: "روابط UTM",
        tabs: { links: "روابطي", report: "تقرير الإعلانات" },
        help: "أنشئ رابطًا لكل إعلان. الرمز في نهاية الرسالة هو ما يحدد مصدر العميل — لا تحذفه أو تعدّله عند استخدام الرابط في الإعلان.",
        reportHelp: "العملاء والمحادثات الناتجة عن كل إعلان. يُحتسب العميل عند إرسال أول رسالة عبر الرابط.",
        fields: {
          connection: "الاتصال",
          name: "اسم الرابط", source: "المصدر", medium: "الوسيط",
          campaign: "الحملة", content: "الإعلان / التصميم",
          number: "رقم واتساب (مع رمز الدولة)", message: "رسالة معبأة مسبقًا"
        },
        report: { converted: "العملاء المحوّلون", leads: "العملاء", tickets: "المحادثات", closed: "المغلقة" },
        code: "الرمز", url: "رابط الإعلان", actions: "الإجراءات",
        create: "إنشاء رابط", copy: "نسخ الرابط", copied: "تم نسخ الرابط!",
        remove: "حذف الرابط", removed: "تم حذف الرابط.", created: "تم إنشاء الرابط!",
        nameRequired: "أدخل اسم الرابط.",
        numberRequired: "أدخل رقم واتساب مع رمز الدولة.",
        emptyLinks: "لم يتم إنشاء أي روابط بعد.",
        emptyReport: "لا توجد بيانات في هذه الفترة."
      },
      leadSource: {
        chipEmpty: "المصدر",
        menuTitle: "اختر مصدر العميل المحتمل",
        empty: "لا توجد مصادر مسجلة",
        clear: "مسح المصدر",
        saved: "تم تحديث المصدر!",
        label: "مصدر العميل المحتمل",
        none: "بدون مصدر"
      },
      leadSourceSettings: {
        title: "مصادر العملاء المحتملين",
        description: "حدد من أين يأتي جهات الاتصال. يختار الموظف المصدر في رأس المحادثة، ويظهر في جهة الاتصال وفي تقرير الحملات.",
        name: "الاسم",
        icon: "الأيقونة",
        color: "اللون",
        add: "إضافة",
        added: "تمت إضافة المصدر!",
        removed: "تم حذف المصدر.",
        remove: "حذف المصدر",
        nameRequired: "أدخل اسم المصدر.",
        newPlaceholder: "مصدر جديد",
        activeOn: "نشط — يظهر للموظف",
        activeOff: "غير نشط — مخفي عن الموظف",
        icons: {
          facebook: "فيسبوك", instagram: "إنستغرام", messenger: "ماسنجر",
          google: "جوجل", tiktok: "تيك توك", youtube: "يوتيوب",
          organic: "عضوي", referral: "إحالة", other: "أخرى"
        }
      },
      authTabs: {
        login: "تسجيل الدخول",
        signup: "إنشاء حساب"
      },
      welcome: {
        dontShowAgain: "عدم عرض هذه التحية مرة أخرى",
        messages: {
          m1: "سعداء بوجودك هنا. نتمنى لك يومًا موفقًا!",
          m2: "فريقك بانتظارك بالفعل. هيا بنا؟",
          m3: "كل محادثة فرصة لإسعاد شخص ما.",
          m4: "يوم جديد وفرص جديدة لخدمة العملاء بشكل أفضل.",
          m5: "القهوة جاهزة وكل شيء مهيأ للبدء.",
          m6: "لا شيء أفضل من بدء اليوم بصندوق وارد مرتب.",
          m7: "نتمنى أن يكون يومك خفيفًا ومنتجًا.",
          m8: "العميل الذي يُخدم جيدًا يتذكر ذلك طويلًا.",
          m9: "سعداء بعودتك. لنحقق ما نصبو إليه.",
          m10: "خذ نفسًا عميقًا. محادثة تلو الأخرى."
        },
        morning: "صباح الخير!",
        afternoon: "مساء الخير!",
        evening: "مساء الخير!",
        morningWithName: "صباح الخير، {{name}}!",
        afternoonWithName: "مساء الخير، {{name}}!",
        eveningWithName: "مساء الخير، {{name}}!",
        subtitle: "سعداء بوجودك هنا. نتمنى لك يومًا موفقًا!",
        close: "إغلاق"
      },
    voiceIvr: {
      criarDestinos: "إنشاء تحويل لكل خيار",
      destinosCriados: "تم إنشاء التحويلات. اختر الطابور لكل منها.",
      transferindoPara: "انتظر من فضلك، سأحوّلك الآن.",
      voz: {
        semVozEscolhida: "لم يتم اختيار صوت",
        buscarVozes: "جلب الأصوات",
        escolhaVoz: "الصوت",
        modeloPadrao: "افتراضي المزود",
        previa: "معاينة الصوت",
        informeChave: "أدخل مفتاح الواجهة أولاً.",
        nenhumaVoz: "لا توجد أصوات في هذا الحساب.",
        falhaBusca: "تعذّر الوصول إلى المزود.",
        comecar: "الصق مفتاح الواجهة واضغط جلب الأصوات لتحميل أصوات حسابك.",
        titulo: "صوت الرد الآلي",
        provedor: "مزود الصوت",
        padraoServidor: "الصوت الافتراضي للخادم",
        idDaVoz: "معرّف الصوت",
        idDaVozAjuda: "انسخ معرّف الصوت من لوحة تحكم المزود.",
        chaveApi: "مفتاح الواجهة",
        verChave: "إظهار المفتاح أو إخفاؤه",
        modelo: "النموذج (اختياري)",
        ajuda: "بدون اختيار مزود، يستخدم الرد الآلي الصوت المهيأ في الخادم. يعمل Piper على جهازك دون تكلفة استخدام.",
        avisoChave: "يُحفظ المفتاح مع هذا الرد الآلي في خادم الصوت. استخدم مفتاحاً مخصصاً بحد استخدام حتى تتمكن من إلغائه دون التأثير على غيره.",
        provedores: {
          piper: "Piper (على خادمك)",
          elevenlabs: "ElevenLabs",
          openai: "OpenAI",
        },
      },
      titulo: "منشئ الرد الصوتي",
      nova: "رد صوتي جديد",
      novaModelo: "البدء بقالب جاهز",
      novaVazia: "البدء من الصفر",
      editando: "تعديل الرد الصوتي",
      editar: "تعديل",
      excluir: "حذف",
      voltar: "رجوع",
      salvar: "حفظ",
      salva: "تم حفظ الرد الصوتي.",
      excluida: "تم حذف الرد الصوتي.",
      ativa: "مفعّل",
      inativa: "غير مفعّل",
      passo: "الخطوة",
      semUras: "لم يتم إنشاء أي رد صوتي بعد.",
      semUrasDica: "أنشئ واحداً ليتم الرد على المكالمات الواردة تلقائياً.",
      explicacao: "جهّز الرد الآلي على المكالمات. بعد الحفظ، انتقل إلى الاتصالات واختر هذا الرد الصوتي في حقل الرد الصوتي.",
      comoFunciona: "تُنفَّذ الخطوات من الأعلى إلى الأسفل. القائمة وحدها تتفرّع: كل خيار ينتقل إلى الخطوة التي تحددها.",
      confirmarExclusao: "حذف هذا الرد الصوتي؟",
      confirmarExclusaoTexto: "الاتصالات التي تستخدم هذا الرد الصوتي ستعود للرنين مباشرة على الموظف.",
      naoEditavel: "This IVR was created in an old format and cannot be opened in this editor. Create a new IVR with the steps you need.",
      adicionarPasso: "إضافة خطوة",
      removerPasso: "إزالة الخطوة",
      subir: "تحريك للأعلى",
      descer: "تحريك للأسفل",
      adicionarOpcao: "إضافة خيار",
      removerOpcao: "إزالة الخيار",
      seguirOrdem: "المتابعة إلى الخطوة التالية",
      primeiroPasso: "يبدأ من",
      corrijaAntes: "صحّح قبل الحفظ:",
      nenhuma: "لا شيء",
      qualquer: "أي موظف في الطابور",
      colunas: {
        nome: "الاسم",
        situacao: "الحالة",
        acoes: "إجراءات",
      },
      tipos: {
        message: "تشغيل رسالة",
        voice_menu: "قائمة الخيارات",
        dtmf_capture: "طلب أرقام",
        record_audio: "تسجيل رسالة",
        transfer: "التحويل إلى موظف",
        end: "إنهاء المكالمة",
      },
      campos: {
        nome: "اسم الرد الصوتي",
        ativa: "الرد الصوتي مفعّل",
        tipo: "نوع الخطوة",
        falar: "ما سيقوله الرد الصوتي",
        falarAjuda: "يُقرأ هذا النص بصوت مسموع للمتصل.",
        menuFala: "نص القائمة",
        menuFalaAjuda: "اذكر الخيارات بصوت مسموع. مثال: للمبيعات اضغط 1.",
        opcoes: "الخيارات",
        tecla: "المفتاح",
        rotulo: "اسم الخيار",
        irPara: "الانتقال إلى",
        teclaDica: "استخدم مفاتيح من رقم واحد (1 إلى 9). بهذا يتعرّف الرد الصوتي على النغمة فوراً دون انتظار. يمكن للمتصل أيضاً نطق اسم الخيار.",
        tempo: "مدة الانتظار (ثانية)",
        seNaoResponder: "في حال عدم الرد",
        seNaoEntender: "في حال عدم الفهم",
        pedirDigitos: "ما المطلوب إدخاله",
        pedirDigitosAjuda: "مثال: أدخل رقم حسابك ثم اضغط مفتاح المربع.",
        maxDigitos: "أقصى عدد أرقام",
        guardarEm: "الحفظ باسم",
        guardarEmAjuda: "استخدم {{الاسم}} في النصوص التالية",
        segundos: "أقصى مدة (ثانية)",
        gravarAjuda: "أضف خطوة رسالة قبل هذه الخطوة ليعرف المتصل أنه يستطيع البدء.",
        avisoTransferencia: "رسالة قبل التحويل",
        avisoTransferenciaAjuda: "اختياري. مثال: انتظر من فضلك، سأحوّلك الآن.",
        fila: "الطابور",
        atendente: "الموظف",
        transferirAjuda: "ينتهي الرد الصوتي هنا: تنتقل المكالمة إلى موظف بشري.",
        despedida: "رسالة الوداع",
        despedidaAjuda: "تنتهي المكالمة بعد هذه الرسالة.",
      },
      erros: {
        nomeObrigatorio: "أعطِ الرد الصوتي اسماً.",
        semPassos: "أضف خطوة واحدة على الأقل.",
        falaVazia: "اكتب ما سيقوله الرد الصوتي.",
        semOpcoes: "القائمة تحتاج خياراً واحداً على الأقل.",
        teclaRepetida: "هناك خياران يستخدمان المفتاح نفسه.",
        semDestino: "اختر طابوراً أو موظفاً للتحويل.",
      },
      title: "الرد الصوتي التفاعلي (WhatsApp Plus)",
      desc: "مسار يرد على المكالمة قبل الموظف. يسمع العميل القائمة ويختار من لوحة المفاتيح.",
      none: "بدون رد آلي — يرن مباشرة للموظف",
      inactive: "(معطل)",
      empty: "لا يوجد مسار صوتي مسجل. أنشئ واحداً في الأتمتة ثم عد لربطه."
    },
    ramais: {
      title: "التحويلات الداخلية",
      dial: "طلب تحويلة",
      call: "اتصال",
      callVoice: "اتصال (صوت)",
      callVideo: "اتصال (فيديو)",
      empty: "لا توجد تحويلات مسجلة. حدد التحويلة في ملف كل مستخدم.",
      extension: "تحويلة",
      available: "متاح",
      onCall: "في مكالمة",
      offline: "غير متصل",
      incoming: "مكالمة واردة",
      calling: "جاري الاتصال...",
      inCall: "في مكالمة",
      answer: "رد",
      reject: "رفض",
      hangup: "إنهاء",
      mute: "كتم",
      unmute: "إلغاء الكتم",
      transfer: "تحويل",
      transferTooltip: "تحويل هذه المكالمة",
      close: "إغلاق",
      transferredCall: "مكالمة محوّلة",
      transferTitle: "تحويل مكالمة",
      transferFrom: "{{name}} يريد تحويل مكالمة إليك.",
      accept: "قبول",
      noCameraLocal: "لا توجد كاميرا هنا — سترى وتسمع، لكن سترسل الصوت فقط.",
      noCameraAnswer: "لا توجد كاميرا هنا — سترى الطرف الآخر وترسل الصوت فقط.",
      noCameraRemote: "الطرف الآخر بدون كاميرا — ستسمع صوته فقط.",
      toasts: {
        busy: "التحويلة مشغولة حالياً.",
        notFound: "التحويلة غير موجودة.",
        self: "لا يمكنك الاتصال بتحويلتك.",
        failed: "تعذر إتمام المكالمة.",
        connectFailed: "فشل في توصيل المكالمة.",
        alreadyInCall: "أنت في مكالمة بالفعل.",
        startFailed: "تعذر بدء المكالمة.",
        answerFailed: "تعذر الرد.",
        lost: "انتهت المكالمة (فقد الاتصال).",
        transferOffered: "تم عرض التحويل على {{name}}."
      }
    },
    officialCall: {
      title: "مكالمة عبر واتساب الرسمي",
      connection: "الاتصال",
      number: "الرقم مع رمز المنطقة",
      numberPlaceholder: "5511999999999",
      permissionHint: "لإجراء مكالمة، يجب أن يكون العميل قد سمح باستقبال المكالمات. بدون ذلك ترفض Meta المكالمة.",
      noConnection: "لا يوجد اتصال رسمي متصل. المكالمات تعمل فقط على اتصالات واتساب الرسمي.",
      incoming: "مكالمة واردة",
      calling: "جاري الاتصال...",
      connecting: "جاري التوصيل...",
      inCall: "في مكالمة",
      answer: "رد",
      reject: "رفض",
      hangup: "إنهاء",
      mute: "كتم",
      unmute: "إلغاء الكتم",
      call: "اتصال",
      close: "إغلاق",
      tooltip: "اتصال عبر واتساب الرسمي",
      toasts: {
        noSdp: "وصلت المكالمة بدون بيانات صوتية. اطلب إعادة الاتصال.",
        typeNumber: "أدخل الرقم مع رمز المنطقة.",
        chooseConnection: "اختر الاتصال الرسمي.",
        alreadyInCall: "أنت في مكالمة بالفعل.",
        answerFailed: "تعذر الرد.",
        startFailed: "تعذر بدء المكالمة.",
        failed: "تعذر إتمام المكالمة.",
        lost: "انتهت المكالمة (فقد الاتصال).",
        rejected: "تم رفض المكالمة.",
        missed: "لم يتم الرد على المكالمة.",
        callFailed: "فشلت المكالمة."
      }
    },
    groupGreeting: {
      cardTitle: "رسالة ترحيب",
      cardDesc: "رسالة تلقائية لمن ينضم إلى المجموعة",
      dialogTitle: "رسالة ترحيب",
      intro: "تُرسل تلقائياً عندما ينضم شخص إلى",
      introScope: "هذا الإعداد يخص هذه المجموعة على هذا الاتصال فقط.",
      enable: "تفعيل الترحيب في هذه المجموعة",
      whereToSend: "أين تُرسل",
      inGroup: "في المجموعة، مع الإشارة إلى المنضم",
      inPrivate: "برسالة خاصة للعضو الجديد",
      privateWarning: "من لم يراسل هذا الرقم من قبل قد لا يستلم الرسالة الخاصة — واتساب يحظر الإرسال للغرباء.",
      message: "الرسالة",
      messagePlaceholder: "مثال: {{saudacao}}، {{primeiro_nome}}! مرحباً بك في {{grupo}}.",
      variablesHint: "انقر لإدراج متغير:",
      preview: "معاينة",
      previewTitle: "معاينة (ببيانات تجريبية)",
      save: "حفظ",
      toasts: {
        loadError: "تعذر تحميل ترحيب هذه المجموعة.",
        saved: "تم حفظ الترحيب.",
        saveError: "تعذر حفظ الترحيب.",
        previewError: "تعذر إنشاء المعاينة."
      }
    },
      sipSettings: {
        title: 'خط SIP',
        navSubtitle: 'الاتصال عبر SIP',
        subtitle: 'الاتصال/الاستقبال عبر خط SIP (Asterisk أو FreePBX أو مزود VoIP) بشكل مستقل عن واتساب. بعد الحفظ، استخدم علامة التبويب "عبر SIP" في لوحة اتصال واتساب بلس.',
        warning: 'يتطلب خدمة خط SIP مثبتة على الخادم — يتم تثبيتها تلقائيًا عند تثبيت/تحديث النظام. إذا ظهرت الشارة أدناه "SIP غير متصل"، شغّل المثبّت ← الأدوات ← تثبيت خط SIP يدويًا. بعد تغيير المضيف/اسم المستخدم/كلمة المرور، قد يلزم إعادة تشغيل الخدمة يدويًا لقراءة الحساب الجديد.',
        connected: 'SIP متصل',
        disconnected: 'SIP غير متصل',
        trunkEnabled: 'الخط مفعّل',
        trunkDisabled: 'الخط معطّل',
        enableTrunk: 'تفعيل خط SIP',
        host: 'الخادم (host)',
        port: 'المنفذ',
        username: 'اسم المستخدم',
        usernamePlaceholder: 'رقم داخلي أو اسم مستخدم الخط',
        passwordFilled: 'كلمة المرور (محفوظة — اتركها فارغة للاحتفاظ بها)',
        password: 'كلمة المرور',
        domain: 'نطاق SIP',
        domainPlaceholder: 'اتركه فارغًا لاستخدام المضيف',
        domainHelp: 'املأ فقط إذا كان نطاق SIP مختلفًا عن مضيف/IP الخط.',
        transport: 'النقل',
        callerId: 'هوية المتصل',
        optional: 'اختياري',
        save: 'حفظ',
        testCallHelp: 'مكالمة تجريبية: بعد الحفظ وتشغيل خدمة SIP، افتح لوحة اتصال واتساب بلس، اختر "عبر SIP" واتصل برقم/تحويلة معروفة من مقسمك الهاتفي.',
        saved: 'تم حفظ إعدادات خط SIP.',
        saveError: 'تعذر حفظ خط SIP.',
      },
      callModal: {
        contact: 'جهة الاتصال',
        incoming: 'مكالمة واردة',
        calling: 'جارٍ الاتصال...',
        inProgress: 'المكالمة جارية',
        finished: 'انتهت المكالمة',
        ended: 'منتهية',
      },
      dialer: {
        canais: {
          ramal: "تحويلة",
          whatsapp: "واتساب بلس",
          oficial: "الواجهة الرسمية",
          sip: "SIP",
        },
        semCanais: "لا توجد قناة اتصال مهيأة. تواصل مع المسؤول.",
        ramalPlaceholder: "رقم التحويلة",
        title: 'لوحة الاتصال',
        recent: 'الأخيرة',
        viaWhatsapp: 'عبر واتساب',
        viaSip: 'عبر SIP',
        noWhatsappConnected: 'لا يوجد واتساب متصل.',
        sipWarning: 'مكالمة عبر خط SIP (مستقل عن واتساب). قم بتهيئة الخط في الإعدادات ← خط SIP.',
        sipNumberPlaceholder: 'رقم/تحويلة SIP',
        numberPlaceholder: 'الرقم',
        audioOnly: 'صوت فقط',
        videoCall: 'مكالمة فيديو',
        call: 'اتصال',
        noRecentCalls: 'لا توجد مكالمات حديثة',
        dialFailed: 'فشل الاتصال',
      },
      flowPage: {
        noDescription: "بدون وصف",
        trigger: "المشغل",
        noKeywords: "لم يتم تكوين كلمات مفتاحية",
        executions: "عمليات تنفيذ",
        node: "عقدة",
        nodes: "عقد",
        successRate: "معدل النجاح",
        updated: "تم التحديث",
        tooltipEdit: "تعديل التدفق",
        tooltipActivate: "تفعيل التدفق",
        tooltipDeactivate: "تعطيل التدفق",
        triggerTypes: {
          keyword: "كلمة مفتاحية",
          anyMessage: "أي رسالة",
          firstContact: "أول اتصال",
          outOfHours: "خارج ساعات العمل",
          regex: "تعبير منتظم (Regex)",
          integration: "تكامل / Webhook",
          manual: "يدوي (تشغيل عبر API)",
        },
        menu: {
          edit: "تعديل",
          report: "تقرير",
          duplicate: "تكرار",
          export: "تصدير",
          delete: "حذف",
        },
      },
      flowFormModal: {
        description: "الوصف",
        triggerType: "نوع المشغل",
        keywords: "الكلمات المفتاحية",
        keywordsPlaceholder: "اكتب واضغط Enter أو فاصلة",
        keywordsHelper: "أضف عدة كلمات. اضغط Enter أو Tab أو فاصلة لتأكيد كل واحدة.",
      },
      flowReport: {
        title: "تقرير التدفق",
        executions: "عمليات التنفيذ",
        completion: "الإكمال",
        clickRate: "معدل النقر",
        avgNodes: "متوسط العقد",
        interactionRate: "معدل التفاعل",
        started: "بدأوا",
        interacted: "تفاعلوا",
        completed: "أكملوا",
        completionRate: "معدل الإكمال",
        close: "إغلاق",
      },
      adsReport: {
        sourceTitle: "مصادر العملاء",
        charts: { funnel: "مسار العملاء", byStatus: "التوزيع حسب الحالة", topAds: "أفضل الإعلانات حسب العملاء" , bySource: "حسب مصدر العميل" },
        utmTitle: "روابط UTM",
        title: "تقرير الإعلانات",
        startDate: "البداية",
        endDate: "النهاية",
        status: "الحالة",
        search: "بحث (هاتف، إعلان، ctwa_clid)",
        filter: "تصفية",
        export: "تصدير",
        statusOptions: {
          all: "الكل",
          new: "جديد",
          contact: "قيد الخدمة",
          qualified: "مؤهل",
          purchase: "بيع",
          lost: "مفقود",
        },
        kpis: {
          total: "الإجمالي",
          new: "جدد",
          contact: "قيد الخدمة",
          qualified: "مؤهلون",
          purchase: "مبيعات",
          lost: "مفقودون",
        },
        performanceTitle: "الأداء حسب الإعلان",
        leadsTitle: "العملاء المحتملون",
        columns: {
          ad: "الإعلان",
          id: "المعرف",
          leads: "العملاء",
          sales: "المبيعات",
          conv: "نسبة التحويل %",
          date: "التاريخ",
          contact: "جهة الاتصال",
          phone: "الهاتف",
          origin: "المصدر",
          channel: "القناة",
          status: "الحالة",
          capi: "CAPI",
        },
        empty: {
          ads: "لم يتم التقاط أي إعلان في الفترة.",
          leads: "لم يتم العثور على عملاء محتملين.",
        },
        capiTooltip: "تم الإرسال {{when}}",
      },
      signup: {
        title: "إنشاء حساب",
        toasts: {
          success: "تم إنشاء المستخدم بنجاح! يرجى تسجيل الدخول الآن!",
          disabled:
            "تسجيل المستخدمين معطل حالياً. يرجى المحاولة مرة أخرى لاحقاً.",
          fail: "حدث خطأ أثناء إنشاء المستخدم. تحقق من البيانات المدخلة.",
          codeSent: "تم إرسال رمز التحقق إلى بريدك الإلكتروني!",
          codeResent: "تم إرسال رمز جديد!"
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          company: "اسم المنظمة",
          phone: "واتساب (رمز الدولة + الرقم)",
        },
        buttons: {
          submit: "تسجيل",
          login: "لديك حساب بالفعل؟ سجّل الدخول!",
        },
        plan: {
          title: "اختر خطتك",
          subtitle: "اختر الخطة المثالية لشركتك",
          badge: "مثالي لشركتك",
          period: "شهر",
          meta: "حتى {{users}} مستخدمين · حتى {{connections}} اتصالات"
        },
        formStep: {
          title: "أنشئ حسابك",
          subtitle: "أكمل بيانات شركتك"
        },
        verify: {
          title: "التحقق من البريد الإلكتروني",
          subtitle: "أدخل الرمز المكون من 6 أرقام المرسل إلى",
          confirm: "تحقق وأنشئ الحساب",
          sending: "جاري الإرسال...",
          resend: "إعادة إرسال الرمز",
          resendIn: "إعادة الإرسال خلال"
        },
        actions: {
          continue: "متابعة",
          back: "رجوع",
          hasAccount: "لديك حساب بالفعل؟",
          enter: "دخول"
        },
        document: {
          label: "CPF / CNPJ / مستند (اختياري)",
          cpfValid: "CPF صالح!",
          cnpjValid: "CNPJ صالح! تم تعبئة اسم الشركة تلقائياً.",
          invalid: "مستند غير صالح.",
          error: "خطأ أثناء التحقق من المستند."
        },
        validation: {
          required: "هذا الحقل مطلوب",
          nameMin: "يجب أن يحتوي الاسم على حرفين على الأقل",
          nameMax: "يجب ألا يزيد الاسم عن 50 حرفاً",
          companyMin: "يجب أن يحتوي اسم الشركة على حرفين على الأقل",
          companyMax: "يجب ألا يزيد اسم الشركة عن 50 حرفاً",
          passwordMin: "يجب أن تتكون كلمة المرور من 5 أحرف على الأقل",
          passwordMax: "يجب ألا تزيد كلمة المرور عن 50 حرفاً",
          invalidEmail: "بريد إلكتروني غير صالح",
          codeLength: "أدخل الرمز الكامل المكون من 6 أرقام."
        },
        features: {
          whatsapp: "WhatsApp",
          facebook: "Facebook",
          instagram: "Instagram",
          campaigns: "الحملات",
          schedules: "المواعيد",
          internalChat: "الدردشة الداخلية",
          externalApi: "واجهة API خارجية",
          integrations: "التكاملات",
          openAi: "OpenAI",
          kanban: "Kanban"
        }
      },
      ticketInfo: {
        copyPhone: "نسخ الهاتف",
        quickMessages: "الردود السريعة",
        phonecopied: "تم نسخ الهاتف إلى الحافظة!",
        noPhone: "لا يوجد هاتف متاح للنسخ",
        copyError: "خطأ في نسخ الهاتف",
      },
      login: {
        title: "تسجيل الدخول",
        welcome: "مرحباً بعودتك",
        loginInstruction: "أدخل بياناتك للوصول إلى حسابك",
        forgotPassword: "هل نسيت كلمة المرور؟",
        form: {
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          button: "دخول",
        },
        buttons: {
          submit: "دخول",
          register: "ليس لديك حساب؟ أنشئ حساباً!",
        },
        footer: "جميع الحقوق محفوظة.",
      },
      forgotPassword: {
        title: "استعادة الوصول",
        subtitleLine1: "أدخل البريد الإلكتروني المرتبط بحسابك.",
        subtitleLine2: "سنرسل لك رمز تحقق.",
        email: "البريد الإلكتروني",
        placeholder: "your.email@example.com",
        sending: "جاري الإرسال...",
        send: "إرسال الرمز",
        back: "العودة إلى تسجيل الدخول",
        toasts: {
          requiredEmail: "أدخل بريدك الإلكتروني",
          success: "إذا كان البريد الإلكتروني مسجلاً، فسيتم إرسال رمز.",
          error: "خطأ أثناء إرسال الرمز. تحقق من إعداد SMTP في الإعدادات."
        }
      },
      validateCode: {
        title: "تحقق من بريدك الإلكتروني",
        subtitle: "لقد أرسلنا رمزاً مكوناً من 6 أرقام إلى",
        label: "رمز التحقق",
        submitting: "جارٍ التحقق...",
        submit: "تحقق من الرمز",
        resendPrompt: "لم يصلك؟ أعد إرسال الرمز",
        back: "رجوع",
        toasts: {
          incomplete: "أدخل الرمز الكامل المكون من 6 أرقام",
          success: "تم التحقق من الرمز بنجاح!",
          error: "الرمز غير صالح أو منتهي الصلاحية. حاول مرة أخرى.",
          resent: "تم إرسال رمز جديد!",
          resentError: "خطأ أثناء إعادة إرسال الرمز."
        }
      },
      resetPassword: {
        title: "إنشاء كلمة مرور جديدة",
        subtitleLine1: "اختر كلمة مرور آمنة من أجل",
        subtitleLine2: "حماية حسابك.",
        newPassword: "كلمة المرور الجديدة",
        confirmPassword: "تأكيد كلمة المرور",
        passwordPlaceholder: "أدخل كلمة المرور الجديدة",
        confirmPlaceholder: "أعد كتابة كلمة المرور الجديدة",
        minHint: "6 أحرف على الأقل",
        submitting: "جارٍ الحفظ...",
        submit: "إعادة تعيين كلمة المرور",
        successTitle: "تمت إعادة تعيين كلمة المرور بنجاح!",
        successSubtitle: "جارٍ التحويل إلى تسجيل الدخول...",
        toasts: {
          minLength: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
          mismatch: "كلمتا المرور غير متطابقتين",
          success: "تمت إعادة تعيين كلمة المرور بنجاح!",
          error: "خطأ أثناء إعادة تعيين كلمة المرور. الرمز غير صالح أو منتهي الصلاحية."
        }
      },
      companies: {
        title: "تسجيل الشركة",
        form: {
          name: "اسم الشركة",
          plan: "الخطة",
          token: "الرمز المميز",
          submit: "تسجيل",
          success: "تم إنشاء الشركة بنجاح!",
        },
        confirmationModal: {
          deleteTitle: "حذف الشركة",
          deleteMessage: "هل أنت متأكد أنك تريد حذف هذه الشركة؟ ستفقد جميع البيانات المرتبطة. لا يمكن التراجع عن هذا الإجراء.",
        },
      },
      auth: {
        toasts: {
          success: "تم تسجيل الدخول بنجاح!",
        },
        dueDate: {
          expiration: "ينتهي اشتراكك في",
          days: "أيام!",
          day: "يوم!",
          expirationToday: "ينتهي اشتراكك اليوم!",
          warning: "ينتهي اشتراكك خلال {{days}} {{unit}}",
          expired: "انتهى اشتراكك في {{date}}. تواصل مع الدعم لمزيد من المعلومات!",
        },
        token: "الرمز المميز",
      },
      dashboard: {
        subtitle: "نظرة عامة على مؤشرات الخدمة",
        fetchError: "خطأ في تحميل بيانات لوحة التحكم",
        hideFilters: "إخفاء المرشحات",
        filters: "المرشحات",
        filter: "تصفية ",
        npsTitle: "استبيان الرضا (NPS)",
        calls: "المحادثات",
        analytics: {
          title: "التحليلات",
          ticketVolume: "حجم التذاكر",
          lastDays: "آخر {{days}} أيام",
          noData: "لا توجد بيانات",
          ticketStatus: "حالة التذاكر",
          distributionByStatus: "التوزيع حسب الحالة",
          noTickets: "لا توجد تذاكر",
          conversationMetrics: "مقاييس المحادثات",
          activeContacts: "جهات الاتصال النشطة",
          ticketsPerContact: "تذاكر/جهة اتصال",
          days: "أيام",
          ratingRate: "معدل التقييم",
          hourlyActivity: "النشاط بالساعة",
          less: "أقل",
          more: "أكثر",
          topContacts: "أفضل جهات الاتصال",
        },
        tabs: {
          indicators: "المؤشرات",
          assessments: "NPS",
          attendants: "المشغلين",
        },
        charts: {
          perDay: {
            title: "المحادثات اليوم: ",
          },
        },
        cards: {
          inAttendance: "في المحادثة",
          waiting: "في الانتظار",
          activeAttendants: "المشغلين النشطين",
          finalized: "منتهية",
          newContacts: "جهات اتصال جديدة",
          totalReceivedMessages: "الرسائل المستلمة",
          totalSentMessages: "الرسائل المرسلة",
          averageServiceTime: "متوسط وقت المحادثة",
          averageWaitingTime: "متوسط وقت الانتظار",
          status: "الحالة (الحالية)",
          activeTickets: "المحادثات النشطة",
          passiveTickets: "المحادثات غير النشطة",
          groups: "المجموعات",
        },
        users: {
          name: "الاسم",
          numberAppointments: "عدد المحادثات",
          statusNow: "الحالية",
          totalCallsUser: "إجمالي المحادثات لكل مستخدم",
          totalAttendances: "إجمالي المحادثات",
        },
        date: {
          initialDate: "التاريخ الأولي",
          finalDate: "التاريخ النهائي",
        },
        licence: {
          available: "متاح حتى",
        },
        assessments: {
          totalCalls: "إجمالي المحادثات",
          callsWaitRating: "محادثات تنتظر التقييم",
          callsWithoutRating: "محادثات بدون تقييم",
          ratedCalls: "محادثات مقيمة",
          evaluationIndex: "مؤشر التقييم",
          score: "النتيجة",
          prosecutors: "الداعمين",
          neutral: "المحايدين",
          detractors: "المنتقدين",
        },
      },
      reports: {
        title: "تقارير المحادثات",
        subtitle: "عرض وتصدير بيانات المحادثات",
        startDate: "التاريخ الأولي",
        endDate: "التاريخ النهائي",
        protocol: "رقم البروتوكول",
        protocolPlaceholder: "مثال: 20260526000123",
        serviceProtocol: "بروتوكول المحادثة",
        copyProtocol: "نسخ البروتوكول",
        searchPlaceholder: "البحث...",
        saleValue: "قيمة البيع",
        noSaleReason: "سبب عدم البيع",
        closedWithSale: "تم الإغلاق مع بيع",
        yes: "نعم",
        no: "لا",
        ticketLogs: "سجلات المحادثة",
        accessTicket: "فتح المحادثة",
        operator: "المشغل",
        period: "الفترة",
        until: "حتى",
        date: "التاريخ",
        reportTitle: "التقارير",
        calls: "المحادثات",
        search: "الاستطلاعات",
        durationCalls: "مدة المحادثات",
        grupoSessions: "محادثات المجموعات",
        groupTicketsReports: {
          timezone: "Asia/Riyadh",
          msgToast: "جاري إنشاء التقرير المضغوط، يرجى الانتظار.",
          errorToast: "خطأ في إنشاء التقرير",
          back: "العودة",
          groupServiceReport: "تقرير محادثات المجموعات",
          loading: "جاري التحميل...",
          contact: "جهة الاتصال",
          dateOpen: "تاريخ الفتح",
          dateLastUpdated: "تاريخ آخر تحديث",
          agent: "من قام بالمحادثة",
          agentClosed: "من أغلق المحادثة",
          waitingAssistance: "في انتظار المحادثة",
          process: "في المحادثة",
        },
        researchReports: {
          response: "إجابة",
          active: "(نشط)",
          inactive: "(غير نشط)",
          quantity: "الكمية",
          percentage: "نسبة مئوية",
          title: "تقرير الاستطلاعات المنجزة",
          activeSearch: "بحث نشط",
          inactiveSearch: "بحث غير نشط",
        },
        ticketDurationDetail: {
          msgToast: "جاري إنشاء التقرير المضغوط، يرجى الانتظار.",
          title: "تقرير مدة المحادثة",
          startService: "بداية المحادثة",
          lastUpdated: "آخر تحديث",
          lastAgent: "آخر مشغل",
          durationFinished: "المدة بعد الانتهاء",
        },
        ticketDuration: {
          title: "تقرير مدة المحادثات",
          contact: "جهة الاتصال",
          open: "مفتوحة",
          pending: "معلقة",
          finished: "منتهية",
          durationFinished: "مدة المنتهية",
          durationAfterFinished: "المدة بعد الانتهاء",
          actions: "الإجراءات",
        },
        ticketReports: {
          msgToast: "جاري إنشاء التقرير المضغوط، يرجى الانتظار.",
          title: "تقرير المحادثات",
        },
        exportExcel: {
          title: "تقارير المحادثات",
          startDate: "التاريخ الأولي",
          endDate: "التاريخ النهائي",
          notInformed: "غير محدد",
          columns: {
            id: "المعرف",
            connection: "الاتصال",
            contact: "جهة الاتصال",
            user: "المستخدم",
            queue: "الطابور",
            status: "الحالة",
            lastMessage: "آخر رسالة",
            openDate: "تاريخ الفتح",
            openTime: "وقت الفتح",
            closeDate: "تاريخ الإغلاق",
            closeTime: "وقت الإغلاق",
            supportTime: "وقت المحادثة",
            nps: "NPS",
          },
        },
        pdf: {
          title: "قائمة المحادثات المنجزة",
          exportTitle: "قائمة محادثات المجموعات المنجزة",
        },
        table: {
          id: "المحادثة",
          user: "المستخدم",
          dateOpen: "تاريخ الفتح",
          dateClose: "تاريخ الإغلاق",
          NPS: "NPS",
          status: "الحالة",
          whatsapp: "الاتصال",
          queue: "الطابور",
          actions: "الإجراءات",
          lastMessage: "آخر رسالة",
          contact: "العميل",
          supportTime: "وقت المحادثة",
        },
        buttons: {
          filter: "تطبيق المرشح",
          onlyRated: "المقيمة فقط",
        },
      },
      todo: {
        newTask: "مهمة جديدة",
        add: "إضافة",
        task: "المهام",
      },
      contactImportWpModal: {
        title: "تصدير جهات الاتصال إلى إكسل",
        buttons: {
          downloadModel: "تحميل نموذج إكسل للاستيراد",
          closed: "إغلاق",
          import: "اختر ملف إكسل لاستيراد جهات الاتصال",
        },
      },
      connections: {
        default: "افتراضي",
        shareLink: "رابط المشاركة",
        copy: "نسخ",
        linkCopied: "تم نسخ الرابط!",
        stats: { last7days: "آخر 7 أيام", sent: "المرسلة", received: "المستلمة", noData: "لا توجد رسائل في هذه الفترة" },
        title: "الاتصالات",
        waitConnection: "انتظر... سيتم إعادة تشغيل اتصالاتك!",
        newConnection: "اتصال جديد",
        restartConnections: "إعادة تشغيل الاتصالات",
        callSupport: "الاتصال بالدعم",
        searchPlaceholder: "ابحث بالاسم أو المعرف أو الرقم...",
        status: "الحالة",
        statusAll: "الكل",
        statusConnected: "متصل",
        statusDisconnected: "غير متصل",
        statusOpening: "جاري الاتصال",
        statusQrcode: "رمز QR",
        statusPairing: "الاقتران",
        clearFilters: "مسح المرشحات",
        newConnection: "اتصال جديد",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " اربط قنوات الخدمة الخاصة بك لاستقبال الرسائل وبدء المحادثات مع عملائك.",
        client: "العميل",
        connectedConnections: " الاتصالات المتصلة ",
        disconnectedConnections: "الاتصالات المنقطعة ",
        totalConnections: " إجمالي الاتصالات",
        total: "الإجمالي",
        connections: "اتصالات:",
        integrity: "السلامة",
        stable: "مستقر",
        unstable: "غير مستقر",

        toasts: {
          deleted: "تم حذف الاتصال بنجاح!",
          closedimported: "نحن نغلق المحادثات المستوردة، يرجى الانتظار قليلاً",
        },
        confirmationModal: {
          closedImportedTitle: "إغلاق المحادثات المستوردة",
          closedImportedMessage: "إذا أكدت سيتم إغلاق جميع المحادثات المستوردة",
          deleteTitle: "حذف",
          deleteMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
          disconnectTitle: "قطع الاتصال",
          disconnectMessage: "هل أنت متأكد؟ ستحتاج إلى قراءة رمز QR مرة أخرى.",
        },
        toasts: {
          reconnecting: "جارٍ إعادة الاتصال... يرجى الانتظار بضع ثوانٍ.",
          activate: "تفعيل الوكيل",
          deactivate: "تعطيل الوكيل",
          activated: "تم تفعيل الوكيل",
          deactivated: "تم تعطيل الوكيل",
        },
        buttons: {
          add: "إضافة اتصال",
          disconnect: "قطع الاتصال",
          tryAgain: "حاول مرة أخرى",
          qrcode: "رمز QR",
          newQr: "رمز QR جديد",
          closedImported: "إغلاق جميع المحادثات المستوردة",
          preparing: "تجهيز الرسائل للاستيراد",
          importing: "استيراد رسائل الواتس اب",
          newQr: "رمز QR جديد",
          processed: "تمت المعالجة",
          in: "من",
          connecting: "جاري الاتصال",
          importHistory: "استيراد الرسائل السابقة",
          importingHistory: "جارٍ استيراد الرسائل...",
          importHistorySuccess: "بدأ الاستيراد — ستظهر المحادثات القديمة تدريجيًا.",
          importHistoryPeriodTitle: "فترة الاستيراد",
          importHistoryPeriodHint: "اختر فترة الرسائل المراد استيرادها (اختياري — اتركه فارغًا لاستيراد الدفعة الأخيرة كاملة).",
        },
        typography: {
          processed: "تمت المعالجة",
          in: "من",
          date: "تاريخ الرسالة",
        },
        toolTips: {
          disconnected: {
            title: "فشل في بدء جلسة الواتس اب",
            content:
              "تأكد من أن هاتفك متصل بالإنترنت وحاول مرة أخرى، أو اطلب رمز QR جديد",
          },
          qrcode: {
            title: "في انتظار قراءة رمز QR",
            content: "انقر على زر 'رمز QR' واقرأ رمز QR بهاتفك لبدء الجلسة",
          },
          connected: {
            title: "تم تأسيس الاتصال!",
          },
          timeout: {
            title: "فُقد الاتصال مع الهاتف",
            content:
              "تأكد من أن هاتفك متصل بالإنترنت والواتس اب مفتوح، أو انقر على زر 'قطع الاتصال' للحصول على رمز QR جديد",
          },
        },
        table: {
          name: "الاسم",
          status: "الحالة",
          lastUpdate: "آخر تحديث",
          default: "افتراضي",
          actions: "الإجراءات",
          session: "الجلسة",
          number: "رقم الواتس اب",
          color: "اللون",
          receiveComments: "استقبال التعليقات",
        },
        receiveComments: {
          label: "استقبال التعليقات",
          enabled: "استقبال التعليقات مفعل",
          disabled: "استقبال التعليقات معطل",
          tooltip: {
            enabled: "التعليقات تُستقبل. انقر للتعطيل.",
            disabled: "التعليقات لا تُستقبل. انقر للتفعيل.",
          },
        },
        transfer: {
          title: "نقل التذاكر",
          description: "حدد اتصال المصدر والوجهة. سيتم نقل جميع التذاكر النشطة.",
          source: "المصدر",
          target: "الوجهة",
          cancel: "إلغاء",
          transfer: "نقل",
          transferTickets: "نقل التذاكر",
          transferring: "جاري نقل التذاكر",
          of: "من",
          waitMessage: "يرجى الانتظار أثناء نقل التذاكر...",
          selectConnections: "حدد اتصالات المصدر والوجهة",
          differentConnections: "يجب أن تكون اتصالات المصدر والوجهة مختلفة",
          success: "تم نقل التذاكر بنجاح! {{count}} تذكرة تم نقلها.",
        },
        preDelete: {
          title: "قبل الحذف",
          message: "هل قمت بنقل التذاكر من هذا الاتصال إلى آخر؟ إذا لم تفعل، نوصي بالنقل قبل الحذف.",
          notYet: "لا بعد",
          yesTransferred: "نعم، تم النقل",
        },
        importMessages: {
          title: "استيراد الرسائل",
          button: "استيراد الرسائل",
          connection: "الاتصال",
          selectConnection: "اختر اتصال Z-API",
          startDate: "تاريخ البدء",
          endDate: "تاريخ الانتهاء",
          messageType: "نوع الرسالة",
          all: "الكل",
          individual: "فردي",
          group: "مجموعة",
          ticketStatus: "حالة التذكرة",
          open: "مفتوح",
          pending: "قيد الانتظار",
          closed: "مغلق",
          queue: "قائمة الانتظار",
          noQueue: "بدون قائمة انتظار",
          import: "استيراد",
          cancel: "إلغاء",
          importing: "جاري استيراد الرسائل...",
          importingDescription: "يرجى الانتظار أثناء استيراد الرسائل. قد يستغرق ذلك بضع دقائق.",
          success: "اكتمل الاستيراد! {{messages}} رسائل، {{tickets}} تذاكر، {{contacts}} جهات اتصال مستوردة.",
          noZApiConnections: "لم يتم العثور على اتصالات Z-API.",
          noConnections: "لم يتم العثور على اتصالات واتساب متصلة.",
          errorMissingFields: "يرجى ملء جميع الحقول المطلوبة.",
        },
        nativeImport: {
          importing: "جاري استيراد رسائل واتساب...",
          finishing: "جاري إنهاء الاستيراد...",
          processed: "تمت المعالجة",
          messages: "رسائل",
          currentDate: "التاريخ الحالي",
          errors: "أخطاء",
          cancelled: "تم إلغاء الاستيراد",
          cancel: "إلغاء",
        },
        importProgress: {
          done: "اكتمل الاستيراد!",
          cancelled: "تم إلغاء الاستيراد",
          importing: "جاري استيراد الرسائل...",
          starting: "جاري الاتصال...",
          scanning: "جاري البحث عن المحادثات...",
          processingChat: "معالجة المحادثة {{current}} من {{total}}",
          allProcessed: "تمت معالجة جميع المحادثات",
          cancelledAt: "توقف عند {{current}} من {{total}} محادثة",
          initializing: "جاري البدء...",
          progress: "التقدم",
          chats: "محادثات",
          messagesLabel: "الرسائل",
          tickets: "التذاكر",
          contacts: "جهات الاتصال",
          errorsLabel: "الأخطاء",
          cancelImport: "إلغاء الاستيراد",
          close: "إغلاق",
        },
        officialLabel: "رسمي",
        badges: {
          pairingCode: "متصل عبر رمز الاقتران",
          qrCode: "متصل عبر رمز QR",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "محادثة موجودة",
        },
        form: {
          message: "جهة الاتصال هذه في محادثة بالفعل:",
          user: "المشغل",
          queue: "الطابور",
          messageWait:
            "جهة الاتصال هذه تنتظر المحادثة بالفعل. اطلع على تبويب الانتظار!",
        },
        close: "إغلاق",
      },
      showTicketLogModal: {
        title: {
          header: "السجلات",
        },
        options: {
          create: "تم إنشاء المحادثة.",
          chatBot: "تم بدء البوت.",
          queue: " - تم تحديد الطابور.",
          open: " بدأ المحادثة.",
          access: "دخل إلى المحادثة.",
          transfered: "نقل المحادثة.",
          receivedTransfer: "استلم المحادثة المنقولة.",
          pending: "أعاد إلى الطابور.",
          closed: "أغلق المحادثة",
          reopen: "أعاد فتح المحادثة",
          redirect: "- تم التوجيه",
          clientClosed: "العميل أغلق المحادثة",
        },
      },
      whatsappModal: {
        title: {
          add: "إضافة اتصال",
          edit: "تعديل الاتصال",
        },
        tabs: {
          general: "عام",
          messages: "الرسائل",
          assessments: "NPS",
          integrations: "التكاملات",
          schedules: "ساعات العمل",
        },
        form: {
          importOldMessagesEnable: "استيراد رسائل الجهاز",
          importOldMessages: "تاريخ بداية الاستيراد",
          importRecentMessages: "تاريخ نهاية الاستيراد",
          importOldMessagesGroups: "استيراد رسائل المجموعات",
          closedTicketsPostImported: "إنهاء المحادثات بعد الاستيراد",
          name: "الاسم",
          queueRedirection: "إعادة توجيه الطابور",
          queueRedirectionDesc:
            "اختر طابوراً لجهات الاتصال التي لا تملك طابوراً ليتم توجيهها",
          default: "افتراضي",
          group: "السماح بالمجموعات",
          timeSendQueue: "الوقت بالدقائق لإعادة التوجيه للطابور",
          importAlert:
            "تنبيه: عند الحفظ، سيتم إنهاء اتصالك، وستحتاج لقراءة رمز QR مرة أخرى لاستيراد الرسائل",
          groupAsTicket: "التعامل مع المجموعات كمحادثة",
          timeCreateNewTicket: "إنشاء محادثة جديدة في x دقائق",
          maxUseBotQueues: "إرسال البوت x مرات",
          maxUseInactiveTime: "إرسال تدفق عدم النشاط x مرات",
          timeUseBotQueues: "إرسال البوت في x دقائق",
          timeToReturnQueue: "الوقت للعودة للطابور بالدقائق",
          timeAwaitActiveFlow: "الوقت لانتظار تفعيل التدفق",
          expiresTicket: "إنهاء المحادثات المفتوحة بعد x دقائق",
          expiresTicketNPS: "إنهاء المحادثات المنتظرة للتقييم بعد x دقائق",
          maxUseBotQueuesNPS: "الحد الأقصى لعدد مرات إرسال التقييم",
          closeLastMessageOptions1: "من المشغل/العميل",
          closeLastMessageOptions2: "من المشغل",
          outOfHoursMessage: "رسالة خارج ساعات العمل",
          greetingMessage: "رسالة الترحيب",
          complationMessage: "رسالة الإنهاء",
          lgpdLinkPrivacy: "رابط سياسة الخصوصية",
          lgpdMessage: "رسالة ترحيب LGPD",
          lgpdDeletedMessages: "إخفاء الرسالة المحذوفة من جهة الاتصال",
          lgpdSendMessage: "طلب تأكيد جهة الاتصال دائماً",
          ratingMessage: "رسالة التقييم - المقياس يجب أن يكون من 0 إلى 10",
          token: "رمز للتكامل الخارجي",
          sendIdQueue: "الطابور",
          inactiveMessage: "رسالة عدم النشاط",
          timeInactiveMessage: "الوقت بالدقائق لإرسال تنبيه عدم النشاط",
          flowInactiveTime: "الوقت بالدقائق لإرسال تدفق عدم النشاط",
          whenExpiresTicket: "إنهاء المحادثات المفتوحة عندما تكون آخر رسالة من",
          expiresInactiveMessage: "رسالة الإنهاء بسبب عدم النشاط",
          prompt: "الموجه",
          collectiveVacationEnd: "التاريخ النهائي",
          collectiveVacationStart: "التاريخ الأولي",
          collectiveVacationMessage: "رسالة الإجازة الجماعية",
          queueIdImportMessages: "طابور لاستيراد الرسائل",
          isOficial: "رسمي",
          phone_number_id: "معرف رقم الهاتف",
          waba_id: "معرف Waba",
          send_token: "رمز الإرسال",
          business_id: "معرف العمل",
          phone_number: "رقم الهاتف",
          triggerIntegrationOnClose: "تفعيل التكامل عند إغلاق المحادثة",
          enableIntegration: "تفعيل التكامل",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        menuItem: {
          enabled: "مفعل",
          disabled: "معطل",
          minutes: "دقائق",
        },
        success: "تم حفظ الاتصال بنجاح.",
        errorSendQueue:
          "تم تحديد وقت لإعادة توجيه الطابور، لكن لم يتم اختيار طابور للتوجيه. يجب ملء الحقلين معاً",
        errorExpiresNPS: "مطلوب تحديد وقت للتقييم عند استخدام NPS.",
        errorRatingMessage: "مطلوب تحديد رسالة تقييم عند استخدام NPS.",
      },
      qrCode: {
        message: "اقرأ رمز QR لبدء الجلسة",
      },
      qrcodeModal: {
        title: "الاتصال بـ WhatsApp",
        subtitle: "امسح رمز QR بهاتفك لبدء الجلسة",
        connected: "تم الاتصال بنجاح!",
        generating: "جارٍ إنشاء رمز QR جديد...",
        step1: "افتح <strong>WhatsApp</strong> على هاتفك",
        step2Options: "اضغط على <strong>المزيد من الخيارات ⋮</strong> أو <strong>الإعدادات ⚙</strong> واختر <strong>الأجهزة المرتبطة</strong>",
        step3: "اضغط على <strong>ربط جهاز</strong> ووجّه الكاميرا نحو رمز QR هذا",
        refreshCountdown: "يتم تحديث رمز QR خلال {{seconds}} ثانية",
        refreshing: "جارٍ تحديث رمز QR...",
      },
      contacts: {
        title: "جهات الاتصال",
        toasts: {
          deleted: "تم حذف جهة الاتصال بنجاح!",
        },
        searchPlaceholder: "البحث...",
        conversationFlows: "التدفقات",
        addFlow: "إضافة تدفق",
        editFlow: "تعديل التدفق ",
        confirmationModal: {
          deleteTitle: "حذف ",
          importTitlte: "استيراد جهات الاتصال",
          exportContact: "تصدير جهات الاتصال",
          deleteMessage:
            "هل أنت متأكد من حذف جهة الاتصال هذه؟ جميع المحادثات المرتبطة ستفقد.",
          blockContact: "هل أنت متأكد من حظر جهة الاتصال هذه؟",
          unblockContact: "هل أنت متأكد من إلغاء حظر جهة الاتصال هذه؟",
          importMessage: "هل تريد استيراد جميع جهات الاتصال من الهاتف؟",
          importChat: "استيراد المحادثات",
          wantImport: "هل تريد استيراد جميع المحادثات من الهاتف؟",
        },
        buttons: {
          import: "استيراد جهات الاتصال",
          add: "إضافة جهة اتصال",
          export: "تصدير جهة الاتصال",
        },
        table: {
          name: "الاسم",
          whatsapp: "الاتصال",
          email: "البريد الإلكتروني",
          actions: "الإجراءات",
          lastMessage: "آخر رسالة",
          wallet: "المحفظة",
        },
        menu: {
          importYourPhone: "استيراد من الجهاز الافتراضي",
          importToExcel: "استيراد / تصدير من إكسل",
          importexport: "استيراد / تصدير",
        },
      },
      forwardMessage: {
        text: "معاد التوجيه",
      },
      forwardMessageModal: {
        title: "إعادة توجيه الرسالة",
        buttons: {
          ok: "إعادة توجيه",
        },
      },
      promptModal: {
        form: {
          name: "الاسم",
          prompt: "الموجه",
          voice: "الصوت",
          max_tokens: "الحد الأقصى للرموز في الإجابة",
          temperature: "درجة الحرارة",
          apikey: "مفتاح API",
          max_messages: "الحد الأقصى للرسائل في التاريخ",
          voiceKey: "مفتاح API الصوت",
          voiceRegion: "منطقة الصوت",
        },
        success: "تم حفظ الوكيل بنجاح!",
        title: {
          add: "إنشاء وكيل",
          edit: "تعديل الوكيل",
        },
        subtitle: "تكوين معلمات وكيل الذكاء الاصطناعي",
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        tabs: {
          basic: "أساسي",
          behavior: "السلوك",
          advanced: "متقدم",
          knowledge: "📚 المعرفة",
          test: "🧪 اختبار",
        },
        basic: {
          agentName: "اسم الوكيل *",
          agentNamePlaceholder: "مثال: مساعد المبيعات",
          function: "الوظيفة",
          voiceTone: "نبرة الصوت",
          aiModel: "نموذج الذكاء الاصطناعي",
          apiKey: "مفتاح API *",
          responseLanguages: "🌐 لغات الاستجابة",
          responseLanguagesHelp: "حدد اللغات التي يمكن للذكاء الاصطناعي الاستجابة بها. استخدم \"تلقائي\" للرد بلغة العميل تلقائياً.",
          personality: "الشخصية",
          personalityPlaceholder: "صف شخصية الوكيل ومعارفه ومهاراته",
          personalityHelp: "صف شخصية الوكيل ومعارفه ومهاراته",
          activeAgent: "وكيل نشط",
        },
        behavior: {
          greetingMessage: "رسالة الترحيب (اختياري)",
          greetingPlaceholder: "مرحباً! كيف يمكنني مساعدتك؟",
          greetingHelp: "رسالة ترسل تلقائياً عندما يبدأ الوكيل محادثة",
          responseRules: "قواعد الاستجابة",
          responseRulesPlaceholder: "ضع قواعد محددة يجب على الوكيل اتباعها",
          responseRulesHelp: "ضع قواعد محددة يجب على الوكيل اتباعها",
          allowTransfer: "السماح بالتحويل إلى موظف",
          transferKeywords: "كلمات مفتاحية للتحويل",
          transferKeywordsPlaceholder: "موظف، خروج، التحدث مع إنسان، إنسان",
          transferKeywordsHelp: "افصل بفاصلة. عند اكتشافها، ينقل الذكاء الاصطناعي إلى موظف",
          transferKeywordsDefault: "موظف, خروج, تحدث مع إنسان, إنسان",
          transferMessage: "رسالة عند التحويل",
          transferMessagePlaceholder: "عذراً، لا أملك معلومات حول هذا الموضوع. سأحولك إلى موظف.",
          transferMessageDefault: "عذراً، لا أملك معلومات حول هذا الموضوع. سأحولك إلى موظف.",
          insertVariable: "إدراج متغير:",
          vars: {
            name: "الاسم",
            firstName: "الاسم الأول",
            attendant: "الموظف",
            queue: "قائمة الانتظار",
            connection: "الاتصال",
            protocol: "البروتوكول",
            hour: "الوقت",
            datetime: "التاريخ والوقت",
            company: "الشركة",
          },
          transferTargetTitle: "وجهة التحويل",
          transferQueueLabel: "قائمة الانتظار",
          transferUserLabel: "الموظف (اختياري)",
          useAgentDefaultQueue: "— استخدام قائمة الانتظار الافتراضية للوكيل —",
          anyUserOfQueue: "— أي موظف من القائمة —",
          whereTicket: "أين يجب أن تظهر التذكرة",
          statusPending: "قيد الانتظار",
          statusOpen: "قيد المعالجة (لدى الموظف)",
          statusOpenHelp: "\"قيد المعالجة\" متاح فقط عند تحديد موظف — تنتقل التذكرة مباشرة إلى قائمته.",
        },
        advanced: {
          responseDelay: "تأخير الاستجابة",
          responseDelayHelp: "وقت الانتظار قبل إرسال الرد (يحاكي الكتابة)",
          charLimit: "حد الأحرف",
          charLimitHelp: "الحد الأقصى لحجم رد الوكيل",
          humanize: "✨ أنسنة المحادثة",
          humanizeHelp: "يتناوب بين الاسم الأول والاسم الكامل وبدون اسم ليبدو طبيعياً",
          audioFeatures: "🔊 ميزات الصوت",
          transcribeAudio: "نسخ الصوت المستلم",
          transcribeAudioHelp: "يحول رسائل الصوت إلى نص ليفهمها الوكيل",
          responseMode: "وضع الاستجابة",
          agentVoice: "صوت الوكيل",
          sendAsPTT: "إرسال كصوت مسجل (PTT)",
          sendAsPTTHelp: "يظهر الصوت كما لو سُجل فوراً، مثل رسالة صوتية في واتساب",
          temperatureHelp: "0 = دقيق، 2 = إبداعي",
          maxTokens: "الحد الأقصى للرموز",
          maxMessages: "سجل الرسائل",
          maxMessagesHelp: "الحد الأقصى لعدد الرسائل السابقة المُرسلة إلى الوكيل كسياق/سجل للمحادثة. كلما زاد العدد، زادت ذاكرة الوكيل ولكن يستهلك المزيد من الرموز.",
        },
        knowledge: {
          title: "قاعدة المعرفة",
          subtitle: "أضف نصوصاً وروابط وملفات PDF وصوتيات وفيديوهات ليستخدمها الوكيل كمرجع",
          upload: "رفع",
          add: "إضافة",
          saveFirst: "احفظ الوكيل أولاً لإضافة عناصر إلى قاعدة المعرفة",
          newItem: "عنصر جديد",
          nameLabel: "الاسم",
          textType: "📋 نص",
          urlType: "🔗 رابط",
          urlLabel: "رابط الموقع",
          textLabel: "محتوى نصي",
          urlPlaceholder: "https://example.com/page",
          textPlaceholder: "الصق النص المرجعي هنا...",
          cancelBtn: "إلغاء",
          saveBtn: "حفظ",
          empty: "لا توجد عناصر في قاعدة المعرفة",
          emptyHelp: "أضف نصوصاً أو روابط أو ارفع ملفات",
          noContent: "بدون محتوى",
          fillNameContent: "املأ الاسم والمحتوى",
          addedSuccess: "تم إضافة العنصر إلى قاعدة المعرفة!",
          uploadSuccess: "تم رفع الملف بنجاح!",
          removeConfirm: "هل أنت متأكد أنك تريد إزالة هذا العنصر؟",
          removeSuccess: "تم إزالة العنصر!",
        },
        test: {
          model: "النموذج",
          usingApiKey: "استخدام مفتاح API والموجه من علامة التبويب \"أساسي\"",
          clear: "مسح",
          emptyChat: "💬 أرسل رسالة لاختبار وكيل الذكاء الاصطناعي",
          placeholder: "اكتب رسالة الاختبار...",
          fillApiKey: "املأ مفتاح API قبل الاختبار",
          fillPrompt: "املأ الشخصية/الموجه قبل الاختبار",
          fillApiKeyVoice: "املأ مفتاح API في علامة التبويب أساسي لسماع معاينة الصوت",
          voiceError: "خطأ في إنشاء معاينة الصوت. تحقق من مفتاح API.",
        },
        tools: {
          title: "قدرات الوكيل",
          subtitle: "قم بتمكين الأدوات حتى يتمكن الوكيل من تنفيذ إجراءات حقيقية بدلاً من مجرد الدردشة.",
          openTicket: {
            title: "فتح محادثة",
            desc: "يغيّر حالة المحادثة إلى مفتوحة ويوقف وكيل الذكاء الاصطناعي مؤقتًا.",
            config: {
              title: "🎧 الإعدادات — فتح المحادثة",
              beforeLabel: "رسالة للعميل قبل التحويل (اختياري)",
              beforePlaceholder: "مثال: سأحولك إلى موظف بشري. لحظة من فضلك.",
              queueLabel: "الطابور الافتراضي للتحويل",
              queueNone: "— لا شيء (تحديد حسب المحادثة) —",
              userLabel: "الموظف الافتراضي (اختياري)",
              userAny: "— أي موظف من الطابور —",
              hint: "إذا تم تعيين الطابور، سيفتح الوكيل المحادثة فيه مباشرة (وفي الموظف، إذا تم تحديده) عند تشغيل الأداة.",
              pauseAi: "إيقاف وكيل الذكاء الاصطناعي بعد فتح المحادثة",
            },
          },
          notifyHuman: {
            title: "إشعار بشري",
            desc: "يرسل تنبيهًا عبر واتساب إلى الأرقام المسؤولة المُعدّة.",
            config: {
              numbersTitle: "📱 أرقام واتساب للمسؤولين",
              phonePlaceholder: "+966 5X XXX XXXX",
              removePhone: "إزالة هذا الرقم",
              addNumber: "+ إضافة رقم آخر",
              hint: "سيرسل الوكيل التنبيه إلى <b>جميع</b> الأرقام المهيأة. أدخل مع رمز الدولة + المنطقة؛ القناع مرئي فقط — نحفظ الأرقام فقط.",
            },
          },
          httpRequest: {
            title: "طلب HTTP",
            desc: "يسمح للوكيل باستدعاء واجهات API خارجية (GET وPOST وغيرها) للتكامل مع أنظمة أخرى.",
            config: {
              title: "🛰️ الإعدادات — طلب HTTP",
              domainsLabel: "النطاقات المسموح بها (واحد لكل سطر) — اتركه فارغًا للسماح بالجميع",
              headersLabel: "الرؤوس الافتراضية (JSON) — مثال: المصادقة",
              invalidHeaders: "رؤوس افتراضية غير صالحة. استخدم JSON، مثال: { \"Authorization\": \"Bearer xxx\" }",
            },
          },
          tags: {
            title: "العلامات",
            desc: "يسمح للوكيل بتطبيق علامات على المحادثة بناءً على المحتوى.",
            config: {
              title: "🏷️ العلامات التي يمكن للوكيل تطبيقها",
              hint: "حدد العلامات المسموح بها. إذا لم يتم تحديد أي علامة، يمكن للوكيل استخدام أي علامة.",
              empty: "لا توجد علامات مسجلة.",
            },
          },
          kanban: {
            title: "كانبان",
            desc: "يسمح للوكيل بنقل المحادثة بين أعمدة كانبان.",
            config: {
              title: "🗂️ أعمدة كانبان التي يمكن للوكيل استخدامها",
              hint: "يمكن للوكيل نقل المحادثة إلى أحد الأعمدة المحددة. إذا لم يتم تحديد أي عمود، فسيتم السماح بأي عمود كانبان.",
              empty: "لا يوجد عمود كانبان مسجل. أنشئ علامات مع كانبان نشط في <b>العلامات</b>.",
            },
          },
          workingHours: {
            title: "⏰ مناوبة الوكيل — ساعات العمل",
            subtitle: "أداة تتحكم في وقت رد الوكيل. خارج المناوبة المُعدّة، يتم إيقاف الذكاء الاصطناعي ويتلقى العميل الرسالة المحددة فقط.",
            tooltipTitle: "كيف يعمل",
            tooltipInside: "عند التفعيل، يرد الوكيل فقط على الرسائل <b>ضمن</b> الفترات المُعدّة لكل يوم من أيام الأسبوع (باستخدام المنطقة الزمنية المختارة).",
            tooltipOutside: "<b>خارج المناوبة:</b> الذكاء الاصطناعي <b>لا</b> يعالج الرسالة ولا يستهلك الرموز. يرسل النظام تلقائياً <b>\"رسالة خارج المناوبة\"</b> ويتجاهل بقية المحادثة حتى عودة الدوام.",
            tooltipLanguage: "إذا كان العميل يتحدث لغة أخرى، تُترجم الرسالة تلقائياً.",
            tooltipMultiple: "يمكنك تحديد <b>عدة فترات في اليوم</b> (مثل 08:00–12:00 و14:00–18:00) وترك أيام <b>بدون فترات</b> لإبقائها مغلقة.",
            timezone: "المنطقة الزمنية",
            outOfMessage: "رسالة خارج المناوبة",
            closed: "مغلق",
            to: "إلى",
            addInterval: "+ إضافة فترة",
            days: { mon: "الإثنين", tue: "الثلاثاء", wed: "الأربعاء", thu: "الخميس", fri: "الجمعة", sat: "السبت", sun: "الأحد" },
          },
        },
        functions: {
          geral: "عام",
          geralDesc: "مساعد متعدد الأغراض",
          vendas: "مبيعات",
          vendasDesc: "مركز على التحويل",
          suporte: "دعم",
          suporteDesc: "دعم تقني",
          agendamento: "جدولة",
          agendamentoDesc: "حجز مواعيد",
          financeiro: "مالي",
          financeiroDesc: "فواتير ومدفوعات",
        },
        voiceTones: {
          amigavel: "😊 ودود",
          profissional: "💼 مهني",
          formal: "🎩 رسمي",
          casual: "😎 عادي",
          empatico: "🤗 متعاطف",
          tecnico: "🔧 تقني",
        },
        responseModes: {
          text: "نص فقط",
          textDesc: "يرد بالنص فقط",
          audio: "صوت فقط",
          audioDesc: "يرد بالصوت فقط",
          both: "نص وصوت",
          bothDesc: "يرد بكليهما",
        },
        agentVoices: {
          alloyDesc: "محايد ومتوازن",
          ashDesc: "ذكوري، ناعم",
          balladDesc: "أنثوي، معبر",
          coralDesc: "أنثوي، واضح",
          echoDesc: "ذكوري، عميق",
          fableDesc: "ذكوري، بريطاني",
          onyxDesc: "ذكوري، غليظ",
          novaDesc: "أنثوي، حيوي",
          sageDesc: "ذكوري، هادئ",
          shimmerDesc: "أنثوي، رقيق",
        },
        aiModels: {
          gpt4oMiniDesc: "موصى به - توازن بين السرعة والجودة",
          gpt4oDesc: "أكثر ذكاءً وتفصيلاً",
          gpt41MiniDesc: "سريع وفعال",
          gpt41Desc: "أداء عالي",
          gpt41NanoDesc: "فائق السرعة واقتصادي",
          o4MiniDesc: "نموذج تفكير متقدم",
        },
        sectorRequired: "حدد قطاع التحويل",
      },
      prompts: {
        title: "وكيل الذكاء الاصطناعي",
        table: {
          name: "الاسم",
          queue: "القسم/الطابور",
          max_tokens: "الحد الأقصى لرموز الإجابة",
          tokens_used: "الرموز المستخدمة",
          status: "الحالة",
          actions: "الإجراءات",
        },
        metrics: {
          title: "مقاييس استخدام الرموز",
          totalTokens: "إجمالي الرموز",
          inputTokens: "رموز الإدخال",
          outputTokens: "رموز الإخراج",
          estimatedCost: "التكلفة المقدرة (USD)",
          costTooltip: "تقدير مبني على متوسط أسعار GPT-4o-mini. قد يختلف السعر الفعلي.",
          perAgent: "الاستهلاك لكل وكيل",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء!",
        },
        toasts: {
          activate: "تفعيل الوكيل",
          deactivate: "تعطيل الوكيل",
          activated: "تم تفعيل الوكيل",
          deactivated: "تم تعطيل الوكيل",
        },
        buttons: {
          add: "إضافة وكيل",
        },
        inactivity: {
          title: "رسالة عدم النشاط",
          description: "تنبه العميل تلقائيًا إذا تأخر في الرد.",
          timeoutLabel: "مدة عدم النشاط (دقائق)",
          maxRemindersLabel: "الحد الأقصى للتذكيرات",
          messageLabel: "رسالة تنبيه العميل",
          messagePlaceholder: "مثال: مرحبًا! هل ما زلت معنا؟ 😊",
          helper: "تُرسل إذا لم يرد العميل بعد آخر رسالة من الموظف.",
        },
        noPermission: "هذه الشركة لا تملك إذن الوصول إلى هذه الصفحة! نقوم بإعادة توجيهك.",
      },
      contactModal: {
        title: {
          add: "إضافة جهة اتصال",
          edit: "تعديل جهة الاتصال",
        },
        form: {
          mainInfo: "بيانات جهة الاتصال",
          extraInfo: "معلومات إضافية",
          name: "الاسم",
          number: "رقم الواتس اب",
          email: "البريد الإلكتروني",
          extraName: "اسم الحقل",
          extraValue: "القيمة",
          chatBotContact: "تعطيل البوت",
          termsLGDP: "تم قبول شروط LGPD في:",
          whatsapp: "مصدر الاتصال: ",
          assignWallet: "محفظة العميل",
        },
        buttons: {
          addExtraInfo: "إضافة معلومة",
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        success: "تم حفظ جهة الاتصال بنجاح.",
        walletLinked: "تم ربط جهة الاتصال بمحفظتك بنجاح!",
        walletError: "المستخدم لا يملك طوابير مرتبطة",
        saveFirst: "يجب حفظ جهة الاتصال أولاً",
      },
      wallets: {
        title: "محافظ جهات الاتصال",
        searchPlaceholder: "البحث عن جهات الاتصال...",
        filterByUser: "تصفية حسب المستخدم",
        allUsers: "جميع المستخدمين",
        contact: "جهة الاتصال",
        user: "المستخدم",
        queue: "الطابور",
        phone: "الهاتف",
        email: "البريد الإلكتروني",
        actions: "الإجراءات",
        editWallet: "تعديل المحفظة",
        selectUser: "اختيار المستخدم",
        selectQueue: "اختيار الطابور",
        selectUserAndQueue: "اختر مستخدماً وطابوراً",
        cancel: "إلغاء",
        save: "حفظ",
        confirmDeleteTitle: "تأكيد الحذف",
        confirmDeleteMessage:
          "هل أنت متأكد من إزالة جهة الاتصال هذه من المحفظة؟",
        deleteSuccess: "تم إزالة جهة الاتصال من المحفظة بنجاح!",
        updateSuccess: "تم تحديث المحفظة بنجاح!",
        wallet: "المحفظة",
      },
      queueModal: {
        title: {
          queueData: "بيانات الطابور",
          text: "ساعات الخدمة",
          add: "إضافة طابور",
          edit: "تعديل الطابور",
          confirmationDelete: "هل أنت متأكد؟ جميع خيارات التكاملات ستحذف.",
        },
        form: {
          name: "الاسم",
          color: "اللون",
          orderQueue: "ترتيب الطابور (البوت)",
          rotate: "التناوب",
          timeRotate: "وقت التناوب",
          typeRandomMode: "نوع التناوب",
          greetingMessage: "رسالة الترحيب",
          complationMessage: "رسالة الإنهاء",
          outOfHoursMessage: "رسالة خارج ساعات العمل",
          token: "الرمز المميز",
          integrationId: "التكامل",
          fileListId: "قائمة الملفات",
          closeTicket: "إغلاق المحادثة",
          queueType: "نوع القائمة",
          message: "رسالة الإرجاع",
          queue: "طابور النقل",
          integration: "التكامل",
          file: "قائمة الملفات",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        bot: {
          title: "الخيارات",
          toolTipTitle: "أضف خيارات لبناء بوت المحادثة",
          toolTip:
            "إذا كان هناك خيار واحد فقط، سيتم اختياره تلقائياً، مما يجعل البوت يجيب برسالة الخيار ويتابع",
          selectOption: "اختر خياراً",
          text: "النص",
          attendent: "المشغل",
          queue: "الطابور",
          integration: "التكامل",
          file: "الملف",
          aiAgent: "وكيل الذكاء الاصطناعي",
          toolTipMessageTitle: "الرسالة مطلوبة للانتقال للمستوى التالي",
          toolTipMessageContent: "الرسالة مطلوبة للانتقال للمستوى التالي",
          selectUser: "اختر مستخدماً",
          selectQueue: "اختر طابوراً",
          selectIntegration: "اختر تكاملاً",
           selectAiAgent: "اختر وكيل ذكاء اصطناعي",
           selectModel: "نموذج الذكاء الاصطناعي",
           addOptions: "إضافة خيارات",
        },
        serviceHours: {
          dayWeek: "يوم الأسبوع",
          startTimeA: "الوقت الأولي - الدوام أ",
          endTimeA: "الوقت النهائي - الدوام أ",
          startTimeB: "الوقت الأولي - الدوام ب",
          endTimeB: "الوقت النهائي - الدوام ب",
          monday: "الاثنين",
          tuesday: "الثلاثاء",
          wednesday: "الأربعاء",
          thursday: "الخميس",
          friday: "الجمعة",
          saturday: "السبت",
          sunday: "الأحد",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "إضافة مشروع",
          edit: "تعديل المشروع",
        },
        form: {
          id: "المعرف",
          type: "النوع",
          name: "الاسم",
          projectName: "اسم المشروع",
          language: "اللغة",
          jsonContent: "محتوى Json",
          urlN8N: "الرابط",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "الوقت بالدقائق لانتهاء المحادثة",
          typebotKeywordFinish: "كلمة إنهاء المحادثة",
          typebotKeywordRestart: "كلمة إعادة تشغيل التدفق",
          typebotRestartMessage: "رسالة عند إعادة تشغيل المحادثة",
          typebotUnknownMessage: "رسالة الخيار غير الصحيح",
          typebotDelayMessage: "الفاصل الزمني (مللي ثانية) بين الرسائل",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          test: "اختبار البوت",
        },
        messages: {
          testSuccess: "تم اختبار التكامل بنجاح!",
          addSuccess: "تم إضافة التكامل بنجاح.",
          editSuccess: "تم تعديل التكامل بنجاح.",
        },
      },
      asaasBoletoNode: {
        title: "نسخة الفاتورة (Asaas)",
        description: "يطلب CPF/CNPJ ويتحقق منه ويستعلم Asaas ويرسل الفواتير تلقائياً.",
        configure: "تكوين العقدة",
        dialogTitle: "تكوين نسخة فاتورة Asaas",
        tabs: { messages: "الرسائل", boletos: "الفواتير", advanced: "متقدم" },
        buttons: { close: "إغلاق", save: "حفظ" },
        statuses: { pending: "قيد الانتظار", overdue: "متأخرة", received: "مدفوعة", confirmed: "مؤكدة" },
        summary: {
          template: "الحالة: {{statuses}} • المحاولات: {{attempts}} • الوضع: {{mode}} • {{sort}}",
          modeSingle: "مفردة", modeSeparate: "منفصلة", noSort: "بدون ترتيب"
        },
        fields: {
          askMessage: "رسالة الطلب",
          askMessageHelper: "النص المُرسل للعميل لطلب CPF/CNPJ",
          invalidMessage: "رسالة CPF/CNPJ غير صالح",
          notFoundMessage: "رسالة عند عدم العثور على فواتير",
          errorMessage: "رسالة خطأ الاستعلام",
          giveUpMessage: "رسالة بعد استنفاد المحاولات",
          finalMessage: "الرسالة النهائية (بعد الفواتير)",
          finalMessageHelper: "اتركها فارغة لعدم الإرسال",
          statusesLabel: "الحالات المطلوب البحث عنها في Asaas",
          headerMessage: "العنوان قبل الفواتير",
          boletoTemplate: "تنسيق كل فاتورة (قالب)",
          boletoTemplateHelper: "المتغيرات: {{indice}} {{descricao}} {{valor}} {{vencimento}} {{status}} {{linkBoleto}} {{linhaDigitavel}} {{nossoNumero}} {{pixCopiaCola}}",
          sendMode: "وضع الإرسال",
          sendModeSingle: "رسالة واحدة (كل الفواتير معاً)",
          sendModeSeparate: "رسالة لكل فاتورة",
          sortBy: "ترتيب حسب", sortOrder: "الاتجاه",
          sortDueDate: "تاريخ الاستحقاق", sortValue: "القيمة", sortNone: "بدون ترتيب (ترتيب Asaas)",
          sortOrderHelper: "تصاعدي: الأقرب أولاً",
          sortAsc: "تصاعدي (الأقدم/الأصغر أولاً)",
          sortDesc: "تنازلي (الأحدث/الأكبر أولاً)",
          sendPixQrCode: "تضمين متغير {{pixCopiaCola}} في القالب (قديم)",
          pixDivider: "PIX لكل فاتورة",
          pixDelivery: "كيفية إرسال PIX",
          pixDeliveryHelper: "يُرسل في رسالة منفصلة بعد كل فاتورة",
          pixNone: "عدم إرسال PIX منفصل",
          pixCopyPaste: "نسخ ولصق فقط (نص)",
          pixQrImage: "صورة QR Code فقط",
          pixBoth: "كلاهما (نص + صورة)",
          pixMessageTemplate: "رسالة PIX النسخ واللصق",
          pixMessageTemplateHelper: "استخدم {{pixCopiaCola}} للرمز",
          pixQrCaption: "تعليق صورة QR Code",
          asaasToken: "رمز Asaas (مفتاح API)",
          asaasTokenPlaceholder: "ألصق هنا access_token لحساب Asaas الخاص بك",
          asaasTokenHelper: "إلزامي. كل شركة تستخدم رمزها الخاص، مُكوَّن لكل عقدة.",
          maxAttempts: "الحد الأقصى لمحاولات التحقق",
          maxAttemptsHelper: "بعد الاستنفاد، ينتقل إلى العقدة التالية",
          timeoutDivider: "مهلة الاستجابة",
          inputTimeoutSeconds: "مهلة رد العميل (ثوانٍ)",
          inputTimeoutSecondsHelper: "0 = معطل. عند انتهاء المهلة يُعاد إرسال الطلب ويُحسب كمحاولة",
          timeoutMessage: "رسالة إعادة الإرسال عند انتهاء المهلة",
          countVariable: "متغير الإخراج (الكمية الموجودة)",
          countVariablePlaceholder: "مثال: qtdBoletos",
          countVariableHelper: "اختياري. استخدمه لاحقاً في عقدة شرطية"
        }
      },
      userModal: {
        warning: "لاستيراد الرسائل يجب قراءة رمز QR مرة أخرى !!!",
        title: {
          add: "إضافة مستخدم",
          edit: "تعديل المستخدم",
          updateImage: "تحديث الصورة",
          removeImage: "حذف الصورة",
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          farewellMessage: "رسالة الوداع",
          acceptanceMessage: "التحية عند قبول التذكرة",
          profile: "الملف الشخصي",
          startWork: "بداية العمل",
          endWork: "نهاية العمل",
          internalExtension: "التحويلة الداخلية",
          internalExtensionPlaceholder: "مثال: 101",
          internalExtensionHelper: "اتركه فارغاً إذا كان هذا المستخدم لا يستخدم تحويلة",
          whatsapp: "الاتصال الافتراضي",
          allTicketEnable: "مفعل",
          allTicketDisable: "معطل",
          allTicket: "عرض المحادثات بدون طابور",
          allowGroup: "السماح بالمجموعات",
          defaultMenuOpen: "مفتوح",
          defaultMenuClosed: "مغلق",
          defaultMenu: "القائمة الافتراضية",
          defaultTheme: "المظهر الافتراضي",
          defaultThemeDark: "داكن",
          defaultThemeLight: "فاتح",
          allHistoric: "عرض محادثات الطوابير الأخرى",
          allHistoricEnabled: "مفعل",
          allHistoricDisabled: "معطل",
          allUserChat: "عرض محادثات المستخدمين الآخرين",
          userClosePendingTicket: "السماح بإغلاق المحادثات المعلقة",
          allowSeeMessagesInPendingTickets: "السماح بعرض المحادثات المعلقة",
          showReturnQueueButton: "إظهار زر الإرجاع للطابور",
          showTransferTicketButton: "إظهار زر نقل المحادثة",
          showDashboard: "عرض لوحة التحكم",
          allowRealTime: "عرض لوحة المحادثات",
          allowConnections: "السماح بإجراءات الاتصالات",
          showContacts: "عرض جهات الاتصال",
          showCampaign: "عرض الحملات",
          showFlow: "عرض التدفقات",
          showSchedules: "عرض الجدولة",
          showKanban: "عرض كانبان",
          showInternalChat: "عرض الدردشة الداخلية",
          showOpenAi: "عرض وكيل الذكاء الاصطناعي",
          showIntegrations: "عرض التكاملات",
          finalizacaoComValorVenda: "إغلاق بقيمة البيع",
          birthDate: "تاريخ الميلاد",
          birthDateHelper: "تاريخ الميلاد لإشعارات أعياد الميلاد",
          connections: "الاتصالات",
          language: "اللغة",
          timezone: "المنطقة الزمنية (الحملات)",
        },
        tabs: {
          general: "عام",
          permissions: "الصلاحيات",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          addImage: "إضافة صورة",
          editImage: "تعديل الصورة",
        },
        success: "تم حفظ المستخدم بنجاح.",
      
        notifyTest: {
          button: "إرسال إشعار تجريبي",
          helper: "تُرسل الإشعارات التلقائية فقط للتذاكر في الطوابير المرتبط بها المستخدم (تبويب الطوابير).",
          saveFirst: "احفظ المستخدم قبل إرسال الاختبار.",
          invalidNumber: "أدخل رقم واتساب صالحاً (رمز الدولة + رمز المنطقة + الرقم، من 8 إلى 15 رقماً).",
          success: "تم إرسال الإشعار التجريبي بنجاح!",
          fail: "فشل إرسال الإشعار التجريبي.",
          reasons: {
            userNotFound: "المستخدم غير موجود.",
            invalidNumber: "رقم واتساب غير صالح أو فارغ (استخدم رمز الدولة + المنطقة + الرقم، أرقام فقط).",
            noDefaultWhatsapp: "لا يوجد اتصال واتساب افتراضي. حدد اتصالاً افتراضياً في صفحة الاتصالات.",
            wppNotInitialized: "الاتصال الافتراضي \"{{name}}\" غير مهيأ. افتح صفحة الاتصالات وقم بالاتصال قبل إرسال الاختبار.",
            wppOffline: "الاتصال الافتراضي \"{{name}}\" غير متصل حالياً.",
            sendFailed: "فشل الإرسال: {{error}}"
          }
        },
},
      companyModal: {
        title: {
          add: "إضافة شركة",
          edit: "تعديل الشركة",
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          passwordDefault: "كلمة المرور",
          numberAttendants: "المستخدمون",
          numberConections: "الاتصالات",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        success: "تم حفظ الشركة بنجاح.",
      },
      scheduleModal: {
        title: {
          add: "جدولة جديدة",
          edit: "تعديل الجدولة",
          message: "الرسالة",
        },
        form: {
          body: "الرسالة",
          contact: "جهة الاتصال",
          sendAt: "تاريخ الجدولة",
          sentAt: "تاريخ الإرسال",
          assinar: "إرسال التوقيع",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          addSchedule: "إضافة جدولة",
        },
        success: "تم حفظ الجدولة بنجاح.",
      },
      tagModal: {
        title: {
          add: "علامة جديدة",
          edit: "تعديل العلامة",
          addKanban: "مسار جديد",
          editKanban: "تعديل المسار",
        },
        form: {
          name: "الاسم",
          color: "اللون",
          timeLane: "الوقت بالدقائق لإعادة التوجيه للمسار",
          nextLaneId: "المسار",
          greetingMessageLane: "رسالة ترحيب المسار",
          rollbackLaneId: "العودة للمسار بعد استئناف المحادثة",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        success: "تم حفظ العلامة بنجاح.",
        successKanban: "تم حفظ المسار بنجاح.",
      },
      fileModal: {
        title: {
          add: "إضافة قائمة ملفات",
          edit: "تعديل قائمة الملفات",
        },
        buttons: {
          okAdd: "حفظ",
          okEdit: "تعديل",
          cancel: "إلغاء",
          fileOptions: "إضافة ملف",
        },
        form: {
          name: "اسم قائمة الملفات",
          message: "تفاصيل القائمة",
          fileOptions: "قائمة الملفات",
          extraName: "رسالة لإرسالها مع الملف",
          extraValue: "قيمة الخيار",
        },
        success: "تم حفظ قائمة الملفات بنجاح!",
      },
      chat: {
        noTicketMessage: "اختر محادثة لبدء المراسلة.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ اسحب وأفلت الملفات في الحقل أدناه ⬇️",
          titleFileList: "قائمة الملف(ات)",
        },
      },
      chatInternal: {
        new: "إنشاء مجموعة",
        modal: {
          conversation: "المحادثة",
          title: "الاسم",
          filterUsers: "اختيار الأعضاء",
          cancel: "إغلاق",
          save: "حفظ",
        },
        modalDelete: {
          title: "حذف المحادثة",
          message: "لا يمكن التراجع عن هذا الإجراء، تأكيد؟",
        },
      },
      ticketsManager: {
        header: {
          title: "المحادثات",
        },
        questionCloseTicket: "هل تريد إغلاق جميع المحادثات؟",
        yes: "نعم",
        not: "لا",
        buttons: {
          newTicket: "جديدة",
          resolveAll: "حل الكل",
          close: "إغلاق",
          new: "جديدة",
        },
      },
      ticketsQueueSelect: {
        placeholder: "الطوابير",
      },
      tickets: {
        messageHidden: "رسالة مخفية",
        inbox: {
          closedAllTickets: "إغلاق جميع المحادثات؟",
          closedAll: "إغلاق الكل",
          newTicket: "محادثة جديدة",
          yes: "نعم",
          no: "لا",
          open: "مفتوحة",
          resolverd: "محلولة",
        },
        toasts: {
          deleted: "المحادثة التي كنت فيها تم حذفها.",
        },
        notification: {
          message: "رسالة من",
          messageHidden: "رسالة مخفية",
        },
        tabs: {
          open: { title: "مفتوحة" },
          closed: { title: "محلولة" },
          search: { title: "البحث" },
        },
        search: {
          placeholder: "البحث في المحادثات والرسائل",
          filterConections: "تصفية حسب الاتصال",
          filterConectionsOptions: {
            open: "مفتوح",
            closed: "مغلق",
            pending: "معلق",
          },
          filterUsers: "تصفية حسب المستخدمين",
          filterContacts: "تصفية حسب جهات الاتصال",
          ticketsPerPage: "محادثات لكل صفحة",
        },
        buttons: {
          showAll: "الكل",
          returnQueue: "إرجاع للطابور",
          scredule: "جدولة",
          deleteTicket: "حذف المحادثة",
        },
        closedTicket: {
          closedMessage: "إغلاق المحادثة مع رسالة الوداع",
          closedNotMessage: "إغلاق المحادثة بدون رسالة الوداع",
        },
      },
      transferTicketModal: {
        title: "نقل المحادثة",
        fieldLabel: "اكتب للبحث عن المستخدمين",
        fieldQueueLabel: "النقل للطابور",
        fieldQueuePlaceholder: "اختر طابوراً",
        fieldWhatsapp: "اختر واتس اب",
        noOptions: "لم يتم العثور على مستخدم بهذا الاسم",
        msgTransfer: "ملاحظات - رسالة داخلية، لن تذهب للعميل",
        buttons: {
          ok: "نقل",
          cancel: "إلغاء",
        },
      },
      chatInternal: {
        new: "إنشاء مجموعة",
        modal: {
          conversation: "المحادثة",
          title: "الاسم",
          filterUsers: "اختيار الأعضاء",
          cancel: "إغلاق",
          save: "حفظ",
        },
        modalDelete: {
          title: "حذف المحادثة",
          message: "لا يمكن التراجع عن هذا الإجراء، تأكيد؟",
        },
      },
      ticketsList: {
        called: "المحادثة",
        today: "اليوم",
        elapsedPrefix: "منذ {{distance}}",
        missedCall: "مكالمة صوتية/فيديو فائتة في",
        pendingHeader: "في الانتظار",
        assignedHeader: "جاري المحادثة",
        groupingHeader: "المجموعات",
        noTicketsTitle: "لا شيء هنا!",
        noTicketsMessage: "لا توجد محادثة بهذه الحالة أو المصطلح المبحوث عنه",
        noQueue: "بدون طابور",
        buttons: {
          accept: "قبول",
          cancel: "إلغاء",
          start: "بدء",
          closed: "إغلاق",
          reopen: "إعادة فتح",
          transfer: "نقل",
          ignore: "تجاهل",
          exportAsPDF: "تصدير كـ PDF",
          kanbanActions: "خيارات الكانبان",
        },
        acceptModal: {
          title: "قبول المحادثة",
          queue: "اختيار القسم",
        },
        lastMessage: {
          deleted: "تم حذف الرسالة",
          location: "الموقع",
          contact: "جهة اتصال مشاركة",
          contactCount: "جهة اتصال مشاركة ({{count}})",
          missedCall: "مكالمة صوتية/فيديو فائتة",
          audio: "صوت",
          photo: "صورة",
          video: "فيديو",
          document: "مستند",
          sticker: "ملصق",
        },
      },
      newTicketModal: {
        title: "إنشاء محادثة",
        fieldLabel: "اكتب للبحث عن جهة الاتصال",
        add: "إضافة",
        buttons: {
          ok: "حفظ",
          cancel: "إلغاء",
        },
      },
      SendContactModal: {
        title: "إرسال جهة اتصال",
        fieldLabel: "اكتب للبحث عن جهة الاتصال",
        add: "إضافة",
        buttons: {
          ok: "إرسال",
          cancel: "إلغاء",
        },
      },
      mainDrawer: {
        listItems: {
          courses: "الدورات",
          agentTemplates: "قوالب الوكيل",
          salesAgents: "وكلاء المبيعات",
          dashboard: "لوحة التحكم",
          connections: "الاتصالات",
          chatsTempoReal: "اللوحة",
          tickets: "المحادثات",
          quickMessages: "الردود السريعة",
          contacts: "جهات الاتصال",
          wallets: "المحافظ",
          queues: "الطوابير والبوت",
          tags: "العلامات",
          administration: "الإدارة",
          companies: "الشركات",
          users: "المستخدمون",
          birthdaySettings: "إعدادات أعياد الميلاد",
          settings: "الإعدادات",
          files: "قائمة الملفات",
          helps: "المساعدة",
          messagesAPI: "API",
          schedules: "الجدولة",
          campaigns: "الحملات",
          annoucements: "الإعلانات",
          chats: "المحادثة الداخلية",
          financeiro: "المالية",
          myPlan: "خطتي",
          adminFinanceiro: "الإدارة المالية",
          queueIntegration: "التكاملات",
          version: "الإصدار",
          kanban: "الكانبان",
          prompts: "وكيل الذكاء الاصطناعي",
          allConnections: "إدارة الاتصالات",
          reports: "التقارير",
          management: "الإدارة",
          callHistorical: "سجل المكالمات",
          automations: "الأتمتة",
          groupManager: "مدير المجموعات",
          tasks: "المهام",
          followUp: "متابعة (القوالب)",
          salesPipeline: "خط المبيعات",
          salesPipelineDesc: "عرض الفرص",
          taskList: "قائمة المهام",
          taskListDesc: "جدولة وإدارة",
          preferences: "التفضيلات",
          preferencesDesc: "إعدادات النظام",
          switchAccount: "تبديل الحساب",
          switchAccountDesc: "إدارة الحسابات المحفوظة",
        },
        planExpiresToday: "⚠️ تنتهي خطتك اليوم! جدد الآن حتى لا تفقد الوصول.",
        planExpiresTomorrow: "⚠️ تنتهي خطتك غداً! جدد حتى لا تفقد الوصول.",
        planExpiresIn: "⏳ تنتهي خطتك خلال {{count}} أيام. جدد للاستمرار في استخدام النظام.",
        renewNow: "جدد الآن",
        appBar: {
          user: {
            profile: "الملف الشخصي",
            logout: "خروج",
            switchAccount: "تبديل الحساب",
            message: "مرحباً",
            messageEnd: "مرحباً بك في",
            active: "نشط حتى",
            goodMorning: "مرحباً،",
            myName: "اسمي",
            continuity: "وسأتابع محادثتك.",
            virtualAssistant: "المساعد الافتراضي",
            token: "رمز غير صالح، يرجى الاتصال بمسؤول المنصة.",
          },
          message: {
            location: "الموقع",
            contact: "جهة الاتصال",
          },
          notRegister: "لا يوجد سجل",
          refresh: "تحديث",
        },
      },
      languages: {
        undefined: "اللغة",
        "pt-BR": "البرتغالية",
        es: "الإسبانية",
        en: "الإنجليزية",
        tr: "التركية",
        ar: "العربية",
      },
      messagesAPI: {
        title: "API",
        toSend: "إرسال",
        textMessage: {
          number: "الرقم",
          body: "الرسالة",
          token: "الرمز المسجل",
          userId: "معرف المستخدم/المشغل",
          queueId: "معرف الطابور",
        },
        mediaMessage: {
          number: "الرقم",
          body: "اسم الملف",
          media: "الملف",
          token: "الرمز المسجل",
        },
        API: {
          title: "وثائق إرسال الرسائل",
          methods: {
            title: "طرق الإرسال",
            messagesText: "الرسائل النصية",
            messagesMidia: "الرسائل الوسائطية",
          },
          instructions: {
            title: "التعليمات",
            comments: "ملاحظات مهمة",
            comments1:
              "قبل إرسال الرسائل، يجب تسجيل الرمز المرتبط بالاتصال الذي سيرسل الرسائل. <br />للتسجيل، ادخل إلى قائمة 'الاتصالات'، انقر على زر تعديل الاتصال وأدخل الرمز في الحقل المخصص.",
            comments2:
              "رقم الإرسال يجب ألا يحتوي على قناع أو رموز خاصة ويجب أن يتكون من:",
            codeCountry: "كود الدولة",
            code: "كود المنطقة",
            number: "الرقم",
          },
          text: {
            title: "1. الرسائل النصية",
            instructions:
              "فيما يلي قائمة المعلومات المطلوبة لإرسال الرسائل النصية:",
          },
          media: {
            title: "2. الرسائل الوسائطية",
            instructions:
              "فيما يلي قائمة المعلومات المطلوبة لإرسال الرسائل النصية:",
          },
        },
      },
      notifications: {
        title: "الإشعارات", clearAll: "مسح الكل",
        noTickets: "لا توجد إشعارات.",
        messageHidden: "رسالة مخفية",
        newMessage: "رسالة جديدة من",
        hideAll: "إخفاء الإشعارات",
        hideAllTooltip: "تعطيل الإشعارات (يمكنك إعادة تفعيلها من الإعدادات)",
      },
      triggerFlowModal: {
        title: "تفعيل التدفق",
        description:
          "اختر تدفقاً لتنفيذه في هذه المحادثة. ستتغير حالة المحادثة إلى 'بوت' أثناء التنفيذ.",
        selectFlow: "اختر تدفقاً",
        selectedFlow: "التدفق المختار",
        flowId: "معرف التدفق",
        noFlows: "لا توجد تدفقات نشطة",
        cancel: "إلغاء",
        trigger: "تفعيل التدفق",
        triggering: "جاري التفعيل...",
        success: "تم تفعيل التدفق بنجاح!",
        error: "خطأ في تفعيل التدفق",
      },
      quickMessages: {
        title: "الردود السريعة",
        searchPlaceholder: "البحث...",
        noAttachment: "بدون مرفق",
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "هذا الإجراء لا يمكن التراجع عنه! هل تريد المتابعة؟",
        },
        selectMessage: "اختيار الرد السريع",
        hasMedia: "مع وسائط",
        global: "عام",
        noResultsFound: "لم يتم العثور على رد سريع لبحثك",
        noQuickMessages: "لا توجد ردود سريعة متاحة",
        buttons: {
          add: "إضافة",
          attach: "إرفاق ملف",
          cancel: "إلغاء",
          edit: "تعديل",
        },
        toasts: {
          success: "تم إضافة الاختصار بنجاح!",
          deleted: "تم حذف الاختصار بنجاح!",
        },
        dialog: {
          title: "الرسالة السريعة",
          shortcode: "الاختصار",
          message: "الرد",
          save: "حفظ",
          cancel: "إلغاء",
          geral: "السماح بالتعديل",
          add: "إضافة",
          general: "عام",
          visao: "السماح بالعرض",
        },
        table: {
          shortcode: "الاختصار",
          message: "الرسالة",
          media: "وسائط",
          actions: "الإجراءات",
          mediaName: "اسم الملف",
          status: "الحالة",
        },
      },
      contactLists: {
        title: "قوائم جهات الاتصال",
        table: {
          name: "الاسم",
          contacts: "جهات الاتصال",
          actions: "الإجراءات",
        },
        buttons: {
          add: "قائمة جديدة",
        },
        dialog: {
          name: "الاسم",
          company: "الشركة",
          okEdit: "تعديل",
          okAdd: "إضافة",
          add: "إضافة",
          edit: "تعديل",
          cancel: "إلغاء",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        toasts: {
          deleted: "تم حذف السجل",
        },
      },
      contactListItems: {
        title: "جهات الاتصال",
        searchPlaceholder: "البحث",
        buttons: {
          add: "جديد",
          lists: "القوائم",
          import: "استيراد",
        },
        dialog: {
          name: "الاسم",
          number: "الرقم",
          whatsapp: "الواتس اب",
          email: "البريد الإلكتروني",
          okEdit: "تعديل",
          okAdd: "إضافة",
          add: "إضافة",
          edit: "تعديل",
          cancel: "إلغاء",
        },
        table: {
          name: "الاسم",
          number: "الرقم",
          whatsapp: "الواتس اب",
          email: "البريد الإلكتروني",
          actions: "الإجراءات",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
          importMessage: "هل تريد استيراد جهات الاتصال من هذا الملف؟ ",
          importTitlte: "استيراد",
        },
        toasts: {
          deleted: "تم حذف السجل",
        },
      },

      kanban: {
        title: "الكانبان",
        searchPlaceholder: "البحث",
        sortBy: "ترتيب حسب",
        startDate: "تاريخ البداية",
        endDate: "تاريخ النهاية",
        search: "بحث",
        addColumns: "إضافة أعمدة",
        allTickets: "جميع التذاكر",
        myTickets: "تذاكري",
        slaOverdue: "SLA متأخر",
        filterSla: "تصفية SLA",
        filterUser: "الموظف",
        filterQueue: "القسم",
        filterChannel: "القناة",
        filterTag: "الوسم",
        filterAll: "الكل",
        compact: "مضغوط",
        expanded: "موسع",
        clearFilters: "مسح عوامل التصفية",
        shortcutsHelp: "اختصارات: ←/→ تنقل بين الأعمدة · ↑/↓ تنقل بين البطاقات · Enter فتح · C تبديل المضغوط · / تركيز البحث",
        sortOptions: {
          ticketNumber: "رقم التذكرة",
          lastMessage: "آخر رسالة",
          valueDesc: "القيمة (الأعلى إلى الأقل)",
        },
        toasts: {
          tagUpdated: "تم تحديث علامة التذكرة بنجاح!",
          tagRemoved: "تم إزالة علامة التذكرة!",
          adminOnly: "فقط المشرفون يمكنهم إعادة ترتيب مسارات الكانبان",
          laneOrderUpdated: "تم تحديث ترتيب المسارات بنجاح",
          laneOrderError: "خطأ في حفظ ترتيب المسارات",
        },
        subMenus: {
          list: "اللوحة",
          tags: "المسارات",
        },
      },

      campaigns: {
        title: "الحملات",
        searchPlaceholder: "البحث",
        subMenus: {
          list: "القائمة",
          listContacts: "قائمة جهات الاتصال",
          settings: "الإعدادات",
        },
        settings: {
          randomInterval: "فاصل زمني عشوائي للإرسال",
          noBreak: "بدون فاصل",
          intervalGapAfter: "فاصل أكبر بعد",
          undefined: "غير محدد",
          messages: "رسائل",
          laggerTriggerRange: "فاصل إرسال أكبر",
          addVar: "إضافة متغير",
          save: "حفظ",
          close: "إغلاق",
          add: "إضافة",
          shortcut: "اختصار",
          content: "المحتوى",
        },
        buttons: {
          add: "حملة جديدة",
          contactLists: "قوائم جهات الاتصال",
        },
        table: {
          name: "الاسم",
          whatsapp: "الاتصال",
          contactList: "قائمة جهات الاتصال",
          option: "لا شيء",
          disabled: "معطل",
          enabled: "مفعل",
          status: "الحالة",
          scheduledAt: "الجدولة",
          completedAt: "مكتملة",
          confirmation: "التأكيد",
          actions: "الإجراءات",
          recurrence: "التكرار",
          nextExecution: "التنفيذ التالي",
        },
        dialog: {
          new: "حملة جديدة",
          update: "تعديل الحملة",
          readonly: "عرض فقط",
          help: "استخدم متغيرات مثل {الاسم}، {الرقم}، {البريد} أو حدد متغيرات مخصصة.",
          form: {
            name: "الاسم",
            message1: "الرسالة 1",
            message2: "الرسالة 2",
            message3: "الرسالة 3",
            message4: "الرسالة 4",
            message5: "الرسالة 5",
            confirmationMessage1: "رسالة التأكيد 1",
            confirmationMessage2: "رسالة التأكيد 2",
            confirmationMessage3: "رسالة التأكيد 3",
            confirmationMessage4: "رسالة التأكيد 4",
            confirmationMessage5: "رسالة التأكيد 5",
            messagePlaceholder: "محتوى الرسالة",
            whatsapp: "الاتصال",
            status: "الحالة",
            scheduledAt: "الجدولة",
            confirmation: "التأكيد",
            contactList: "قائمة جهات الاتصال",
            tagList: "العلامات",
            statusTicket: "حالة المحادثة",
            openTicketStatus: "مفتوحة",
            pendingTicketStatus: "معلقة",
            closedTicketStatus: "مغلقة",
            enabledOpenTicket: "مفعل",
            disabledOpenTicket: "معطل",
            openTicket: "فتح محادثة",
          },
          buttons: {
            add: "إضافة",
            edit: "تحديث",
            okadd: "موافق",
            cancel: "إلغاء الإرسال",
            restart: "إعادة تشغيل الإرسال",
            close: "إغلاق",
            attach: "إرفاق ملف",
          },
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        statuses: {
          inactive: "غير نشطة",
          scheduled: "مجدولة",
          inProgress: "قيد التنفيذ",
          cancelled: "ملغاة",
          finished: "منتهية",
        },
        recurrence: {
          minutely: "كل دقيقة",
          hourly: "كل ساعة",
          daily: "يومي",
          weekly: "أسبوعي",
          biweekly: "كل أسبوعين",
          monthly: "شهري",
          yearly: "سنوي",
        },
        stopRecurrence: {
          title: "إيقاف التكرار",
          message: "هل أنت متأكد أنك تريد إيقاف تكرار هذه الحملة؟ ستستمر الحملة الحالية في التنفيذ، ولكن لن تكون هناك عمليات تنفيذ مستقبلية.",
        },
        filters: {
          status: "الحالة",
          all: "الكل",
          allFem: "الكل",
          recurrence: "التكرار",
          recurring: "متكررة",
          single: "مرة واحدة",
        },
        tooltips: {
          recurring: "حملة متكررة",
          stop: "إيقاف الحملة",
          restart: "إعادة تشغيل الحملة",
          stopRecurrence: "إيقاف التكرار",
          duplicate: "تكرار الحملة",
          export: "تصدير CSV",
          preview: "معاينة الرسالة",
        },
        summary: {
          total: "الإجمالي",
          scheduled: "مجدولة",
          inProgress: "قيد التنفيذ",
          finished: "منتهية",
          cancelled: "ملغاة",
        },
        bulk: {
          selected: "محددة",
          cancelAll: "إلغاء",
          restartAll: "إعادة تشغيل",
          deleteAll: "حذف",
          confirmTitle: "إجراء جماعي",
          confirmMessage: "هل أنت متأكد من تنفيذ هذا الإجراء على {{count}} حملة(حملات)؟",
        },
        noMessage: "لا توجد رسالة",
        listRemoved: "لا توجد قائمة مرتبطة",
        connectionDeleted: "تم حذف الاتصال",
        connectionPrefix: "اتصال",
        noConnection: "لا يوجد اتصال",
        notCompleted: "لم تكتمل",
        totalLabel: "حملات",
        pagination: {
          rowsPerPage: "صفوف في الصفحة:",
          of: "من",
          moreThan: "أكثر من",
        },
        toasts: {
          success: "تم تنفيذ العملية بنجاح",
          cancel: "تم إلغاء الحملة",
          restart: "تم إعادة تشغيل الحملة",
          deleted: "تم حذف السجل",
          duplicated: "تم تكرار الحملة بنجاح!",
          bulkSuccess: "تم تنفيذ الإجراء الجماعي بنجاح!",
          noPermission: "هذه الشركة ليس لديها إذن للوصول إلى هذه الصفحة! نحن نعيد توجيهك.",
          recurrenceStopped: "تم إيقاف التكرار بنجاح!",
        },
      },
      campaignReport: {
        title: "تقرير",
        inactive: "غير نشطة",
        scheduled: "مجدولة",
        process: "قيد التنفيذ",
        cancelled: "ملغاة",
        finished: "منتهية",
        campaign: "الحملة",
        validContacts: "جهات اتصال صالحة",
        confirmationsRequested: "تأكيدات مطلوبة",
        confirmations: "تأكيدات",
        deliver: "مسلمة",
        connection: "الاتصال",
        contactLists: "قائمة جهات الاتصال",
        schedule: "الجدولة",
        conclusion: "الخلاصة",
        fetchError: "خطأ في جلب بيانات التقرير",
        backButton: "العودة",
        awaitingTemplateResponseCard: "في انتظار الرد على القالب",
        templateRespondedCard: "ردّوا (تم إرسال المتابعة)",
        followUpStatus: {
          waiting: "في انتظار الرد",
          waitingTooltip: "تم إرسال القالب. في انتظار رد العميل لإطلاق الرسائل 2-5 (نافذة 24 ساعة من ميتا).",
          sent: "تم إرسال المتابعات",
          sentTooltip: "ردّ العميل على القالب. تم إرسال رسائل المتابعة (2-5) بالفعل.",
          expired: "انتهت النافذة",
          expiredTooltip: "انتهت نافذة 24 ساعة من ميتا دون رد من العميل. لا يمكن إرسال الرسائل 2-5 بعد الآن.",
        },
      },
      announcements: {
        title: "الإعلانات",
        searchPlaceholder: "البحث",
        active: "نشط",
        inactive: "غير نشط",
        buttons: {
          add: "إعلان جديد",
          contactLists: "قوائم الإعلانات",
        },
        table: {
          priority: "الأولوية",
          title: "العنوان",
          text: "النص",
          mediaName: "الملف",
          status: "الحالة",
          actions: "الإجراءات",
        },
        dialog: {
          edit: "تعديل الإعلان",
          add: "إعلان جديد",
          update: "تعديل الإعلان",
          readonly: "عرض فقط",
          form: {
            priority: "الأولوية",
            title: "العنوان",
            text: "النص",
            mediaPath: "الملف",
            status: "الحالة",
            high: "عالية",
            medium: "متوسطة",
            low: "منخفضة",
            active: "نشط",
            inactive: "غير نشط",
          },
          buttons: {
            add: "إضافة",
            edit: "تحديث",
            okadd: "موافق",
            cancel: "إلغاء",
            close: "إغلاق",
            attach: "إرفاق ملف",
          },
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        toasts: {
          success: "تم تنفيذ العملية بنجاح",
          deleted: "تم حذف السجل",
        },
      },
      campaignsConfig: {
        title: "إعدادات الحملات",
        buttons: {
          filter: "تطبيق الفلتر",
          onlyRated: "المقيمة فقط",
        },
      },
      queues: {
        title: "الطوابير والبوت",
        table: {
          name: "الاسم",
          color: "اللون",
          greeting: "رسالة الترحيب",
          orderQueue: "ترتيب الطابور (البوت)",
          actions: "الإجراءات",
          ID: "المعرف",
        },
        buttons: {
          add: "إضافة طابور",
        },
        toasts: {
          success: "تم حفظ الطابور بنجاح",
          deleted: "تم حذف الطابور بنجاح",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء! محادثات هذا الطابور ستبقى موجودة، لكن لن يكون لها طابور مخصص.",
        },
      },
      queue: {
        queueData: "البيانات",
      },
      queueSelect: {
        inputLabel: "الطوابير",
        inputLabelRO: "طوابير للقراءة فقط",
        withoutQueue: "بدون طابور",
      },
      queueIntegration: {
        title: "التكاملات",
        table: {
          id: "المعرف",
          type: "النوع",
          name: "الاسم",
          projectName: "اسم المشروع",
          language: "اللغة",
          lastUpdate: "آخر تحديث",
          actions: "الإجراءات",
        },
        buttons: {
          add: "إضافة مشروع",
        },
        searchPlaceholder: "البحث...",
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء! وسيتم إزالته من الطوابير والاتصالات المرتبطة",
        },
      },
      users: {
        title: "المستخدمون",
        table: {
          status: "الحالة",
          name: "الاسم",
          email: "البريد الإلكتروني",
          profile: "الملف الشخصي",
          startWork: "بداية العمل",
          endWork: "نهاية العمل",
          internalExtension: "التحويلة الداخلية",
          internalExtensionPlaceholder: "مثال: 101",
          internalExtensionHelper: "اتركه فارغاً إذا كان هذا المستخدم لا يستخدم تحويلة",
          actions: "الإجراءات",
          ID: "المعرف",
        },
        buttons: {
          add: "إضافة مستخدم",
        },
        toasts: {
          deleted: "تم حذف المستخدم بنجاح.",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "جميع بيانات المستخدم ستفقد. المحادثات المفتوحة لهذا المستخدم ستنقل للطابور.",
        },
      },
      compaies: {
        title: "الشركات",
        table: {
          ID: "المعرف",
          status: "نشط",
          name: "الاسم",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          phone: "الهاتف",
          plan: "الخطة",
          active: "نشط",
          numberAttendants: "المشغلين",
          numberConections: "الاتصالات",
          value: "القيمة",
          namePlan: "اسم الخطة",
          numberQueues: "الطوابير",
          useCampaigns: "الحملات",
          useExternalApi: "Rest API",
          useFacebook: "فيسبوك",
          useInstagram: "إنستجرام",
          useWhatsapp: "واتس اب",
          useInternalChat: "المحادثة الداخلية",
          useSchedules: "الجدولة",
          createdAt: "تم الإنشاء في",
          dueDate: "الاستحقاق",
          lastLogin: "آخر دخول",
          folderSize: "حجم المجلد ",
          totalFiles: " إجمالي الملفات",
          lastUpdate: "آخر تحديث",
          actions: "الإجراءات",
          money: "ر.س",
          yes: "نعم",
          no: "لا",
          document: "السجل التجاري/الهوية",
          recurrence: "التكرار",
          monthly: "شهري",
          bimonthly: "شهرين",
          quarterly: "ربع سنوي",
          semester: "نصف سنوي",
          yearly: "سنوي",
          clear: "مسح",
          delete: "حذف",
          user: "المستخدم",
          save: "حفظ",
          generateInvoice: "إنشاء فاتورة",
        },
        buttons: {
          add: "إضافة شركة",
        },
        toasts: {
          deleted: "تم حذف الشركة بنجاح.",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "جميع بيانات الشركة ستفقد. المحادثات المفتوحة لهذا المستخدم ستنقل للطابور.",
        },
      },
      plans: {
        form: {
          name: "الاسم",
          users: "المستخدمون",
          connections: "الاتصالات",
          queues: "الصفوف",
          amount: "القيمة",
          campaigns: "الحملات",
          schedules: "الجدولة",
          internalChat: "الدردشة الداخلية",
          externalApi: "API خارجي",
          kanban: "كانبان",
          openAi: "وكيل الذكاء الاصطناعي",
          integrations: "التكاملات",
          flows: "التدفقات",
          contacts: "جهات الاتصال",
          dashboard: "لوحة التحكم",
          realTime: "الوقت الحقيقي",
          enabled: "مفعل",
          disabled: "معطل",
          clear: "إلغاء",
          delete: "حذف",
          save: "حفظ",
          yes: "نعم",
          no: "لا",
          money: "ر.س",
          public: "عام",
          trial: "تجريبي",
          trialDays: "أيام التجربة",
        },
        confirmationModal: {
          deleteTitle: "حذف السجل",
          deleteMessage: "هل تريد حقاً حذف هذا السجل؟",
        },
        toasts: {
          success: "تمت العملية بنجاح!",
          errorList: "لم يتمكن من تحميل قائمة السجلات",
          errorSave: "لم يتمكن من إتمام العملية. تحقق مما إذا كانت هناك خطة بنفس الاسم أو ما إذا كانت الحقول مملوءة بشكل صحيح",
          errorDelete: "لم يتمكن من إتمام العملية",
        },
      },
      helps: {
        title: "مركز المساعدة",
        settings: {
          codeVideo: "كود الفيديو",
          description: "الوصف",
          clear: "مسح",
          delete: "حذف",
          save: "حفظ",
        },
        confirmationModal: {
          deleteTitle: "حذف السجل",
          deleteMessage: "هل تريد حقاً حذف هذا السجل؟",
        },
        toasts: {
          success: "تمت العملية بنجاح!",
          error: "لم يتمكن من إتمام العملية",
        },
      },
    schedulesHeader: {
      title: "جدولة الرسائل",
      subtitle: "جدولة ومتابعة الإرسال التلقائي والتذكيرات في تقويم تفاعلي",
      programmed: "عمليات إرسال مجدولة",
      schedulesWord: "جدولة",
      cardTotal: "إجمالي المجدول",
      cardTotalHint: "عمليات الإرسال المسجلة في النظام",
      cardToday: "مجدول لليوم",
      cardTodayHint: "عمليات الإرسال المخططة لليوم",
      cardWeek: "الأيام السبعة القادمة",
      cardWeekHint: "توقعات الأسبوع",
      cardPending: "قيد الانتظار",
      cardPendingHint: "بانتظار موعد الإرسال",
      googleCalendar: "تقويم Google",
      newSchedule: "جدولة جديدة",
    },
    googleCalendar: {
      errors: {
        credentialsMissing: "لم يتم تفعيل تقويم Google على هذه المنصة بعد. اطلب من المسؤول تسجيل Client ID و Client Secret.",
        redirectMissing: "تعذّر تحديد عنوان الخادم لعودة Google. يرجى إبلاغ المسؤول.",
      },
      toast: {
        connected: "تم ربط تقويم Google!",
        connectFail: "تعذّر الاتصال: ",
        unknownError: "خطأ غير معروف",
        authUrlError: "تعذّر بدء الاتصال بـ Google.",
        disconnected: "تم فصل الحساب.",
        disconnectError: "تعذّر فصل الحساب.",
        saved: "تم حفظ الإعدادات.",
        saveError: "تعذّر الحفظ.",
      },
      title: "Google Calendar & Google Meet integration",
      step1: "1. Google API credentials (OAuth 2.0)",
      step1Sub: "Set the Client ID and Client Secret generated in Google Cloud Console",
      clientId: "Google Client ID",
      clientSecret: "Google Client Secret",
      redirectUri: "Authorized redirect URI (paste into Google Cloud)",
      jsOrigin: "Authorized JavaScript origin (paste into Google Cloud)",
      saveCredentials: "Save API credentials",
      credentialsSaved: "Credentials saved.",
      credentialsFail: "Could not save the credentials.",
      copied: "Copied!",
      howToTitle: "Step by step: how to create the Client ID and Client Secret in Google Cloud (2 minutes)",
      how1: "Go to console.cloud.google.com and create (or pick) a project.",
      how2: "Under APIs & Services → Library, enable the Google Calendar API.",
      how3: "Under OAuth consent screen, set it to External and publish.",
      how4: "Under Credentials → Create credentials → OAuth client ID, choose Web application.",
      how5: "Paste the two values above into the authorized origins and redirect URIs fields.",
      how6: "Copy the generated Client ID and Client Secret and paste them above.",
      step2: "2. Google account connection",
      step2Sub: "Connect the account that will manage meetings and Meet",
      connectionStatus: "CONNECTION STATUS",
      connectedAccount: "CONNECTED ACCOUNT",
      connected: "Connected",
      disconnectAccount: "Disconnect account",
      openCalendar: "Open Google Calendar",
      connect: "Connect Google Calendar",
      notConnected: "No Google account connected for this company.",
      confirmDisconnect: "Disconnect the Google account from this company?",
      defaultCalendar: "Default calendar",
      primary: "primary (default)",
      main: "main",
      defaultDuration: "Default meeting length",
      timezone: "Time zone",
      timezoneHelp: "e.g. America/Sao_Paulo",
      save: "Save settings",
      saving: "Saving...",
    },
    scheduleGoogle: {
      connectAccount: "ربط حساب",
      notConnectedHint: "لا يوجد حساب Google مرتبط. اربط حساباً لمزامنة هذه الجدولة مع التقويم وإنشاء رابط Meet.",
      title: "تكامل تقويم Google و Meet",
      connectedAs: "متصل:",
      syncCalendar: "المزامنة مع تقويم Google",
      generateMeet: "إنشاء رابط Google Meet",
      eventTitle: "عنوان الاجتماع / الموضوع",
      eventTitlePlaceholder: "مثال: اجتماع مع العميل",
      duration: "المدة",
      minutes: "دقيقة",
      hour: "ساعة",
      hours: "ساعات",
      copyLink: "نسخ الرابط",
      copied: "تم النسخ!",
      openMeet: "فتح Meet",
    },
      schedules: {
        title: "الجدولة",
        date: "التاريخ",
        time: "الوقت",
        event: "الحدث",
        allDay: "اليوم كله",
        week: "الأسبوع",
        work_week: "الجدولة",
        day: "اليوم",
        month: "الشهر",
        previous: "السابق",
        next: "التالي",
        yesterday: "أمس",
        tomorrow: "غداً",
        today: "اليوم",
        agenda: "الأجندة",
        noEventsInRange: "لا توجد جدولة في هذه الفترة.",
        more: "المزيد",
        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذه الجدولة؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        table: {
          contact: "جهة الاتصال",
          body: "الرسالة",
          sendAt: "تاريخ الجدولة",
          sentAt: "تاريخ الإرسال",
          status: "الحالة",
          actions: "الإجراءات",
        },
        buttons: {
          add: "جدولة جديدة",
        },
        toasts: {
          deleted: "تم حذف الجدولة بنجاح.",
        },
      },
      tags: {
        title: "العلامات",
        addColumns: "+ إضافة أعمدة",
        search: "البحث",
        seeTicket: "عرض المحادثة",
        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذه العلامة؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        table: {
          id: "المعرف",
          name: "الاسم",
          kanban: "الكانبان",
          color: "اللون",
          tickets: "سجلات العلامات",
          contacts: "جهات الاتصال",
          actions: "الإجراءات",
        },
        buttons: {
          add: "علامة جديدة",
        },
        toasts: {
          deleted: "تم حذف العلامة بنجاح.",
        },
      },

      tagsKanban: {
        title: "المسارات",
        laneDefault: "مفتوحة",
        backToKanban: "العودة للكانبان",

        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذا المسار؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        table: {
          name: "الاسم",
          color: "اللون",
          tickets: "المحادثات",
          actions: "الإجراءات",
        },
        buttons: {
          add: "مسار جديد",
        },
        toasts: {
          deleted: "تم حذف المسار بنجاح.",
        },
      },
      files: {
        title: "قائمة الملفات",
        table: {
          name: "الاسم",
          contacts: "جهات الاتصال",
          actions: "الإجراءات",
        },
        toasts: {
          deleted: "تم حذف القائمة بنجاح!",
          deletedAll: "تم حذف جميع القوائم بنجاح!",
        },
        buttons: {
          add: "إضافة",
          deleteAll: "حذف الكل",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteAllTitle: "حذف الكل",
          deleteMessage: "هل أنت متأكد من حذف هذه القائمة؟",
          deleteAllMessage: "هل أنت متأكد من حذف جميع القوائم؟",
        },
      },
      settings: {
        success: "تم حفظ الإعدادات بنجاح.",
        title: "الإعدادات",
        tabs: {
          leadSources: "مصادر العملاء",
          options: "الخيارات",
          plans: "الخطط",
          helps: "المساعدة",
          companies: "الشركات",
          finalizacao: "إنهاء الخدمة",
        },
        settings: {
          userCreation: {
            name: "إنشاء المستخدم",
            options: {
              enabled: "مفعل",
              disabled: "معطل",
            },
          },
          tabs: {
            options: "الخيارات",
            schedules: "المواعيد",
            plans: "الخطط",
            help: "المساعدة",
          },
          options: {
            disabled: "معطل",
            enabled: "مفعل",
            updating: "جاري التحديث...",
            creationCompanyUser: "إنشاء الشركة/المستخدم",
            evaluations: "التقييمات",
            officeScheduling: "جدولة المكتب",
            queueManagement: "الإدارة بالطابور",
            companyManagement: "الإدارة بالشركة",
            connectionManagement: "الإدارة بالاتصال",
            sendGreetingAccepted: "إرسال الترحيب عند قبول المحادثة",
            sendMsgTransfTicket: "إرسال رسالة نقل القسم/المشغل",
            checkMsgIsGroup: "تجاهل رسائل المجموعات",
            chatBotType: "نوع البوت",
            userRandom: "اختيار مشغل عشوائي",
            buttons: "الأزرار",
            acceptCallWhatsapp: "إعلام عدم قبول المكالمات في الواتس اب؟",
            sendSignMessage: "السماح للمشغل باختيار إرسال التوقيع",
            sendGreetingMessageOneQueues:
              "إرسال الترحيب عند وجود طابور واحد فقط",
            sendQueuePosition: "إرسال رسالة مع موقع الطابور",
            sendFarewellWaitingTicket: "إرسال رسالة الوداع في الانتظار",
            acceptAudioMessageContact: "قبول الصوتيات من جميع جهات الاتصال؟",
            enableLGPD: "تفعيل معاملة LGPD",
            requiredTag: "علامة إجبارية لإغلاق المحادثة",
            closeTicketOnTransfer: "إغلاق المحادثة عند النقل لطابور آخر",
            enableCloseTicketModal: "شاشة إغلاق المحادثة (الموضوع والملخص)",
            DirectTicketsToWallets: "نقل العميل تلقائياً للمحفظة",
            autoReaction: "التفاعل تلقائيًا مع رسائل العميل",
            autoReactionEmoji: "إيموجي التفاعل",
            autoReactionHelp: "مع كل رسالة واردة من جهة الاتصال، يرسل النظام هذا التفاعل. لاتصالات واتساب (Baileys) فقط، ولا ينطبق على المجموعات.",
            showNotificationPending: "إظهار إشعار للمحادثات المعلقة",
            disableSystemNotifications: "كتم جميع الإشعارات",
            transferredTicketStatus: "حالة المحادثة عند النقل مع المستخدم",
            copyContactPrefix: "بادئة لنسخ جهات الاتصال",
            copyContactPrefixPlaceholder: "مثال: COPIA_",
            open: "مفتوح",
            pending: "معلق",
          },
          customMessages: {
            sendQueuePositionMessage: "رسالة الموقع في الطابور",
            AcceptCallWhatsappMessage: "رسالة إعلام عدم قبول المكالمات",
            greetingAcceptedMessage: "رسالة الترحيب عند قبول المحادثة",
            transferMessage: "رسالة النقل - استخدم {{queue}} لاسم الطابور المقصود",
          },
          LGPD: {
            title: "LGPD",
            welcome: "رسالة الترحيب (LGPD)",
            linkLGPD: "رابط سياسة الخصوصية",
            obfuscateMessageDelete: "إخفاء الرسالة المحذوفة",
            alwaysConsent: "طلب الموافقة دائماً",
            obfuscatePhoneUser: "إخفاء رقم الهاتف للمستخدمين",
            enabled: "مفعل",
            disabled: "معطل",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "مخصص لـ:",
          dialogRatingTitle: "هل تريد ترك تقييم للخدمة للعميل؟",
          dialogClosingTitle: "إنهاء المحادثة مع العميل!",
          dialogRatingCancel: "حل مع رسالة الوداع",
          dialogRatingSuccess: "حل وإرسال التقييم",
          dialogRatingWithoutFarewellMsg: "حل بدون رسالة الوداع",
          ratingTitle: "اختر قائمة تقييم",
          notMessage: "لا توجد رسالة مختارة",
          amount: "قيمة الاستطلاع",
          buttons: {
            return: "إرجاع",
            resolve: "حل",
            reopen: "إعادة فتح",
            accept: "قبول",
            rating: "إرسال التقييم",
            enableIntegration: "تفعيل التكامل",
            disableIntegration: "تعطيل التكامل",
            logTicket: "سجلات المحادثة",
            requiredTag: "يجب تخصيص علامة قبل إغلاق المحادثة.",
            greetingAcceptedMessage: "يجب إعداد رسالة ترحيب عند قبول المحادثة.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage: "اكتب رسالة أو اضغط / للردود السريعة",
        placeholderOpen: "اكتب رسالة أو اضغط / للردود السريعة",
        placeholderClosed: "أعد فتح أو اقبل هذه المحادثة لإرسال رسالة.",
        signMessage: "توقيع",
        privateMessage: "رسالة خاصة",
        tooltips: {
          bold: "غامق",
          italic: "مائل",
          strikethrough: "يتوسطه خط",
          code: "كود",
          numberedList: "قائمة مرقمة",
          bulletList: "قائمة نقطية",
          quote: "اقتباس",
          clearFormat: "مسح التنسيق",
          ghostMention: "إشارة شبحية (إخطار الجميع دون إظهار @)",
          triggerFlow: "تشغيل التدفق",
          aiSuggest: "ذكاء اصطناعي: اقتراح رد",
          enableSignature: "تفعيل/تعطيل التوقيع",
          enableComments: "تفعيل/تعطيل التعليقات",
          quickAnswers: "ردود سريعة",
        },
        menuItems: {
          ghostMention: "إشارة شبحية",
          signature: "التوقيع",
          triggerFlow: "تشغيل التدفق",
          catalog: "كتالوج المنتجات",
          comments: "التعليقات",
        },
        errors: {
          ticketIdNotFound: "خطأ: لم يتم العثور على معرف المحادثة",
        },
      },
      contactDrawer: {
        header: "بيانات جهة الاتصال",
        buttons: {
          edit: "تعديل جهة الاتصال",
          block: "حظر",
          unblock: "إلغاء الحظر",
        },
        extraInfo: "معلومات أخرى",
      },
      messageVariablesPicker: {
        label: "المتغيرات المتاحة",
        vars: {
          contactFirstName: "الاسم الأول",
          contactName: "الاسم",
          user: "المشغل",
          greeting: "الترحيب",
          protocolNumber: "البروتوكول",
          date: "التاريخ",
          hour: "الساعة",
          ticket_id: "رقم المحادثة",
          queue: "القسم",
          connection: "الاتصال",
        },
      },
      ticketOptionsMenu: {
        schedule: "جدولة",
        delete: "حذف",
        transfer: "نقل",
        registerAppointment: "ملاحظات جهة الاتصال",
        resolveWithNoFarewell: "إنهاء بدون وداع",
        acceptAudioMessage: "قبول صوتيات جهة الاتصال؟",
        appointmentsModal: {
          title: "ملاحظات المحادثة",
          textarea: "الملاحظة",
          placeholder: "أدخل هنا المعلومة التي تريد تسجيلها",
        },
        confirmationModal: {
          title: "حذف محادثة جهة الاتصال",
          titleFrom: "من جهة الاتصال ",
          message: "تنبيه! جميع الرسائل المتعلقة بالمحادثة ستفقد.",
        },
        buttons: {
          delete: "حذف",
          cancel: "إلغاء",
        },
        aiSummarize: "ملخص ذكاء اصطناعي للمحادثة",
        aiSummarizeTitle: "ملخص ذكاء اصطناعي للمحادثة",
        aiSummaryCopied: "تم نسخ الملخص!",
        aiSummaryCopy: "نسخ",
        aiSummaryClose: "إغلاق",
        aiSummarySaveNote: "حفظ كملاحظة",
        aiSummarySaved: "تم حفظ الملخص كملاحظة لجهة الاتصال!",
        autoAiSummary: "ملخص تلقائي بالذكاء الاصطناعي عند الإغلاق",
      },
      confirmationModal: {
        buttons: {
          confirm: "موافق",
          cancel: "إلغاء",
        },
      },
      messageInput: {
        tooltip: {
          attach: "إرفاق ملف",
          signature: "تفعيل/تعطيل التوقيع",
          privateMessage: "تفعيل/تعطيل الرسالة الخاصة",
          meet: "إرسال رابط مؤتمر فيديو",
          triggerFlow: "تفعيل التدفق",
        },
        type: {
          imageVideo: "الصور والفيديوهات",
          cam: "الكاميرا",
          contact: "جهة الاتصال",
          meet: "مكالمة فيديو",
          template: "قالب ميتا",
        },
      },
      messageOptionsMenu: {
        delete: "حذف",
        reply: "رد",
        edit: "تعديل",
        forward: "إعادة توجيه",
        toForward: "إعادة توجيه",
        talkTo: "محادثة مع",
        react: "تفاعل",
        reactionSent: "تم إرسال التفاعل",
        confirmationModal: {
          title: "حذف الرسالة؟",
          message: "لا يمكن التراجع عن هذا الإجراء.",
        },
      },
      invoices: {
        table: {
          invoices: "الفواتير",
          details: "التفاصيل",
          users: "المستخدمون",
          connections: "الاتصالات",
          queue: "الطوابير",
          value: "القيمة",
          expirationDate: "تاريخ الاستحقاق",
          action: "الإجراء",
        },
      },
      backendErrors: {
        ERR_FLOW_AI_NO_KEY: "لم يتم تكوين مفتاح ذكاء اصطناعي. أضف المفتاح في الإعدادات > الذكاء الاصطناعي قبل إنشاء التدفقات.",
        ERR_FLOW_AI_SHORT_DESCRIPTION: "يرجى وصف التدفق بمزيد من التفصيل.",
        ERR_FLOW_AI_REQUEST_FAILED: "تعذر الوصول إلى الذكاء الاصطناعي. تحقق من المفتاح وحاول مرة أخرى.",
        ERR_FLOW_AI_INVALID_JSON: "أعاد الذكاء الاصطناعي استجابة غير صالحة. حاول إعادة صياغة الوصف.",
        ERR_FLOW_AI_EMPTY: "لم يتمكن الذكاء الاصطناعي من بناء تدفق من هذا الوصف. حاول إضافة مزيد من التفاصيل.",
        ERR_NO_OTHER_WHATSAPP:
          "يجب أن يكون هناك واتس اب افتراضي واحد على الأقل.",
        ERR_NO_DEF_WAPP_FOUND:
          "لم يتم العثور على واتس اب افتراضي. تحقق من صفحة الاتصالات.",
        ERR_WAPP_NOT_INITIALIZED:
          "جلسة الواتس اب هذه لم يتم تهيئتها. تحقق من صفحة الاتصالات.",
        ERR_WAPP_CHECK_CONTACT:
          "لا يمكن التحقق من جهة اتصال الواتس اب. تحقق من صفحة الاتصالات",
        ERR_WAPP_INVALID_CONTACT: "هذا ليس رقم واتس اب صالح.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "لا يمكن تحميل الوسائط من الواتس اب. تحقق من صفحة الاتصالات.",
        ERR_INVALID_CREDENTIALS: "خطأ في المصادقة. حاول مرة أخرى.",
        ERR_SENDING_WAPP_MSG:
          "خطأ في إرسال رسالة الواتس اب. تحقق من صفحة الاتصالات.",
        ERR_DELETE_WAPP_MSG: "لا يمكن حذف رسالة الواتس اب.",
        ERR_OTHER_OPEN_TICKET: "يوجد محادثة مفتوحة لجهة الاتصال هذه بالفعل.",
        ERR_SESSION_EXPIRED: "انتهت الجلسة. يرجى الدخول.",
        ERR_USER_CREATION_DISABLED: "تم تعطيل إنشاء المستخدم من قبل المدير.",
        ERR_NO_PERMISSION: "ليس لديك صلاحية للوصول لهذا المورد.",
        ERR_DUPLICATED_CONTACT: "يوجد جهة اتصال بهذا الرقم بالفعل.",
        ERR_NO_SETTING_FOUND: "لم يتم العثور على إعداد بهذا المعرف.",
        ERR_NO_CONTACT_FOUND: "لم يتم العثور على جهة اتصال بهذا المعرف.",
        ERR_NO_TICKET_FOUND: "لم يتم العثور على محادثة بهذا المعرف.",
        ERR_NO_USER_FOUND: "لم يتم العثور على مستخدم بهذا المعرف.",
        ERR_NO_WAPP_FOUND: "لم يتم العثور على واتس اب بهذا المعرف.",
        ERR_CREATING_MESSAGE: "خطأ في إنشاء الرسالة في قاعدة البيانات.",
        ERR_CREATING_TICKET: "خطأ في إنشاء المحادثة في قاعدة البيانات.",
        ERR_FETCH_WAPP_MSG:
          "خطأ في جلب الرسالة من الواتس اب، ربما تكون قديمة جداً.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "هذا اللون مستخدم بالفعل، اختر لوناً آخر.",
        ERR_WAPP_GREETING_REQUIRED:
          "رسالة الترحيب مطلوبة عند وجود أكثر من طابور واحد.",
        ERR_OUT_OF_HOURS: "خارج ساعات العمل!",
        ERR_TICKET_NO_LINKED_CONNECTION:
          "هذه المحادثة لا تحتوي على اتصال مرتبط، وربما تم حذف الاتصال.",
        ERR_PLAN_FEATURE_DISABLED: "هذه الميزة غير متاحة في خطتك الحالية. تواصل مع المسؤول للترقية.",
      },
      messagesAPIInstructions: {
        endpoint: "نقطة النهاية:",
        method: "الطريقة:",
        post: "POST",
        headers: "الرؤوس:",
        headerAuthorization:
          "Authorization Bearer (الرمز المسجل) و Content-Type (application/json)",
        body: "المحتوى:",
        fieldNumber: '"number": "966555999999"',
        fieldBody: '"body": "الرسالة"',
        fieldUserId: '"userId": معرف المستخدم أو ""',
        fieldQueueId: '"queueId": معرف الطابور أو ""',
        fieldSendSignature: '"sendSignature": توقيع الرسالة - true/false',
        fieldCloseTicket: '"closeTicket": إنهاء المحادثة - true/false',
        singMessage: "توقيع الرسالة - true/false",
        closeTicket: "إنهاء المحادثة - true/false",
        testSend: "اختبار الإرسال",
      },
      recurrenceSection: {
        title: "التكرار",
        description:
          "يمكنك اختيار إرسال الرسالة بشكل متكرر واختيار الفاصل الزمني. إذا كانت رسالة لإرسالها مرة واحدة، لا تغير شيئاً في هذا القسم.",
        labelInterval: "الفاصل الزمني",
        intervalFilterValue: "قيمة الفاصل الزمني",
        sendAsManyTimes: " إرسال كم مرة",
        shipNormallyOnNonbusinessDays: " إرسال عادي في الأيام غير العمل",
        sendOneBusinessDayBefore: "إرسال يوم عمل قبل",
        sendOneBusinessDayLater: "إرسال يوم عمل بعد",
        options: {
          days: "أيام",
          weeks: "أسابيع",
          months: "أشهر",
          minutes: "دقائق",
        },
      },
      servicePanel: {
        allowRealTime: "لوحة المحادثات",
      },
      financial: {
        invoices: "الفواتير",
        details: "التفاصيل",
        users: "المستخدمون",
        connections: "الاتصالات",
        queues: "الطوابير",
        value: "القيمة",
        expirationDate: "تاريخ الاستحقاق",
        status: "الحالة",
        action: "الإجراء",
      },
      statusFilter: {
        statusFilter: "تصفية حسب الحالة",
      },
      momentsUser: {
        services: "المحادثات:",
        pending: "معلقة",
        noqueue: "بدون طابور",
        total: "الإجمالي",
        inService: "قيد الخدمة",
        activeAgents: "الوكلاء النشطون",
        searchPlaceholder: "ابحث عن جهة اتصال أو رسالة أو وكيل...",
        allQueues: "جميع الطوابير",
        all: "الكل",
        refresh: "تحديث",
        fullscreen: "ملء الشاشة",
        exitFullscreen: "الخروج من ملء الشاشة",
        noTicketsForFilters: "لا توجد تذاكر للفلاتر الحالية.",
      },
      campaignsPhrase: {
        campaignsFlow: "تدفق الحملات",
        campaigns: "الحملات",
        name: "الاسم",
        status: "الحالة",
        newCampaignWithFlowByPhrase: "حملة جديدة مع تدفق بالعبارة",
        editCampaignWithFlowByPhrase: "تعديل حملة مع تدفق بالعبارة",
        phraseTriggerName: "اسم التفعيل بالعبارة",
        chooseAStream: "اختر تدفقاً",
        whichPhraseTriggersTheFlow: " أي عبارة تفعل التدفق؟",
        selectAConnection: " اختر اتصالاً",
        chooseAStream: " اختر تدفقاً",
        status: " الحالة",
        cancel: "إلغاء",
        createCampaign: "إنشاء حملة ",
        saveCampaign: "حفظ الحملة",
      },
      chatList: {
        noMessages: "لا توجد رسائل",
        admin: "المدير",
        member: "عضو",
        searchChat: "البحث في المحادثة...",
        createNewChat: "إنشاء محادثة جديدة",
        searchUser: "البحث عن مستخدم...",
        noUserFound: "لم يتم العثور على مستخدم",
        noUserAvailable: "لا يوجد مستخدم متاح",
        cancel: "إلغاء",
        details: "التفاصيل",
        deleteChat: "حذف المحادثة",
        deleteChatConfirm: "لا يمكن التراجع عن هذا الإجراء، تأكيد؟",
        detailsTitle: "التفاصيل",
        edit: "تعديل",
        delete: "حذف",
        now: "الآن",
        minutesAgo: "{{count}} د مضت",
        hoursAgo: "{{count}} س مضت",
      },
      chatMessages: {
        deleted: "تم حذف هذه الرسالة",
        deletedAdmin: "رسالة محذوفة - مرئية للمديرين فقط",
        reply: "رد",
        edit: "تعديل",
        delete: "حذف",
        forward: "إعادة توجيه",
        editMessage: "تعديل الرسالة",
        save: "حفظ",
        cancel: "إلغاء",
        deleteMessage: "حذف الرسالة",
        deleteMessageConfirm: "هل أنت متأكد من حذف هذه الرسالة؟",
        forwardMessage: "إعادة توجيه الرسالة",
        selectChat: "اختر المحادثة",
        doubleClickToReply: "انقر مرتين للرد",
        edited: "(معدلة)",
        forwarded: "(معاد توجيهها)",
        typeMessage: "اكتب رسالة...",
        send: "إرسال",
        noMessages: "لا توجد رسائل",
        loading: "جاري التحميل...",
        replyingTo: "رد على",
        clickToGoToOriginal: "انقر للذهاب للرسالة الأصلية",
      },
      chatPopover: {
        reply: "رد",
        edit: "تعديل",
        delete: "حذف",
        forward: "إعادة توجيه",
        cancel: "إلغاء",
        confirmDelete: "تأكيد الحذف",
        confirm: "تأكيد",
        deleteMessage: "هل أنت متأكد من حذف هذه الرسالة؟",
        editMessage: "تعديل الرسالة",
        save: "حفظ",
        forwardMessage: "إعادة توجيه الرسالة",
        selectChat: "اختر المحادثة",
        forward: "إعادة توجيه",
        noChats: "لا توجد محادثة متاحة",
      },
      chatIndex: {
        chats: "المحادثات",
        groups: "المجموعات",
        new: "جديد",
        messages: "الرسائل",
        search: "البحث...",
        noChats: "لا توجد محادثة",
        noGroups: "لا توجد مجموعة",
        noMessages: "لا توجد رسائل",
        loading: "جاري التحميل...",
        error: "خطأ في تحميل البيانات",
        addGroupPhoto: "إضافة صورة المجموعة",
        changeGroupPhoto: "تغيير صورة المجموعة",
        groupName: "اسم المجموعة",
        groupDescription: "وصف المجموعة",
        save: "حفظ",
        cancel: "إلغاء",
        createGroup: "إنشاء مجموعة",
        editGroup: "تعديل المجموعة",
        deleteGroup: "حذف المجموعة",
        deleteGroupConfirm: "هل أنت متأكد من حذف هذه المجموعة؟",
        edit: "تعديل",
        delete: "حذف",
        details: "التفاصيل",
        groupDetails: "تفاصيل المجموعة",
        title: "العنوان",
        description: "الوصف",
        editMessage: "تعديل الرسالة",
        messageLabel: "رسالة",
        modal: {
          title: "إنشاء مجموعة",
          editTitle: "تعديل المجموعة",
          name: "اسم المجموعة",
          description: "وصف المجموعة",
          create: "إنشاء",
          cancel: "إلغاء",
          save: "حفظ",
          edit: "تعديل",
        },
      },
      whitelabel: {
        primaryColorLight: "اللون الأساسي (المظهر الفاتح)",
        primaryColorDark: "اللون الأساسي (المظهر الداكن)",
        appName: "اسم التطبيق",
        logoLight: "الشعار (المظهر الفاتح)",
        logoDark: "الشعار (المظهر الداكن)",
        favicon: "الأيقونة المفضلة",
        logoMobile: "شعار الجوال (PWA)",
        backgroundLight: "صورة الخلفية (المظهر الفاتح)",
        backgroundDark: "صورة الخلفية (المظهر الداكن)",
        preview: "معاينة",
        delete: "حذف",
        upload: "رفع",
        availableLanguages: "اللغات المتاحة",
        atLeastOneLanguage: "يجب تفعيل لغة واحدة على الأقل",
        sections: {
          general: "الإعدادات العامة",
          generalDescription: "تكوين الاسم والمعلومات الأساسية للتطبيق",
          colors: "الألوان والمظاهر",
          colorsDescription: "تخصيص الألوان الأساسية للمظاهر الفاتحة والداكنة",
          logos: "الشعارات والصور",
          logosDescription: "رفع شعارات وصور خلفية التطبيق",
          languages: "اللغات المتاحة",
          languagesDescription: "اختر اللغات المتاحة في النظام",
        },
      },
      flowBuilder: {
        conversationFlows: "التدفقات",
        addImage: {
          title: "إضافة صورة إلى التدفق",
          editTitle: "تعديل الصورة",
          add: "إضافة",
          save: "حفظ",
          caption: "تعليق (اختياري)",
          uploadImage: "رفع صورة",
          successAdd: "تمت إضافة الصورة بنجاح!",
          fileTooLarge: "الملف كبير جداً! الحد الأقصى 2 ميجابايت",
          error: "خطأ",
        },
        addText: {
          title: "إضافة رسالة إلى التدفق",
          editTitle: "تعديل رسالة التدفق",
          add: "إضافة",
          save: "حفظ",
          message: "رسالة",
        },
        addAttendant: {
          title: "إضافة موظف إلى التدفق",
          editTitle: "تعديل الموظف",
          add: "إضافة",
          edit: "تعديل",
          chooseAttendant: "اختر موظفاً",
          selectUser: "اختر مستخدماً",
          addAttendant: "أضف موظفاً",
        },
        condition: {
          title: "شرط جديد",
          editTitle: "تعديل الشرط",
          variableField: "متغير / حقل",
          variablePlaceholder: "اكتب $ لرؤية المتغيرات المتاحة",
          variableHelper: "اكتب $ لإكمال متغيرات التدفق تلقائياً",
          conditionType: "نوع الشرط",
          comparisonValue: "قيمة المقارنة",
          commaSeparated: "قيم مفصولة بفاصلة",
          regexExample: "مثال: ^[0-9]{11}$ — تعبير منتظم JavaScript",
          anyTokenTrigger: "أي رمز في القائمة يُطلق صحيح",
          fixedOrVariable: "قيمة ثابتة أو متغير مع $",
          insertVariable: "إدراج متغير من المحدد",
          addCondition: "إضافة شرط",
          logicTrue: "المنطق: صحيح إذا",
          allConditions: "جميع الشروط",
          anyCondition: "أي شرط",
          satisfied: "تتحقق",
          quickTips: "💡 نصائح سريعة",
          tipContainsAny: "يحتوي على أي (,): افصل الرموز بفاصلة →",
          tipRegex: "Regex: استخدم تعبير JS →",
          tipVariable: "استخدم ${متغير} في أي حقل للإشارة إلى قيم ديناميكية",
          cancel: "إلغاء",
          saving: "جاري الحفظ...",
          saveChanges: "حفظ التغييرات",
          errorRequired: "حقل \"المتغير / الحقل\" مطلوب",
          errorComparisonRequired: "حقل \"قيمة المقارنة\" مطلوب",
          errorSave: "حدث خطأ أثناء الحفظ. حاول مرة أخرى.",
          selectVariable: "اختيار متغير",
          dynamicVarsFound: "متغير(ات) موجودة في التدفق",
          addVarNodes: "أضف عقد متغير عام أو إدخال للمتغيرات الديناميكية",
          searchVariable: "البحث عن متغير...",
          noVariableFound: "لم يتم العثور على متغير",
          flowVariables: "متغيرات التدفق",
          equals: "يساوي",
          notEquals: "لا يساوي",
          contains: "يحتوي على نص",
          notContains: "لا يحتوي",
          containsAny: "يحتوي على أي (,)",
          startsWith: "يبدأ بـ",
          endsWith: "ينتهي بـ",
          greaterThan: "أكبر من",
          lessThan: "أقل من",
          greaterOrEqual: "أكبر من أو يساوي",
          lessOrEqual: "أقل من أو يساوي",
          isEmpty: "فارغ",
          isNotEmpty: "ليس فارغاً",
          regex: "تعبير منتظم",
          equality: "مساواة",
          text: "نص",
          numeric: "رقمي",
          state: "حالة",
          advanced: "متقدم",
          contactName: "اسم جهة الاتصال",
          contactEmail: "بريد جهة الاتصال",
          contactPhone: "هاتف / رقم جهة الاتصال",
          lastMessage: "آخر رسالة مستلمة",
          ticketIdDesc: "معرف التذكرة الحالية",
          ticketStatusDesc: "حالة التذكرة (مفتوح/معلق/مغلق)",
          ticketQueueDesc: "قائمة انتظار التذكرة الحالية",
          ticketQueueIdDesc: "معرّف قائمة انتظار التذكرة الحالية",
          ticketConnectionDesc: "اسم اتصال (واتساب) التذكرة",
          ticketConnectionIdDesc: "معرّف اتصال (واتساب) التذكرة",
          ticketTagsDesc: "وسوم التذكرة (مفصولة بفواصل)",
          ticketIsOpenDesc: "التذكرة مفتوحة (true/false)",
          ticketIsClosedDesc: "التذكرة مغلقة (true/false)",
          ticketIsPendingDesc: "التذكرة معلقة (true/false)",
          ticketTransferredDesc: "تم تحويل التذكرة (true/false)",
          ticketUserIdDesc: "معرّف الوكيل المسؤول عن التذكرة",
          apiResponseDesc: "استجابة آخر طلب HTTP",
          contact: "جهة اتصال",
          ticket: "تذكرة",
          globalVariable: "متغير عام",
          capturedInput: "إدخال ملتقط",
          menu: "قائمة",
          httpApi: "HTTP / API",
          api: "API",
          globalVarDesc: "متغير عام للتدفق",
          userResponseDesc: "استجابة ملتقطة من المستخدم",
          responseFrom: "استجابة من:",
          menuResponse: "استجابة القائمة:",
          menuOption: "خيار القائمة:",
          mappedFrom: "مُعيَّن من:",
          httpVarDesc: "متغير استجابة HTTP",
          valuePrefix: "القيمة:",
        },
      },
      flowBuilderTicketModal: {
        addTitle: "إضافة تذكرة",
        editTitle: "تعديل تذكرة",
        chooseQueue: "اختيار القسم",
        selectConnection: "اختر اتصالاً",
        addQueueError: "اختر قسماً",
      },
      campaignModal: {
        followUp: {
          useApprovedTemplate: "استخدم قالباً معتمداً",
          noSimpleTemplate: "لا يتوفر قالب بسيط",
          selectApprovedTemplate: "اختر قالباً معتمداً",
          simpleTemplateHelper: "تظهر هنا فقط القوالب المعتمدة بدون متغيرات. وسائط الرأس (إن وجدت) جزء من القالب.",
          metaRestrictionTitle: "قيود ميتا — نافذة 24 ساعة",
          metaRestrictionBody: "لقد ملأت رسائل إضافية (2-5) في حملة API الرسمي. تسمح ميتا بإرسال هذه الرسائل فقط بعد رد العميل على القالب الأولي، وضمن نافذة 24 ساعة.",
          metaRestrictionEnableHint: "فعّل مفتاح \"إرسال رسالة بعد القالب\" أدناه، وإلا لن يتم إرسال الرسائل 2-5.",
        },
        validation: {
          tooShort: "!قصير جداً",
          tooLong: "!طويل جداً",
          required: "مطلوب",
          recurrenceTypeRequired: "نوع التكرار مطلوب",
          intervalMin: "يجب أن يكون الفاصل أكبر من 0",
          intervalRequired: "الفاصل مطلوب",
          selectDay: "حدد يوماً واحداً على الأقل من الأسبوع",
          dayRange: "يجب أن يكون اليوم بين 1 و 31",
          dayRequired: "يوم الشهر مطلوب",
          endDateFuture: "يجب أن يكون تاريخ الانتهاء في المستقبل",
          maxExecMin: "يجب أن يكون الحد الأقصى أكبر من 0",
          noneValue: "لا شيء",
        },
        tabs: {
          campaign: "حملة",
          contactLists: "📋 قوائم جهات الاتصال",
          settings: "⚙️ الإعدادات",
        },
        recurrence: {
          title: "إعدادات التكرار",
          enable: "تفعيل التكرار",
          type: "نوع التكرار",
          interval: "الفاصل الزمني",
          dayOfMonth: "يوم الشهر",
          dayOfMonthHelper: "يوم محدد من الشهر (1-31)",
          endDate: "تاريخ الانتهاء (اختياري)",
          endDateHelper: "اتركه فارغاً للتكرار اللانهائي",
          maxExecutions: "الحد الأقصى للتنفيذات (اختياري)",
          maxExecutionsHelper: "اتركه فارغاً للتكرار اللانهائي",
          showExecutions: "عرض",
          hideExecutions: "إخفاء",
          nextExecutions: "التنفيذات القادمة",
          next5: "التنفيذات الخمس القادمة:",
          nthExecution: " تنفيذ",
          minutely: "كل X دقيقة",
          hourly: "كل X ساعة",
          daily: "يومي",
          weekly: "أسبوعي",
          biweekly: "نصف شهري",
          monthly: "شهري",
          yearly: "سنوي",
        },
        days: {
          sunday: "الأحد",
          monday: "الإثنين",
          tuesday: "الثلاثاء",
          wednesday: "الأربعاء",
          thursday: "الخميس",
          friday: "الجمعة",
          saturday: "السبت",
        },
        message: {
          title: "رسالة الحملة",
          variables: {
            name: "الاسم",
            number: "الرقم",
            email: "البريد",
            greeting: "التحية",
            protocol: "البروتوكول",
            firstName: "الاسم الأول",
            attendant: "الموظف",
          },
          helperText: "استخدم المتغيرات مثل {الاسم}، {الرقم}، {البريد} أو حدد متغيرات مخصصة.",
          oficialNotAvailable: "لـ API الرسمي، استخدم القالب المحدد في الجانب. حقل الرسالة ومرفق الوسائط غير متاحين.",
          attachMedia: "إرفاق وسائط",
          preview: "معاينة",
        },
        template: {
          label: "القالب *",
          noTemplates: "لم يتم العثور على قالب معتمد. أنشئ قالباً قبل الإرسال.",
          helperText: "مطلوب لـ API الرسمي. الرسائل بدون قالب تفشل خارج نافذة 24 ساعة.",
          selectTemplate: "اختر قالباً معتمداً لحملات API الرسمي.",
        },
        contactList: {
          title: "📋 قائمة جهات اتصال الحملة",
          description: "اختر قائمة تم إنشاؤها في علامة التبويب \"📋 قوائم جهات الاتصال\". تحدد القائمة من سيتلقى رسائل الحملة.",
          label: "قائمة جهات الاتصال",
          noList: "لم يتم تحديد قائمة",
          contacts: "جهات اتصال",
          filterByTag: "تصفية حسب العلامة (اختياري)",
          noTagFilter: "بدون تصفية بالعلامة",
          switchList: "تغيير القائمة → الذهاب إلى قوائم جهات الاتصال",
          createOrSelect: "+ إنشاء أو اختيار قائمة في علامة تبويب قوائم جهات الاتصال",
        },
        triggerSettings: {
          title: "فترات الإرسال",
          description: "قم بتكوين الفترات الزمنية بين عمليات إرسال الحملة لتجنب الحظر.",
          antiBan: "مكافحة الحظر",
          antiBanDesc: "يضفي الطابع البشري على الإرسال لتقليل خطر الحظر",
          jitterLabel: "تباين عشوائي (jitter)",
          jitterFixed: "ثابت",
          jitterMax: "الحد الأقصى",
          jitterBase: "القاعدة",
          jitterBetween: "بين",
          jitterAnd: "و",
          selectBaseInterval: "⚠️ اختر فترة أساسية أعلاه",
          extraPause: "توقف إضافي كل N رسالة",
          extraPauseDuration: "مدة التوقف الإضافي",
          disabled: "معطل",
          every10: "كل 10 رسائل",
          every20: "كل 20 رسالة",
          every30: "كل 30 رسالة",
          every50: "كل 50 رسالة",
          every100: "كل 100 رسالة",
          seconds: "ثواني",
          minute1: "دقيقة واحدة",
          minutes2: "دقيقتان",
          minutes5: "5 دقائق",
          savedSuccess: "تم حفظ الإعدادات بنجاح!",
          saveSettings: "حفظ الإعدادات",
        },
      },
      chatMessages: {
        user: "مستخدم",
        today: "اليوم",
        loadingOldMessages: "جاري تحميل الرسائل القديمة...",
        viewDocument: "عرض المستند",
        doubleClickReply: "انقر نقراً مزدوجاً للرد",
        messageLabel: "رسالة",
        messageNotFound: "[رسالة غير موجودة]",
      },
      finalizacaoAtendimento: {
        title: "إنهاء الخدمة", generalSettings: "إعدادات عامة",
        informSaleValue: "إبلاغ قيمة البيع عند إنهاء الخدمة",
        informSaleValueHelper: "عند التفعيل، سيظهر حقل قيمة البيع في نافذة الإنهاء",
        finalizationReasons: "أسباب الإنهاء", addReason: "إضافة سبب",
        name: "الاسم", description: "الوصف", actions: "الإجراءات",
        noDescription: "بدون وصف", noReasons: "لا توجد أسباب مسجلة.",
        editReason: "تعديل السبب", reasonName: "اسم السبب", descriptionOptional: "الوصف (اختياري)",
        cancel: "إلغاء", saving: "جاري الحفظ...", update: "تحديث", add: "إضافة",
        nameRequired: "اسم السبب مطلوب", reasonUpdated: "تم تحديث السبب بنجاح!",
        reasonCreated: "تم إنشاء السبب بنجاح!", reasonSaveError: "خطأ في حفظ السبب",
        confirmDelete: "هل أنت متأكد من حذف هذا السبب؟", reasonDeleted: "تم حذف السبب بنجاح!",
        reasonDeleteError: "خطأ في حذف السبب", settingUpdated: "تم تحديث الإعداد بنجاح!",
        settingUpdateError: "خطأ في تحديث الإعداد", currencyUpdated: "تم تحديث العملة بنجاح!",
        currencyUpdateError: "خطأ في تحديث العملة",
      },
      interactiveMessage: {
        tabs: { buttons: "أزرار", list: "قائمة", billing: "فوترة", offers: "عروض", pix: "PIX", url: "رابط", call: "اتصال", location: "موقع", carousel: "كاروسيل", catalog: "كتالوج", poll: "استطلاع" },
        select: "اختيار", options: "خيارات", reviewAndPay: "مراجعة ودفع",
        templateLoaded: "تم تحميل القالب \"{{name}}\"", templateNameRequired: "أدخل اسماً للقالب",
        templateSaved: "تم حفظ القالب!", templateSaveError: "خطأ في حفظ القالب",
        templateRemoved: "تمت إزالة القالب", templateRemoveError: "خطأ في الإزالة",
        fillMessageText: "املأ نص الرسالة", addAtLeastOneButton: "أضف زراً واحداً على الأقل",
        addAtLeastOneListOption: "أضف خياراً واحداً على الأقل", fillLatLong: "املأ خط العرض والطول",
        fillUrl: "املأ الرابط", fillPhone: "املأ رقم الهاتف", fillPixKey: "املأ مفتاح PIX",
        addAtLeast2Options: "أضف خيارين على الأقل", addAtLeastOneCard: "أضف بطاقة واحدة على الأقل",
        fillBillingDescription: "املأ وصف الفاتورة", pdfUploadError: "خطأ في رفع PDF",
        messageSent: "تم إرسال الرسالة التفاعلية!", sendError: "خطأ في الإرسال",
        buttonsInfo: "أرسل حتى 3 أزرار قابلة للنقر.", messageText: "نص الرسالة *",
        footerOptional: "تذييل (اختياري)", buttonsMax3: "أزرار (حد أقصى 3)", addButton: "إضافة",
        optionPlaceholder: "خيار {{number}}", save: "حفظ", cancel: "إلغاء", send: "إرسال", sending: "جاري الإرسال...",
        saveTemplate: "حفظ كقالب", templateNameLabel: "اسم القالب", saveTemplateBtn: "حفظ القالب",
        noTemplates: "لا توجد قوالب محفوظة", templates: "القوالب", deleteTemplate: "حذف القالب",
        listInfo: "أرسل قائمة بحتى 10 خيارات.", buttonText: "نص الزر",
        sectionTitle: "عنوان القسم", titleLabel: "العنوان", descriptionLabel: "الوصف", addOption: "إضافة خيار",
        offerInfo: "أرسل عرضاً.", offerTitle: "عنوان العرض", bodyDescription: "الوصف / نص الرسالة *",
        price: "السعر", additionalDetails: "تفاصيل إضافية",
        pixInfo: "أرسل بيانات PIX.", pixKey: "مفتاح PIX *", pixKeyPlaceholder: "CPF أو بريد إلكتروني أو هاتف",
        beneficiaryName: "اسم المستفيد", city: "المدينة", amount: "المبلغ",
        urlInfo: "أرسل رابطاً قابلاً للنقر.", linkText: "نص الرابط", linkTextPlaceholder: "انقر هنا",
        urlLabel: "الرابط *", urlPlaceholder: "https://...",
        callInfo: "أرسل رسالة مع رقم للاتصال.", callButtonText: "نص الزر", callButtonPlaceholder: "اتصل الآن",
        phoneNumber: "رقم الهاتف *", locationInfo: "أرسل موقعاً.", locationName: "اسم المكان", address: "العنوان",
        latitude: "خط العرض *", longitude: "خط الطول *",
        carouselInfo: "أرسل بطاقات متعددة.", cardLabel: "بطاقة {{number}}", addCard: "إضافة بطاقة",
        catalogInfo: "أرسل منتجات.", productLabel: "منتج {{number}}", productName: "اسم المنتج",
        priceDescription: "الوصف / السعر", addProduct: "إضافة منتج",
        pollInfo: "أنشئ استطلاعاً.", pollQuestion: "سؤال الاستطلاع *", pollOptionsLabel: "خيارات (حد أدنى 2، حد أقصى 12)",
        billingInfo: "أرسل فاتورة.", billingNumber: "رقم الفاتورة", billingDescription: "وصف الفاتورة *",
        quantity: "الكمية", totalAmount: "المبلغ الإجمالي", billingMessage: "رسالة إضافية",
        paymentUrl: "رابط الدفع (اختياري)", paymentButtonText: "نص زر الدفع", attachPdf: "إرفاق PDF",
      },
      flowBuilderInteractive: {
        title: "رسالة تفاعلية (Baileys)", editTitle: "تعديل الرسالة التفاعلية",
        add: "إضافة", save: "حفظ", cancel: "إلغاء",
        messageType: "نوع الرسالة التفاعلية", buttonsMax3: "أزرار (حد أقصى 3)",
        infoText: "أزرار تفاعلية عبر Baileys. تعمل على الاتصالات غير الرسمية. حد أقصى 3 أزرار.",
        messageContent: "محتوى الرسالة", buttonsTab: "الأزرار",
        messageBody: "نص الرسالة", footerOptional: "تذييل (اختياري)",
        headerImageOptional: "صورة العنوان (اختياري)", changeImage: "تغيير الصورة", uploadImage: "رفع صورة",
        listButtonText: "نص زر القائمة", listButtonHelper: "النص المعروض على الزر الذي يفتح القائمة",
        preview: "معاينة", messageBodyPlaceholder: "نص الرسالة...",
        buttonsLabel: "الأزرار", listOptions: "خيارات القائمة",
        buttonTextPlaceholder: "نص الزر {{number}}", optionPlaceholder: "خيار {{number}}",
        addAtLeastOneOption: "أضف خياراً واحداً على الأقل.",
        bodyRequired: "نص الرسالة مطلوب!", addOption: "أضف خياراً واحداً على الأقل!",
        fileTooLarge: "الملف كبير جداً! الحد الأقصى 2MB",
        imageUploadError: "خطأ في رفع الصورة", maxOptionsReached: "الحد الأقصى {{max}} خيارات للأزرار!",
        officialOnlyBanner: "⚠ الميزات المتقدمة (CTA، Flow، الكتالوج، العرض الدوار) تتطلب WhatsApp API الرسمي (Meta Cloud). الأزرار والقوائم تعمل على القناتين.",
        flowOnlyOfficial: "WhatsApp Flows يتطلب قناة API الرسمية (Meta).",
        typeButton: "أزرار الرد السريع",
        typeList: "قائمة تفاعلية",
        typeCtaUrl: "CTA - فتح رابط",
        typeCtaCall: "CTA - اتصال",
        typeFlow: "WhatsApp Flow (API الرسمي فقط)",
        typeCatalog: "كتالوج المنتجات",
        typeCarousel: "عرض دوار للمنتجات",
        typeDescButton: "حتى 3 أزرار للرد السريع. استخدمها للأسئلة ذات الخيارات القليلة. تعمل على Baileys و API الرسمي.",
        typeDescList: "قائمة تحتوي على ما يصل إلى 10 خيارات. تعمل على Baileys و API الرسمي.",
        typeDescCtaUrl: "زر واحد يفتح رابطاً خارجياً. API الرسمي فقط.",
        typeDescCtaCall: "زر واحد يبدأ مكالمة هاتفية. API الرسمي فقط.",
        typeDescFlow: "نموذج تفاعلي أصلي من WhatsApp (Flows) معد في Meta Business. API الرسمي فقط.",
        typeDescCatalog: "إرسال منتج أو الكتالوج المسجل في Meta Commerce. API الرسمي فقط.",
        typeDescCarousel: "عدة بطاقات قابلة للتمرير بصورة وعنوان ووصف وزر. API الرسمي فقط.",
        ctaButtonText: "نص الزر", ctaUrl: "رابط URL", ctaPhone: "الهاتف (مع رمز الدولة)",
        ctaUrlPlaceholder: "مثال: فتح الموقع", ctaCallPlaceholder: "مثال: اتصل الآن",
        flowId: "Flow ID", flowToken: "Flow Token (اختياري)", flowCta: "نص الزر (CTA)", flowScreen: "الشاشة الأولية",
        catalogId: "Catalog ID", catalogProductId: "المنتج المميز (retailer_id، اختياري)",
        carouselCards: "بطاقات العرض الدوار", addCard: "إضافة بطاقة",
        cardTitle: "العنوان", cardDescription: "الوصف", cardImageUrl: "رابط الصورة (اختياري)",
        cardButtonText: "نص الزر", cardButtonId: "معرف الزر", cardLabel: "بطاقة",
        ctaTextRequired: "أدخل نص الزر والرابط", callTextRequired: "أدخل نص الزر والهاتف",
        flowFieldsRequired: "أدخل Flow ID و CTA", catalogIdRequired: "أدخل معرف الكتالوج",
        carouselCardsRequired: "أضف بطاقة واحدة على الأقل", maxCards: "الحد الأقصى 10 بطاقات",
        pixBoxInfo: "يرسل زر 'نسخ رمز PIX' الأصلي مع رمز النسخ واللصق.",
        pixReuseTitle: "أعد الاستخدام في عدة فواتير:",
        pixReuseSubtitle: "استخدم المتغيرات في النص (أعلاه) وفي الحقول أدناه.",
        pixFlowVars: "متغيرات التدفق (ملتقطة/Webhook):",
        pixTicketVars: "متغيرات المحادثة:",
        pixCopyPasteLabel: "رمز PIX للنسخ واللصق",
        pixButtonTextLabel: "نص الزر",
        pixNameLabel: "اسم المستفيد (اختياري)",
        pixAmountLabel: "المبلغ (اختياري)",
        pixQrCodeLabel: "إرسال رمز QR (صورة) مع الزر",
        pixDocBoxInfo: "📄 أرفق ملف PDF (فاتورة) كرأس + زر 'نسخ مفتاح Pix' في نفس الفقاعة.",
        pixTotalLabel: "الإجمالي المعروض (اختياري)",
        pixDocUrlLabel: "رابط ملف PDF (فاتورة)",
        pixDocNameLabel: "اسم الملف (اختياري)",
      },
      flowBuilderVideo: {
        title: "إضافة فيديو للتدفق", editTitle: "تعديل الفيديو",
        add: "إضافة", save: "حفظ", captionOptional: "تعليق (اختياري)",
        uploadVideo: "رفع فيديو", mp4Only: "تنبيه! فيديوهات MP4 فقط!",
        videoAdded: "تمت إضافة الفيديو بنجاح!", fileTooLarge: "الملف كبير جداً! الحد الأقصى 20MB",
        browserNotSupported: "متصفحك لا يدعم HTML5",
      },
      flowBuilderInput: {
        addTitle: "إضافة إدخال للتدفق",
        title: "إضافة إدخال للتدفق", editTitle: "تعديل إدخال التدفق",
        add: "إضافة", saveChanges: "حفظ التغييرات",
        question: "السؤال", questionTooltip: "السؤال الذي سيُرسل للمستخدم.",
        questionLabel: "اكتب السؤال", typeQuestion: "اكتب السؤال",
        questionPlaceholder: "مثال: مرحباً، كم عمرك؟",
        flowVariables: "متغيرات التدفق (انقر للإدراج):",
        variableName: "اسم المتغير", variableNameTooltip: "اسم المتغير حيث سيتم تخزين الإجابة.",
        variableTooltip: "اسم المتغير حيث سيتم تخزين الإجابة.",
        variableNameLabel: "اسم المتغير", variableNamePlaceholder: "مثال: عمر_العميل",
        variablePlaceholder: "مثال: عمر_العميل",
        variableNameHelper: "سيتم تخزين إجابة المستخدم في هذا المتغير",
        variableHelper: "سيتم تخزين إجابة المستخدم في هذا المتغير",
        howItWorks: "كيف يعمل", howItWorksDescription: "سيرسل هذا العقدة السؤال للمستخدم وينتظر الرد.",
        howItWorksDesc: "سيرسل هذا العقدة السؤال للمستخدم وينتظر الرد.",
        examples: { name: "اسم العميل", email: "بريد العميل", phone: "هاتف العميل", city: "مدينة العميل" },
        exampleVars: { nome: "اسم العميل", email: "بريد العميل", telefone: "هاتف العميل", cidade: "مدينة العميل" },
      },
      flowBuilderTag: {
        addTitle: "إضافة وسم للتدفق", editTitle: "تعديل الوسم",
        chooseTag: "اختر وسماً", selectTag: "حدد وسماً", noTagSelected: "لم يتم تحديد وسم",
        addTag: "أضف وسماً", add: "إضافة", edit: "تعديل",
      },
      flowBuilderSingleBlock: {
        addTitle: "إضافة محتوى للتدفق", editTitle: "تعديل المحتوى",
        addMenu: "إضافة قائمة للتدفق", add: "إضافة", save: "حفظ",
        image: "صورة", uploadImage: "رفع صورة", captionOptional: "تعليق (اختياري)",
        audio: "صوت", uploadAudio: "رفع صوت", sendAsRecorded: "إرسال كصوت مسجل مباشرة",
        video: "فيديو", uploadVideo: "رفع فيديو", text: "نص", message: "رسالة",
        interval: "فترة", timeInSeconds: "الوقت بالثواني",
        document: "مستند", uploadDocument: "رفع مستند", viewDocument: "عرض المستند",
        contentAdded: "تمت إضافة المحتوى بنجاح!", deleteEmptyCards: "احذف البطاقات الفارغة",
        emptyMessageFields: "حقول الرسالة فارغة!", intervalInvalid: "الفترة لا يمكن أن تكون 0 أو أكثر من 120!",
        fileTooLargeImg: "الملف كبير جداً! 2MB كحد أقصى", fileTooLargeAudio: "الملف كبير جداً! 5MB كحد أقصى",
        fileTooLargeVideo: "الملف كبير جداً! 20MB كحد أقصى", fileTooLargeDoc: "الملف كبير جداً! 10MB كحد أقصى",
        browserNotSupported: "متصفحك لا يدعم HTML5",
        variableLabels: { firstName: "الاسم الأول", name: "الاسم", userName: "الموظف", ms: "التحية", protocol: "البروتوكول", date: "التاريخ", hour: "الساعة", ticket_id: "رقم التذكرة", queue: "القسم", connection: "الاتصال", phoneNumber: "الهاتف", email: "البريد", kanban: "كانبان" },
      },
      flowBuilderGemini: {
        title: "إضافة Gemini للتدفق", editTitle: "تعديل Gemini",
        add: "إضافة", save: "حفظ", cancel: "إلغاء",
        basicSettings: "الإعدادات الأساسية - Google Gemini",
        assistantName: "اسم المساعد", apiKey: "مفتاح API Google AI", model: "نموذج Gemini",
        systemPrompt: "موجه النظام", systemPromptPlaceholder: "صف كيف يجب أن يتصرف الذكاء الاصطناعي...",
        temperature: "الحرارة", temperatureHelper: "0 = محافظ، 2 = إبداعي",
        maxTokens: "الحد الأقصى للرموز", maxTokensHelper: "الحد الأقصى لحجم الرد",
        maxMessages: "الحد الأقصى للرسائل", maxMessagesHelper: "سجل السياق",
        flowBehavior: "سلوك التدفق", flowBehaviorTooltip: "إعداد سلوك Gemini في التدفق",
        operationMode: "وضع التشغيل",
        permanent: "دائم", permanentDesc: "إنهاء التدفق هنا", permanentHelper: "يستمر المستخدم بالمحادثة مع الذكاء الاصطناعي",
        temporary: "مؤقت", temporaryDesc: "يعود للتدفق بعد ذلك", temporaryHelper: "ينفذ الذكاء الاصطناعي مهمة محددة ثم يعود",
        temporarySettings: "إعدادات الوضع المؤقت", temporarySettingsDesc: "إعداد متى يجب أن يتوقف الذكاء الاصطناعي",
        maxInteractions: "الحد الأقصى للتفاعلات", maxInteractionsHelper: "الحد الأقصى للرسائل قبل العودة للتدفق",
        timeout: "المهلة (دقائق)", timeoutHelper: "حد زمني قبل العودة للتدفق",
        continueKeywords: "كلمات مفتاحية لمتابعة التدفق", keywordPlaceholder: "اكتب كلمة مفتاحية",
        addKeyword: "إضافة", keywordsHelper: "عندما يرسل المستخدم إحدى هذه الكلمات، سيستمر التدفق",
        objective: "هدف الذكاء الاصطناعي", objectiveHelper: "صف ما يجب أن يكمله الذكاء الاصطناعي",
        objectivePlaceholder: "مثال: جمع بيانات العميل...",
        autoComplete: "إكمال تلقائي عند تحقيق الهدف", autoCompleteHelper: "سيحلل الذكاء الاصطناعي تلقائياً ما إذا أكمل الهدف",
        validation: { tooShort: "قصير جداً!", tooLong: "طويل جداً!", required: "مطلوب", describeTraining: "صف التدريب للذكاء الاصطناعي", invalidModel: "نموذج غير صالح", informModel: "أبلغ عن النموذج", minTokens: "الحد الأدنى 10 رموز", maxTokens: "الحد الأقصى 8000 رمز", informMaxTokens: "أبلغ عن الحد الأقصى للرموز", minTemp: "الحد الأدنى 0", maxTemp: "الحد الأقصى 2", informTemp: "أبلغ عن الحرارة", informApiKey: "أبلغ عن مفتاح API", minMessages: "رسالة واحدة كحد أدنى", maxMessages: "100 رسالة كحد أقصى", informMaxMessages: "أبلغ عن الحد الأقصى للرسائل", invalidFlowMode: "وضع تدفق غير صالح", selectFlowMode: "حدد وضع التدفق", minInteraction: "تفاعل واحد كحد أدنى", maxInteraction: "50 تفاعل كحد أقصى", minTimeout: "دقيقة واحدة كحد أدنى", maxTimeout: "60 دقيقة كحد أقصى", keywordRequired: "الكلمة المفتاحية لا يمكن أن تكون فارغة", atLeastOneKeyword: "كلمة مفتاحية واحدة على الأقل مطلوبة في الوضع المؤقت", objectiveRequired: "الهدف مطلوب عند تفعيل الإكمال التلقائي" },
      },
      flowBuilderOpenAI: {
        title: "إضافة OpenAI للتدفق", editTitle: "تعديل OpenAI",
        add: "إضافة", save: "حفظ", cancel: "إلغاء",
        basicSettings: "الإعدادات الأساسية - OpenAI",
        assistantName: "اسم المساعد", apiKey: "مفتاح API OpenAI", model: "نموذج OpenAI",
        systemPrompt: "موجه النظام", systemPromptPlaceholder: "صف كيف يجب أن يتصرف الذكاء الاصطناعي...",
        temperature: "الحرارة", temperatureHelper: "0 = محافظ، 2 = إبداعي",
        maxTokens: "الحد الأقصى للرموز", maxTokensHelper: "الحد الأقصى لحجم الرد",
        maxMessages: "الحد الأقصى للرسائل", maxMessagesHelper: "سجل السياق",
        voiceSettings: "إعدادات الصوت (اختياري)", responseType: "نوع الاستجابة", textOnly: "نص فقط",
        voiceKeyLabel: "Voice Key (Azure)", voiceKeyPlaceholder: "مفتاح خدمة Azure Speech",
        voiceRegionLabel: "Voice Region (Azure)", voiceRegionPlaceholder: "مثال: brazilsouth",
        flowBehavior: "سلوك التدفق", flowBehaviorTooltip: "إعداد سلوك OpenAI في التدفق",
        operationMode: "وضع التشغيل",
        permanent: "دائم", permanentDesc: "إنهاء التدفق هنا", permanentHelper: "يستمر المستخدم بالمحادثة مع الذكاء الاصطناعي",
        temporary: "مؤقت", temporaryDesc: "يعود للتدفق بعد ذلك", temporaryHelper: "ينفذ الذكاء الاصطناعي مهمة محددة ثم يعود",
        temporarySettings: "إعدادات الوضع المؤقت", temporarySettingsDesc: "إعداد متى يجب أن يتوقف الذكاء الاصطناعي",
        maxInteractions: "الحد الأقصى للتفاعلات", maxInteractionsHelper: "الحد الأقصى للرسائل قبل العودة للتدفق",
        timeout: "المهلة (دقائق)", timeoutHelper: "حد زمني قبل العودة للتدفق",
        continueKeywords: "كلمات مفتاحية لمتابعة التدفق", keywordPlaceholder: "اكتب كلمة مفتاحية",
        addKeyword: "إضافة", keywordsHelper: "عندما يرسل المستخدم إحدى هذه الكلمات، سيستمر التدفق",
        objective: "هدف الذكاء الاصطناعي", objectiveHelper: "صف ما يجب أن يكمله الذكاء الاصطناعي",
        objectivePlaceholder: "مثال: جمع بيانات العميل...",
        autoComplete: "إكمال تلقائي عند تحقيق الهدف", autoCompleteHelper: "سيحلل الذكاء الاصطناعي تلقائياً ما إذا أكمل الهدف",
        validation: { tooShort: "قصير جداً!", tooLong: "طويل جداً!", required: "مطلوب", describeTraining: "صف التدريب للذكاء الاصطناعي", invalidModel: "نموذج غير صالح", informModel: "أبلغ عن النموذج", minTokens: "الحد الأدنى 10 رموز", maxTokens: "الحد الأقصى 4000 رمز", informMaxTokens: "أبلغ عن الحد الأقصى للرموز", minTemp: "الحد الأدنى 0", maxTemp: "الحد الأقصى 2", informTemp: "أبلغ عن الحرارة", informApiKey: "أبلغ عن مفتاح API", minMessages: "رسالة واحدة كحد أدنى", maxMessages: "100 رسالة كحد أقصى", informMaxMessages: "أبلغ عن الحد الأقصى للرسائل", informVoice: "أبلغ عن وضع الصوت", voiceKeyRequired: "Voice Key مطلوب لتركيب الصوت", voiceRegionRequired: "Voice Region مطلوب لتركيب الصوت", invalidFlowMode: "وضع تدفق غير صالح", selectFlowMode: "حدد وضع التدفق", minInteraction: "تفاعل واحد كحد أدنى", maxInteraction: "50 تفاعل كحد أقصى", minTimeout: "دقيقة واحدة كحد أدنى", maxTimeout: "60 دقيقة كحد أقصى", keywordRequired: "الكلمة المفتاحية لا يمكن أن تكون فارغة", atLeastOneKeyword: "كلمة مفتاحية واحدة على الأقل مطلوبة في الوضع المؤقت", objectiveRequired: "الهدف مطلوب عند تفعيل الإكمال التلقائي" },
      },
      queueModalExtra: { none: "لا شيء" },
      validation: { tooShort: "قصير جداً!", tooLong: "طويل جداً!", required: "مطلوب", messageTooShort: "رسالة قصيرة جداً", nameTooShort: "اسم قصير جداً" },
      
    embeddedSignup: {
      title: "تسجيل WhatsApp المضمن",
      subtitle: "سجّل رقمك مباشرة من نظام إدارة العملاء",
      steps: { configure: "إعداد", processing: "معالجة", result: "النتيجة" },
      description: "انقر على الزر أدناه لبدء عملية تسجيل رقم WhatsApp Business الخاص بك مباشرة عبر Meta.",
      connectionName: "اسم الاتصال",
      connectionNamePlaceholder: "مثال: واتساب الرئيسي",
      infoTitle: "ماذا يحدث:",
      infoItems: { popup: "سيتم فتح نافذة Meta منبثقة", login: "ستقوم بتسجيل الدخول بحساب Facebook Business الخاص بك", select: "ستختار أو تنشئ حساب WhatsApp Business", register: "سيتم تسجيل الرقم تلقائيًا في نظام إدارة العملاء" },
      buttons: { loadingSdk: "جارٍ تحميل SDK...", processing: "جارٍ المعالجة...", start: "بدء التسجيل عبر Meta", close: "إغلاق", cancel: "إلغاء" },
      success: { title: "تم إنشاء الاتصال بنجاح!", name: "الاسم", number: "الرقم", numberPending: "سيتم عرضه قريبًا", wabaId: "WABA ID", status: "الحالة" },
      errors: { title: "خطأ في التسجيل", noAppId: "لم يتم تكوين App ID الخاص بـ Meta!", noConfigId: "لم يتم تكوين Configuration ID الخاص بـ Meta!", noName: "يرجى إدخال اسم للاتصال!", sdkNotLoaded: "لم يتم تحميل SDK الخاص بـ Meta بشكل صحيح. أعد تحميل الصفحة وحاول مرة أخرى.", sdkInitFailed: "فشل في تهيئة SDK الخاص بـ Meta.", sdkLoadFailed: "فشل في تحميل SDK الخاص بـ Meta. قم بتعطيل أدوات الحظر والسماح بالنوافذ المنبثقة.", sdkNotAvailable: "SDK الخاص بـ Facebook غير متوفر في المتصفح.", appIdNotConfigured: "لم يتم تكوين App ID الخاص بـ Meta! انتقل إلى الإعدادات > تكامل Meta.", configIdNotConfigured: "لم يتم تكوين Configuration ID الخاص بـ Meta! انتقل إلى الإعدادات > تكامل Meta.", timeout: "انتهت المهلة. قد يكون المتصفح قد حظر نافذة Meta المنبثقة. اسمح بالنوافذ المنبثقة وحاول مرة أخرى.", noAuthCode: "لم يتم استلام رمز التفويض. تحقق من أذونات التطبيق.", cancelled: "تم إلغاء العملية من قبل المستخدم.", signupError: "خطأ أثناء عملية التسجيل.", processingError: "خطأ في معالجة التسجيل. حاول مرة أخرى.", popupError: "خطأ في فتح نافذة Meta المنبثقة. تحقق من السماح بالنوافذ المنبثقة.", loginCancelled: "تم إلغاء تسجيل الدخول أو غير مصرح به.", metaStatus: "أرجعت Meta الحالة:" },
      processing: { title: "جارٍ معالجة التسجيل...", description: "نقوم بتبادل بيانات الاعتماد مع Meta وإعداد اتصالك." },
      menuItem: "تسجيل WhatsApp المضمن",
    },
    },
    flowBuilderConditionModal: { addTitle: "إضافة شرط إلى التدفق", editTitle: "تعديل الشرط", add: "إضافة", save: "حفظ", conditionField: "حقل الشرط (أدخل مفتاح واحد فقط)", validationRule: "قاعدة التحقق", conditionValue: "قيمة الشرط للتحليل" },
    flowBuilderTypebot: { addTitle: "إضافة Typebot إلى التدفق", editTitle: "تعديل Typebot في التدفق", add: "إضافة", edit: "تعديل", save: "حفظ" },
    flowBuilderSwitchFlow: { addTitle: "إضافة تبديل تدفق", editTitle: "تعديل تبديل التدفق", add: "إضافة", edit: "تعديل", save: "حفظ", chooseFlow: "اختر تدفق" },
    flowBuilderRandomizer: { add: "إضافة", edit: "تعديل" },
    flowBuilderRandomizerModal: { addTitle: "إضافة عشوائي للتدفق", editTitle: "تعديل العشوائي", addIntervalError: "النسبة يجب أن تكون أكبر من 0", maxTimeError: "النسبة لا يمكن أن تكون أكبر من 120" },
    flowBuilderMenu: { addTitle: "إضافة قائمة للتدفق", editTitle: "تعديل قائمة التدفق", add: "إضافة", save: "حفظ", menuMessage: "رسالة القائمة", addOption: "إضافة خيار", digit: "رقم", typeOption: "اكتب الخيار" },
    flowBuilderInterval: { addTitle: "إضافة فاصل زمني للتدفق", editTitle: "تعديل الفاصل الزمني", add: "إضافة", edit: "تعديل", timeInSeconds: "الوقت بالثواني", addIntervalError: "الفاصل الزمني يجب أن يكون أكبر من 0", maxTimeError: "الفاصل الزمني لا يمكن أن يكون أكبر من 120" },
    flowBuilderRemoveTag: { addTitle: "إزالة علامة من التدفق", editTitle: "تعديل إزالة العلامة", addRemoval: "إضافة إزالة", edit: "تعديل", selectTagToRemove: "حدد علامة للإزالة", noTagSelected: "لم يتم تحديد علامة", chooseTag: "اختر علامة لإزالتها من جهة الاتصال", actionDescription: "هذا الإجراء سيزيل العلامة المحددة من جهة الاتصال عند تنفيذ التدفق", selectTagError: "حدد علامة للإزالة", title: "إزالة العلامة", tagNotSelected: "لم يتم تحديد علامة", removesTagFromContact: "يزيل العلامة من جهة الاتصال" },
    flowBuilderTicket: { add: "إضافة", edit: "تعديل" },
    flowBuilderVideo: { addTitle: "إضافة فيديو إلى التدفق", editTitle: "تعديل الفيديو", add: "إضافة", save: "حفظ" },
    flowBuilderAudio: { addTitle: "إضافة صوت إلى التدفق", editTitle: "تعديل الصوت", add: "إضافة", save: "حفظ" },
    flowBuilderGeminiModal: { addTitle: "إضافة Gemini إلى التدفق", editTitle: "تعديل Gemini في التدفق", add: "إضافة", save: "حفظ", cancel: "إلغاء", basicSettings: "الإعدادات الأساسية - Google Gemini", assistantName: "اسم المساعد", geminiModel: "نموذج Gemini", systemPrompt: "موجه النظام", systemPromptPlaceholder: "صف كيف يجب أن يتصرف الذكاء الاصطناعي...", temperature: "الحرارة", temperatureHelper: "0 = محافظ، 2 = إبداعي", maxTokensLabel: "الحد الأقصى للرموز", maxTokensHelper: "الحد الأقصى لحجم الاستجابة", maxMessagesLabel: "الحد الأقصى للرسائل", maxMessagesHelper: "سجل السياق", flowBehavior: "سلوك التدفق", flowBehaviorTooltip: "إعداد سلوك Gemini في التدفق", operationMode: "وضع التشغيل", permanent: "دائم", permanentDesc: "إنهاء التدفق هنا", permanentHelper: "يستمر المستخدم بالمحادثة مع الذكاء الاصطناعي", temporary: "مؤقت", temporaryDesc: "يعود للتدفق بعد ذلك", temporaryHelper: "ينفذ الذكاء الاصطناعي مهمة محددة ثم يعود", temporarySettings: "إعدادات الوضع المؤقت", temporarySettingsDesc: "إعداد متى يجب أن يتوقف الذكاء الاصطناعي", maxInteractions: "الحد الأقصى للتفاعلات", maxInteractionsHelper: "الحد الأقصى للرسائل قبل العودة للتدفق", timeoutLabel: "المهلة (دقائق)", timeoutHelper: "حد زمني قبل العودة للتدفق", continueKeywords: "كلمات مفتاحية لمتابعة التدفق", keywordPlaceholder: "اكتب كلمة مفتاحية", addKeyword: "إضافة", keywordsHelper: "عندما يرسل المستخدم إحدى هذه الكلمات، سيستمر التدفق", objectiveLabel: "هدف الذكاء الاصطناعي", objectiveHelper: "صف ما يجب أن يكمله الذكاء الاصطناعي", objectivePlaceholder: "مثال: جمع بيانات العميل...", autoComplete: "إكمال تلقائي عند تحقيق الهدف", autoCompleteHelper: "سيحلل الذكاء الاصطناعي تلقائياً ما إذا أكمل الهدف", queueId: "معرف القائمة (للتحويل)", queueIdHelper: "معرف القائمة للتحويل إذا طلب المستخدم وكيل (0 = لا تحويل)" },
    interactiveMessageModal: { title: "إرسال رسالة تفاعلية", subtitle: "أرسل رسائل مع أزرار وقوائم وعروض", templateActive: "📋 قالب: {{name}}", cancel: "إلغاء", send: "إرسال", sending: "جاري الإرسال...", save: "حفظ", saveTemplate: "حفظ القالب", saveAsTemplate: "حفظ كقالب", loadTemplate: "تحميل قالب محفوظ", models: "نماذج", templateNameLabel: "اسم القالب", templateNamePlaceholder: "مثال: ترحيب مع أزرار", saveCurrentConfig: "احفظ الإعداد الحالي كنموذج قابل لإعادة الاستخدام", noTemplates: "لا توجد قوالب محفوظة لهذا النوع", templateLoaded: "تم تحميل القالب \"{{name}}\"", templateSaved: "تم حفظ القالب!", templateRemoved: "تم إزالة القالب", templateSaveError: "خطأ في حفظ القالب", templateRemoveError: "خطأ في الإزالة", templateNameRequired: "أدخل اسماً للقالب", messageSent: "تم إرسال الرسالة التفاعلية!", messageError: "خطأ في الإرسال", fillMessageText: "املأ نص الرسالة", addAtLeastOneButton: "أضف زراً واحداً على الأقل", addAtLeastOneOption: "أضف خياراً واحداً على الأقل في القائمة", fillLatLong: "املأ خط العرض وخط الطول", fillUrl: "املأ الرابط", fillPhone: "املأ رقم الهاتف", fillPixKey: "املأ مفتاح PIX", addAtLeast2Options: "أضف خيارين على الأقل", addAtLeastOneCard: "أضف بطاقة واحدة على الأقل", fillBillingDesc: "املأ وصف الفاتورة", pdfUploadError: "خطأ في رفع PDF", pdfTooBig: "PDF كبير جداً (حد أقصى 16MB)", previewTitle: "معاينة الرسالة", billingDesc: "وصف الفاتورة...", messageBody: "نص الرسالة...", tabs: { buttons: "أزرار", list: "قائمة", billing: "فواتير", offers: "عروض", pix: "PIX", url: "رابط", call: "مكالمة", location: "موقع", carousel: "كاروسيل", catalog: "كتالوج", poll: "استطلاع" }, buttonsTab: { info: "أرسل حتى 3 أزرار قابلة للنقر.", messageText: "نص الرسالة *", footer: "تذييل (اختياري)", buttonsMax: "أزرار (حد أقصى 3)", add: "إضافة", option: "خيار" }, listTab: { info: "أرسل قائمة بحد أقصى 10 خيارات.", messageText: "نص الرسالة *", footer: "تذييل (اختياري)", buttonText: "نص الزر", sectionTitle: "عنوان القسم", title: "عنوان", description: "وصف", addOption: "إضافة خيار", select: "اختيار" }, offerTab: { info: "🏷️ أرسل عرضاً بعنوان وسعر ووصف.", offerTitle: "عنوان العرض", bodyText: "وصف / نص الرسالة *", price: "السعر", additionalDetails: "تفاصيل إضافية", footer: "تذييل (اختياري)" }, pixTab: { info: "💰 أرسل بيانات PIX منسقة.", messageText: "نص الرسالة *", pixKey: "مفتاح PIX *", pixKeyPlaceholder: "CPF أو بريد إلكتروني أو هاتف", beneficiaryName: "اسم المستفيد", city: "المدينة", amount: "القيمة" }, urlTab: { info: "🔗 أرسل رابطاً قابلاً للنقر.", messageText: "نص الرسالة *", linkText: "نص الرابط", linkPlaceholder: "انقر هنا", url: "الرابط *", footer: "تذييل (اختياري)" }, callTab: { info: "📞 أرسل رسالة مع رقم للاتصال.", messageText: "نص الرسالة *", buttonText: "نص الزر", buttonPlaceholder: "اتصل الآن", phone: "رقم الهاتف *" }, locationTab: { info: "📍 أرسل موقعاً للعميل.", messageText: "نص الرسالة", locationName: "اسم الموقع", address: "العنوان", latitude: "خط العرض *", longitude: "خط الطول *", searchPlaceholder: "ابحث عن عنوان أو مكان...", myLocation: "موقعي", mapHint: "انقر على الخريطة أو اسحب العلامة لتحديد الموقع." }, carouselTab: { info: "🎠 أرسل بطاقات متعددة ككاروسيل.", messageText: "نص الرسالة *", card: "بطاقة", title: "عنوان", description: "وصف", addCard: "إضافة بطاقة" }, catalogTab: { info: "🛍️ أرسل منتجات الكتالوج كبطاقات.", messageText: "نص الرسالة *", product: "منتج", productName: "اسم المنتج", descriptionPrice: "وصف / سعر", addProduct: "إضافة منتج" }, pollTab: { info: "📊 أنشئ استطلاعاً للعميل للتصويت.", officialNote: "(سيتم إرساله كنص منسق في API الرسمي)", question: "سؤال الاستطلاع *", optionsMinMax: "خيارات (حد أدنى 2، حد أقصى 12)", add: "إضافة", option: "خيار" }, billingTab: { info: "🧾 أرسل فاتورة مع تفاصيل الدفع.", billingNumber: "رقم الفاتورة", billingDesc: "وصف الفاتورة *", billingDescPlaceholder: "فاتورة", quantity: "الكمية", totalAmount: "المبلغ الإجمالي *", customMessage: "رسالة مخصصة", footer: "تذييل (اختياري)", attachPdf: "📄 إرفاق PDF (اختياري)", selectPdf: "اختيار PDF", paymentButton: "زر الدفع", buttonText: "نص الزر", paymentUrl: "رابط الدفع (اختياري)", paymentUrlHelper: "إذا تم ملؤه، سيكون الزر رابطاً قابلاً للنقر", reviewAndPay: "مراجعة ودفع", total: "الإجمالي", billingNumberLabel: "رقم الفاتورة" } },
    pairingCodeModal: { title: "📱 الاتصال عبر رمز الإقران", instructions: "أدخل رقم واتساب مع", countryCode: "رمز البلد + رمز المنطقة", example: "مثال:", phoneLabel: "رقم واتساب", phonePlaceholder: "+1 (555) 999-8888", digitsCount: "{{count}}/13 رقم", generateCode: "توليد الرمز", tryAgain: "حاول مرة أخرى", close: "إغلاق", cancel: "إلغاء", connected: "متصل!", connectedDesc: "تم إقران واتساب بنجاح.", alreadyConnected: "✅ واتساب متصل بالفعل!", codeNotReturned: "لم يتم إرجاع رمز الإقران من الخادم.", codeGenerated: "🔑 تم توليد الرمز! أدخله في واتساب خلال 60 ثانية.", whatsappInstructions: "في واتساب، اذهب إلى:", whatsappSteps: "الإعدادات ← الأجهزة المرتبطة ← ربط جهاز", tapLinkPhone: "اضغط على", linkWithPhone: "الربط برقم الهاتف", enterCodeExact: "وأدخل الرمز كما هو معروض:", waitingCode: "في انتظار الرمز...", enterCodeInWhatsapp: "أدخل الرمز في واتساب", codeExpiring: "الرمز ينتهي!", waitingPairing: "في انتظار إدخال الرمز في واتساب...", syncingSession: "جاري المزامنة... تقريباً جاهز!", steps: { generateCode: "توليد الرمز", enterCode: "إدخال في واتساب", syncing: "مزامنة", connected: "متصل" } },
    campaignContactSelector: { newListTitle: "قائمة جهات اتصال جديدة", stepName: "تسمية القائمة", stepImport: "استيراد جهات الاتصال", nameDescription: "أعطِ اسماً لتحديد قائمة جهات الاتصال.", listName: "اسم القائمة", namePlaceholder: "مثال: عملاء VIP...", charsCount: "{{count}}/50 حرف", listCreated: "تم إنشاء القائمة \"{{name}}\"! الآن استورد جهات الاتصال (اختياري).", dragExcel: "اسحب ملف Excel هنا أو انقر للاختيار", acceptedFormats: "الصيغ المقبولة: .xls, .xlsx", downloadTemplate: "📥 تحميل نموذج الجدول (.xlsx)", close: "إغلاق", cancel: "إلغاء", skipImport: "تخطي الاستيراد", creating: "جاري الإنشاء...", createList: "إنشاء القائمة ←", sending: "جاري الإرسال...", importContacts: "استيراد جهات الاتصال", selectedForCampaign: "✓ القائمة مختارة لهذه الحملة", selectForCampaign: "اختيار هذه القائمة للحملة", backToCampaign: "العودة للحملة ←", searchSystemContacts: "بحث جهات اتصال النظام", selected: "{{count}} مختار", addingToList: "إضافة إلى القائمة: {{name}}", searchPlaceholder: "بحث بالاسم أو الرقم...", filterByTag: "تصفية حسب العلامة:", clearFilters: "مسح ({{count}})", loadingTags: "جاري تحميل العلامات...", noTagsAvailable: "لا توجد علامات متاحة.", selectAll: "تحديد الكل ({{count}} معروض)", noContactsFound: "لم يتم العثور على جهات اتصال.", tryAnotherSearch: "حاول البحث باسم أو رقم آخر.", name: "الاسم", number: "الرقم", loadMore: "تحميل المزيد", cancelSearch: "إلغاء", adding: "جاري الإضافة...", addToList: "إضافة {{count}} للقائمة", contactLists: "قوائم جهات الاتصال", createListsDesc: "أنشئ قوائم واستورد جهات اتصال واختر القائمة للحملة.", simpleList: "قائمة بسيطة", newListExcel: "قائمة جديدة + Excel", selectedList: "القائمة المختارة: {{name}}", contactsCount: "{{count}} جهة اتصال — ستستخدم هذه القائمة في الحملة", remove: "إزالة", searchList: "بحث في القوائم...", noListsYet: "لم يتم إنشاء قوائم بعد.", clickNewList: "انقر على \"قائمة جديدة\" للبدء.", selectedBadge: "مختارة", contacts: "جهات اتصال", alreadySelected: "القائمة مختارة بالفعل", selectForCampaignTooltip: "اختيار للحملة", searchSystemContactsTooltip: "بحث جهات اتصال النظام لهذه القائمة", editList: "تعديل القائمة", deleteList: "حذف القائمة", deleteListConfirm: "حذف القائمة \"{{name}}\"؟", listSelected: "تم اختيار القائمة \"{{name}}\" للحملة!", listRemoved: "تم إزالة القائمة بنجاح", importStarted: "بدأ الاستيراد! سيتم تحميل جهات الاتصال قريباً.", invalidFormat: "تنسيق غير صالح. استخدم فقط ملفات .xls أو .xlsx", fileUploaded: "تم رفع الملف! سيتم تحميل جهات الاتصال قريباً.", searchContact: "بحث جهة اتصال...", selectThisList: "تحديد هذه القائمة للحملة", listSelectedToast: "تم تحديد القائمة \"{{name}}\" للحملة!", nameList: "تسمية القائمة", giveNameToList: "أعطِ اسماً لتحديد قائمة جهات الاتصال هذه.", listNamePlaceholder: "مثال: عملاء VIP...", characters: "حروف", searchByNameOrNumber: "بحث بالاسم أو الرقم...", listAlreadySelected: "القائمة محددة بالفعل", selectWhatsapp: "حدد اتصال واتساب في الحملة قبل الاستيراد." },
    contactsPage: { importFromPhone: "استيراد جهات الاتصال من الهاتف", selectConnection: "حدد اتصال واتساب لاستيراد جهات الاتصال:", noConnectionFound: "لم يتم العثور على اتصال واتساب متصل.", selectAConnection: "حدد اتصال", noNumber: "بدون رقم", cancel: "إلغاء", import: "استيراد", profilePhoto: "صورة الملف الشخصي", imageNotAvailable: "الصورة غير متاحة", blockContact: "حظر جهة الاتصال {{name}}؟", unblockContact: "إلغاء حظر جهة الاتصال {{name}}؟", contactBlocked: "تم حظر جهة الاتصال", contactUnblocked: "تم إلغاء حظر جهة الاتصال", deleteAll: "حذف الكل ({{count}})", deleteSelected: "حذف المحدد ({{count}})", delete: "حذف", selectAtLeastOne: "حدد جهة اتصال واحدة على الأقل للحذف", allDeleted: "تم حذف جميع {{count}} جهات الاتصال", selectedDeleted: "تم حذف {{count}} جهات اتصال بنجاح", importStarting: "بدء الاستيراد...", importSuccess: "تم استيراد جهات الاتصال بنجاح!", notSynced: "جهات الاتصال غير متزامنة بعد.", importError: "خطأ في استيراد جهات الاتصال" },
    kanbanCard: {
      assignValue: "تعيين قيمة",
      value: "القيمة: {{value}}",
      remove: "إزالة",
      viewTicket: "عرض التذكرة",
      editValue: "تعديل",
      assignValueTitle: "تعيين قيمة الفرصة",
      editValueTitle: "تعديل قيمة الفرصة",
      valueLabel: "القيمة",
      cancel: "إلغاء",
      save: "حفظ",
      noName: "بدون اسم",
      noMessages: "لا رسائل",
      pending: "معلق",
      addValue: "إضافة قيمة",
      viewChat: "عرض المحادثة",
      slaOnTime: "في الموعد",
      slaWarning: "تنبيه",
      slaOverdue: "متأخر",
    },
    kanbanColumn: {
      searchPlaceholder: "البحث بالاسم، الرقم...",
      noResults: "لا نتائج",
      noTickets: "لا تذاكر",
      slaOnTime: "في الموعد",
      slaWarning: "تنبيه",
      slaOverdue: "متأخر",
      totalValue: "القيمة الإجمالية",
    },
    kanbanLanes: {
      novo: "جديد",
      emAnalise: "قيد المراجعة",
      aguardandoCliente: "بانتظار العميل",
      resolvido: "تم الحل",
      lead: "عميل محتمل",
      qualificado: "مؤهل",
      proposta: "عرض",
      fechado: "مغلق",
      perdido: "مفقود",
      emAberto: "مفتوح",
      negociacao: "تفاوض",
      acordo: "اتفاق",
      pago: "مدفوع",
      inadimplente: "متأخر",
      boasVindas: "ترحيب",
      treinamento: "تدريب",
      ativacao: "تفعيل",
      clienteAtivo: "عميل نشط",
    },
    kanbanChat: {
      statusOpen: "مفتوح",
      statusPending: "معلق",
      statusClosed: "مغلق",
      contact: "جهة اتصال",
      noQueue: "بدون قائمة",
      noMessages: "لا رسائل حتى الآن",
      inputPlaceholder: "اكتب رسالة...",
    },
    tooltips: { edit: "تعديل", delete: "حذف", report: "تقرير", syncTemplates: "مزامنة القوالب", copyWebhook: "نسخ webhook" },
    telegram: {
      botTokenTitle: "🤖 رمز بوت تيليجرام",
      botTokenHelp: "أنشئ بوتًا في @BotFather على تيليجرام والصق الرمز هنا. سيتم تكوين الويب هوك تلقائيًا عند الحفظ.",
      botTokenLabel: "رمز البوت",
      webhookUrl: "رابط الويب هوك",
      connectBot: "توصيل البوت",
      chip: "تيليجرام",
    },
    locationPreview: {
      openInMaps: "فتح في خرائط جوجل",
    },
    flowBuilderConditionCompare: { saving: "جاري الحفظ...", saveChanges: "حفظ التغييرات", add: "إضافة" },
    flowBuilderStart: { title: "بداية التدفق", description: "هذه الكتلة تحدد بداية التدفق الخاص بك!" },
    flowBuilderConditionCompareNode: { title: "إذا / وإلا", contains: "يحتوي", notContains: "لا يحتوي", containsAny: "يحتوي على أي", startsWith: "يبدأ بـ", endsWith: "ينتهي بـ", isEmpty: "فارغ", isNotEmpty: "غير فارغ", regex: "regex", field: "حقل", value: "قيمة", and: "و", or: "أو", true: "صحيح", false: "خطأ" },
    flowBuilderHttpRequest: { title: "طلب HTTP", preconfiguredWebhooks: "Webhooks مُعدة مسبقاً", selectPreset: "اختر إعداد مسبق", choosePreset: "اختر تكوين جاهز...", system: "نظام", remove: "إزالة", usingPreset: "يستخدم إعداد مسبق:", urlFromPreset: "URL (من الإعداد المسبق)", urlPlaceholder: "https://api.example.com/webhook", editPresetUrl: "يمكنك تعديل عنوان URL الأساسي للإعداد المسبق إذا لزم الأمر", method: "الطريقة", testRequest: "اختبار الطلب", apiResponse: "استجابة API:", viewFullResponse: "عرض الاستجابة الكاملة", hideAdvanced: "إخفاء المتقدم", showAdvanced: "إظهار المتقدم", advancedWarning: "قد تتجاوز الإعدادات المتقدمة إعدادات الإعداد المسبق", timeoutMs: "المهلة (مللي ثانية)", queryParams: "معلمات الاستعلام", key: "مفتاح", addParam: "إضافة معلمة", headersJson: "الرؤوس (JSON)", requestBody: "جسم الطلب (JSON)", editRequestBody: "تحرير جسم الطلب", close: "إغلاق", hideMapVars: "إخفاء متغيرات الاستجابة", showMapVars: "تعيين متغيرات الاستجابة", mapResponseData: "تعيين بيانات الاستجابة إلى متغيرات", path: "مسار", pathPlaceholder: "مثال: data.user.id", variableName: "اسم المتغير", variablePlaceholder: "مثال: userId", addVariable: "إضافة متغير", tips: "نصائح مفيدة:", tipAutoSave: "يتم حفظ استجابة API الكاملة تلقائياً في المتغير العام", tipVarUsage: "يمكنك استخدام ${اسمالمتغير} في URL وجسم الطلب لتضمين قيم المتغيرات.", requestError: "خطأ في الطلب", configSaved: "تم حفظ التكوين!", fullApiResponse: "استجابة API الكاملة", presetError: "خطأ في تطبيق تكوين الإعداد المسبق", value: "قيمة" },
    flowBuilderInteractiveNode: { title: "رسالة تفاعلية API", buttons: "أزرار", maxButtons: "حد أقصى 3", messageBody: "نص الرسالة...", select: "اختيار", button: "زر", item: "عنصر" },
    
    flowBuilderVariable: { title: "متغير عام", variableName: "اسم المتغير", value: "القيمة", helperText: "يمكنك استخدام قيم ثابتة أو مراجع مثل ${متغيرآخر}", saved: "تم الحفظ!", saveVariable: "حفظ المتغير", variableSavedSuccess: "تم حفظ المتغير بنجاح!" },
    flowBuilderAiAgent: { title: "وكيل ذكاء اصطناعي", selectAgent: "اختر وكيلاً" },
    flowBuilderAttendant: { title: "موظف" },
    flowBuilderAudioNode: { title: "صوت", recordedLive: "مسجل مباشرة", audioSent: "تم إرسال الصوت" },
    flowBuilderVideoNode: { title: "فيديو" },
    flowBuilderMessageNode: { title: "رسالة" },
    flowBuilderConditionNode: { title: "شرط" },
    flowBuilderImageNode: { title: "صورة" },
    flowBuilderInputNode: { title: "إدخال", question: "سؤال:", questionNotDefined: "السؤال غير محدد", variableToStore: "متغير لتخزين الاستجابة:", variableNotDefined: "المتغير غير محدد", usingVariables: "استخدام المتغيرات:", alwaysAsk: "اسأل دائماً (حتى لو كان المتغير موجوداً)" },
    flowBuilderMenuNode: { title: "قائمة رقمية" },
    flowBuilderIntervalNode: { title: "فاصل زمني" },
    flowBuilderRandomizerNode: { title: "عشوائي" },
    flowBuilderSingleBlockNode: { title: "محتوى" },
    flowBuilderSwitchFlowNode: { title: "تبديل التدفق" },
    flowBuilderTypebotNode: { title: "TypeBot" },
    flowBuilderQuestionNode: { title: "سؤال" },
    flowBuilderTagNode: { title: "علامة" },
    flowBuilderTicketNode: { title: "طابور" },
    flowBuilderAiAgentModal: { addTitle: "إضافة وكيل ذكاء اصطناعي", editTitle: "تعديل وكيل ذكاء اصطناعي", add: "إضافة", save: "حفظ", cancel: "إلغاء", selectAgent: "اختر وكيل ذكاء اصطناعي", agentLabel: "وكيل ذكاء اصطناعي", selectPlaceholder: "اختر...", subtitle: "اختر وكيلاً نشطاً لاستخدامه في هذا التدفق", noAgentsFound: "لم يتم العثور على وكلاء نشطين. أنشئ وكيلاً في صفحة \"وكلاء الذكاء الاصطناعي\".", defaultAgentName: "وكيل ذكاء اصطناعي" },
    flowBuilderValidation: { tooShort: "قصير جداً!", tooLong: "طويل جداً!", enterName: "أدخل اسماً!", enterMessage: "أدخل رسالة!", required: "مطلوب" },
    audioTranscription: { transcription: "النسخ:", transcribing: "جاري النسخ...", transcribe: "نسخ", failed: "فشل تحويل النص" },
    birthdayModal: { congratulations: "🎉 مبروك!", specialDay: "اليوم يوم مميز!", loading: "جاري تحميل أعياد الميلاد...", youLabel: "(أنت!)", systemUser: "مستخدم النظام", contact: "جهة اتصال", sending: "جاري الإرسال...", messageSent: "تم إرسال الرسالة بالفعل", sendCongrats: "إرسال تهنئة", remindLater: "ذكّرني لاحقاً", understood: "فهمت، شكراً!", year: "سنة", years: "سنوات", notAvailable: "غ/م", toasts: { sent: "تم إرسال رسالة تهنئة إلى {{name}}! 🎉", alreadySent: "تم إرسال رسالة عيد الميلاد بالفعل لهذا الاتصال اليوم", loadError: "خطأ في تحميل أعياد الميلاد", sendError: "خطأ في إرسال رسالة عيد الميلاد" } },
    birthdaySettings: { title: "🎂 إعدادات أعياد الميلاد", loading: "جاري تحميل الإعدادات...", userSection: "أعياد ميلاد المستخدمين", contactSection: "أعياد ميلاد جهات الاتصال", generalSection: "إعدادات عامة", enableUserNotifications: "تفعيل إشعارات أعياد ميلاد المستخدمين", enableUserNotificationsHelp: "عند التفعيل، سيتم عرض نافذة تهنئة", createAnnouncementUsers: "إنشاء إعلان تلقائي لأعياد ميلاد المستخدمين", createAnnouncementUsersHelp: "ينشئ إعلاناً تلقائياً يُعرض لجميع المستخدمين", userBirthdayMessage: "رسالة عيد ميلاد للمستخدمين", userMessageHelper: "استخدم {nome} لتضمين اسم المستخدم", enableContactMessages: "تفعيل إرسال رسائل عيد الميلاد التلقائية لجهات الاتصال", enableContactMessagesHelp: "يرسل تلقائياً رسائل تهنئة عبر واتساب", contactBirthdayMessage: "رسالة عيد ميلاد لجهات الاتصال", contactMessageHelper: "استخدم {nome} للاسم و{idade} للعمر", testMessage: "رسالة اختبار", sendTime: "وقت إرسال الرسائل", sendTimeHelper: "الوقت الذي سيتم فيه إرسال الرسائل التلقائية", whatsappConnection: "اتصال واتساب للإرسال", selectConnection: "حدد اتصالاً", whatsappConnectionHelp: "اتصال واتساب لإرسال رسائل عيد الميلاد", createInternalAnnouncement: "إنشاء إعلان داخلي لأعياد ميلاد المستخدمين", createInternalAnnouncementHelp: "ينشئ إعلاناً داخلياً عند عيد ميلاد مستخدم", availableVariables: "المتغيرات المتاحة في الرسائل:", varName: "اسم الشخص", varAge: "عمر الشخص (جهات الاتصال فقط)", preview: "معاينة:", saving: "جاري الحفظ...", saveSettings: "حفظ الإعدادات", toasts: { saved: "تم حفظ إعدادات أعياد الميلاد! 🎉", loadError: "خطأ في تحميل إعدادات أعياد الميلاد", saveError: "خطأ في حفظ الإعدادات", testSent: "تم إرسال رسالة الاختبار! 📱", testError: "خطأ في إرسال رسالة الاختبار" } },
    announcementValidation: { required: "مطلوب" },
    campaignModal: { tabCampaign: "حملة", tabContactLists: "📋 قوائم جهات الاتصال", tabSettings: "⚙️ إعدادات", selectTemplateRequired: "حدد قالباً معتمداً لحملات API الرسمي.", noTemplateFound: "لم يتم العثور على قوالب معتمدة.", templateRequired: "مطلوب لـ API الرسمي.", apiOfficialLabel: "API رسمي", recurrenceTitle: "إعداد التكرار", enableRecurrence: "تفعيل التكرار", recurrenceType: "نوع التكرار", minutely: "بالدقيقة", hourly: "بالساعة", daily: "يومي", weekly: "أسبوعي", biweekly: "نصف شهري", monthly: "شهري", yearly: "سنوي", interval: "الفاصل", everyInterval: "كل {{count}} {{unit}}", minuteUnit: "دقيقة/دقائق", hourUnit: "ساعة/ساعات", dayUnit: "يوم/أيام", weekUnit: "أسبوع/أسابيع", biweekUnit: "نصف شهر", monthUnit: "شهر/أشهر", yearUnit: "سنة/سنوات", daysOfWeek: "أيام الأسبوع", dayOfMonth: "يوم الشهر", dayOfMonthHelper: "يوم محدد من الشهر (1-31)", endDate: "تاريخ الانتهاء (اختياري)", emptyRecurrence: "اتركه فارغاً للتكرار اللانهائي", maxExecutions: "الحد الأقصى للتنفيذ (اختياري)", hideExecutions: "إخفاء", showExecutions: "عرض", nextExecutions: "التنفيذات القادمة", next5Executions: "التنفيذات الخمسة القادمة:", nthExecution: "التنفيذ {{n}}", campaignMessage: "رسالة الحملة", apiOfficialNote: "لـ API الرسمي، استخدم القالب المحدد.", apiOfficialNoFollowUp: "⚠️ Follow-up متاح فقط لقنوات Baileys. في الحملات عبر API الرسمي، يُرسل القالب فقط.", attachMedia: "إرفاق وسائط", messageVariableHelper: "استخدم متغيرات مثل {nome}, {numero}, {email}.", varName: "الاسم", varNumber: "الرقم", varEmail: "البريد", varGreeting: "التحية", varProtocol: "البروتوكول", varFirstName: "الاسم الأول", varAgent: "الوكيل", contactListTitle: "📋 قائمة جهات اتصال الحملة", contactListDesc: "حدد قائمة من تبويب \"📋 قوائم جهات الاتصال\".", contactList: "قائمة جهات الاتصال", noListSelected: "لم يتم تحديد قائمة", contacts: "جهات اتصال", filterByTag: "تصفية حسب العلامة (اختياري)", noTagFilter: "بدون تصفية", switchList: "تبديل القائمة ← الذهاب لقوائم جهات الاتصال", createOrSelectList: "+ إنشاء أو اختيار قائمة", dispatchIntervals: "فواصل الإرسال", dispatchIntervalsDesc: "إعداد الفواصل الزمنية لتجنب الحظر.", antiBan: "مضاد الحظر", antiBanDesc: "يحاكي السلوك البشري لتقليل خطر الحظر", jitterLabel: "تباين عشوائي (jitter)", jitterFixed: "ثابت", jitterMax: "أقصى", jitterBase: "أساس {{base}}ث ← بين {{min}}ث و{{max}}ث", jitterSelectBase: "⚠️ حدد فاصل أساسي أعلاه", extraPauseEvery: "توقف إضافي كل N رسالة", disabled: "معطل", everyNMessages: "كل {{n}} رسالة", extraPauseDuration: "مدة التوقف الإضافي", seconds: "ثوانٍ", minute1: "دقيقة واحدة", minutes2: "دقيقتان", minutes5: "5 دقائق", settingsSaved: "تم حفظ الإعدادات!", daysOfWeekOptions: { sunday: "الأحد", monday: "الاثنين", tuesday: "الثلاثاء", wednesday: "الأربعاء", thursday: "الخميس", friday: "الجمعة", saturday: "السبت" }, autoListName: "حملة - {{name}} - {{date}}", noName: "بدون اسم" },
    campaignModalPhrase: { campaignName: "اسم الحملة", nameRequired: "الاسم مطلوب", selectFlow: "حدد تدفقاً", flowRequired: "التدفق مطلوب", connections: "اتصالات واتساب", connectionsMultiple: "(متعددة)", atLeastOneConnection: "يجب تحديد اتصال واحد على الأقل", connectionsSelected: "{{count}} اتصال(ات) محددة:", connectionsInfo: "ستعمل الحملة عندما يتلقى أي اتصال رسائل تطابق العبارات.", filterByTag: "تصفية حسب علامة جهة الاتصال", optional: "(اختياري)", filterByTagDesc: "إذا تم التحديد، سيتم تشغيل التدفق فقط لجهات الاتصال التي لديها إحدى هذه العلامات.", tagsLabel: "العلامات (اختياري)", filterActive: "🏷️ فلتر نشط: سيتم تشغيل التدفق فقط لجهات الاتصال التي لديها إحدى {{count}} علامة(ات) محددة.", triggerKeywords: "كلمات مفتاحية تشغّل التدفق", logicOr: "🔀 منطق أو: سيتم تشغيل التدفق إذا أرسل الاتصال أياً من الكلمات/العبارات أدناه.", exactLabel: "مطابقة: رسالة مطابقة.", partialLabel: "جزئية: كلمة موجودة في أي جزء من الرسالة.", orChip: "أو", phraseLabel: "كلمة/عبارة {{index}}", phrasePlaceholder: "مثال: مرحبا، أريد عرض أسعار...", fieldRequired: "حقل مطلوب", typeLabel: "النوع", exact: "مطابقة", partial: "جزئية", addPhrase: "+ إضافة كلمة/عبارة أخرى (أو)", active: "نشطة", inactive: "غير نشطة", saving: "جاري الحفظ...", update: "تحديث", create: "إنشاء", fillAllFields: "يرجى ملء جميع الحقول المطلوبة", flowNotFound: "التدفق المحدد غير موجود", toasts: { updated: "تم تحديث الحملة!", created: "تم إنشاء الحملة!", saveError: "خطأ في حفظ الحملة", loadFlowsError: "خطأ في تحميل التدفقات", loadConnectionsError: "خطأ في تحميل الاتصالات", loadDataError: "خطأ في تحميل بيانات الحملة" } },
    contactNotes: { deleteTitle: "حذف السجل", deleteConfirm: "هل تريد حقاً حذف هذا السجل؟", noteAdded: "تمت إضافة الملاحظة بنجاح!", noteDeleted: "تم حذف الملاحظة بنجاح!", cancel: "إلغاء", save: "حفظ", close: "إغلاق" },
    contactDeleteConfirm: { titleAll: "حذف جميع {{count}} جهات الاتصال؟", titleSelected: "حذف {{count}} جهات اتصال محددة؟", warningAll: "⚠️ تحذير: ستحذف هذه العملية جميع {{count}} جهات الاتصال نهائياً!", warningAllBody: "لا يمكن التراجع عن هذه العملية.", warningSelected: "ستحذف هذه العملية {{count}} جهات اتصال محددة نهائياً.", warningSelectedBody: "سيتم حذف جهات الاتصال المحددة وبياناتها المرتبطة نهائياً.", confirmPrompt: "للتأكيد، اكتب بالضبط:", confirmLabel: "تأكيد", cancel: "إلغاء", deleteAll: "حذف الكل", deleteSelected: "حذف المحددة", expectedAll: "حذف الكل", expectedSelected: "حذف المحددة", typeExact: "اكتب بالضبط: {{text}}" },
    colorBoxModal: { title: "اختر لوناً", cancel: "إلغاء", ok: "موافق" },
    contactGroupModal: { title: "إنشاء مجموعة جهات اتصال", groupName: "اسم المجموعة", groupNamePlaceholder: "مثال: عملاء VIP...", searchPlaceholder: "بحث جهات الاتصال...", selectedCount: "{{count}} جهة(ات) اتصال محددة", clearSelection: "مسح التحديد", name: "الاسم", number: "الرقم", email: "البريد", tags: "العلامات", noContacts: "لم يتم العثور على جهات اتصال", perPage: "لكل صفحة:", displayedRows: "{{from}}-{{to}} من {{count}}", cancel: "إلغاء", creating: "جاري الإنشاء...", createGroup: "إنشاء مجموعة ({{count}} جهات اتصال)", groupNameRequired: "أدخل اسماً للمجموعة", selectAtLeastOne: "حدد جهة اتصال واحدة على الأقل", groupCreated: "تم إنشاء المجموعة \"{{name}}\" مع {{count}} جهات اتصال" },
    contactListTable: { name: "الاسم", contacts: "جهات الاتصال", actions: "الإجراءات" },
    contactTagListModal: { contacts: "جهات الاتصال", id: "المعرف", name: "الاسم", number: "الرقم", actions: "الإجراءات" },
    contactsFilter: { placeholder: "جهات الاتصال" },
    contactImport: { fields: { name: "الاسم", number: "الرقم", email: "البريد", birthDate: "تاريخ الميلاد", tags: "العلامات", wallet: "المحفظة" }, errors: { noNumber: "لم يتم تحديد حقل رقم جهة الاتصال", noName: "لم يتم تحديد حقل اسم جهة الاتصال", noSelection: "لم يتم تحديد جهات اتصال", fieldAlreadySelected: "الحقل {{field}} محدد بالفعل." }, results: { title: "نتيجة الاستيراد", created: "✅ {{count}} جهات اتصال تم إنشاؤها بنجاح", ignored: "⚠️ {{count}} جهات اتصال تم تجاهلها", successAll: "تم الاستيراد بنجاح! {{count}} جهات اتصال.", successPartial: "اكتمل الاستيراد: {{created}} مستوردة و{{ignored}} تم تجاهلها.", failed: "فشل الاستيراد. لم يتم استيراد أي جهات اتصال.", importMore: "استيراد المزيد" }, validateSwitch: "التحقق من جهات الاتصال في واتساب", uploading: "جاري الاستيراد... انتظر", importButton: "استيراد جهات الاتصال", cancel: "إلغاء", processing: "جاري معالجة الملف...", invalidFile: "ملف غير صالح!", invalidFileDesc: "الملف الذي حاولت استيراده غير صالح.", tryAgain: "حاول مرة أخرى", dropzoneTitle: "انقر أو اسحب ملف Excel", dropzoneFormats: "* الصيغ المقبولة: xls, xlsx, csv, txt", dropzoneHelp: "لاستيراد جهات الاتصال، يجب أن يكون لديك أعمدة الاسم والرقم على الأقل.", back: "رجوع" },
    contactImportWpModal: { importingPhone: "جاري استيراد جهات اتصال الهاتف...", importPhoneButton: "📱 استيراد جهات اتصال الهاتف (واتساب)", phoneImported: "تم استيراد جهات اتصال الهاتف بنجاح!", statusInProgress: "الاستيراد جارٍ {{current}} من {{total}}", statusComplete: "اكتمل الاستيراد بنجاح" },
    contactDrawer: { noParticipants: "لم يتم العثور على مشاركين", chat: "محادثة", superAdmin: "مشرف أعلى", admin: "مشرف", participant: "مشارك", searching: "جاري البحث...", noMessages: "لم يتم العثور على رسائل", searchPlaceholder: "البحث في الرسائل...", infoTab: "معلومات", imagesTab: "صور", videosTab: "فيديوهات", audiosTab: "صوتيات", documentsTab: "مستندات", linksTab: "روابط", participantsTab: "المشاركون", noImages: "لم يتم العثور على صور", noVideos: "لم يتم العثور على فيديوهات", noAudios: "لم يتم العثور على صوتيات", noDocs: "لم يتم العثور على مستندات", noLinks: "لم يتم العثور على روابط", contactUpdated: "تم تحديث جهة الاتصال بنجاح!", contactBlocked: "تم حظر جهة الاتصال", contactUnblocked: "تم إلغاء حظر جهة الاتصال", blockTooltip: "حظر جهة الاتصال", unblockTooltip: "إلغاء حظر جهة الاتصال", lidWarning: "⚠️ خطأ محتمل: الرقم يبدو أنه LID", you: "(أنت)", exportParticipants: "تصدير المشاركين", noParticipantsExport: "لا يوجد مشاركون للتصدير", exportSuccess: "تم تصدير الملف \"{{name}}\" بنجاح!", noName: "بدون اسم" },
    companiesManager: { generateInvoice: "إنشاء فاتورة", yes: "نعم", no: "لا", loadError: "تعذر تحميل قائمة السجلات", operationSuccess: "تمت العملية بنجاح!", operationError: "تعذر تنفيذ العملية", deleteError: "تعذر تنفيذ العملية" },
    birthdaySettingsPage: { title: "🎂 إعدادات أعياد الميلاد" },
    groupManager: { title: "مدير المجموعات", groups: "المجموعات", refresh: "تحديث", sync: "مزامنة المجموعات", syncing: "جاري المزامنة...", clearAll: "مسح جميع المجموعات", selectConnection: "حدد اتصالاً", selectConnectionFirst: "حدد اتصالاً للبدء", clickSyncToLoad: "انقر على مزامنة لتحميل المجموعات", connection: "الاتصال", allConnections: "جميع الاتصالات", searchGroup: "البحث عن مجموعة...", noGroupsFound: "لم يتم العثور على مجموعات", noName: "بدون اسم", connectionLabel: "اتصال {{id}}", selectGroup: "حدد مجموعة", selectGroupDesc: "اختر مجموعة من القائمة لإدارتها", participants: "مشاركون", groupActions: "إجراءات المجموعة", changeName: "تغيير الاسم", changeNameDesc: "تغيير اسم المجموعة", changeDescription: "تغيير الوصف", changeDescriptionDesc: "تعديل وصف المجموعة", inviteLink: "رابط الدعوة", inviteLinkDesc: "إنشاء أو نسخ رابط المشاركة", addParticipants: "إضافة مشاركين", addParticipantsDesc: "إضافة عبر رقم الهاتف", sendMessage: "إرسال رسالة", sendMessageDesc: "إرسال رسالة للمجموعة مع إشارة شبحية", settings: "الإعدادات", onlyAdminsSend: "المشرفون فقط يرسلون", onlyAdminsSendDesc: "فقط المشرفون يمكنهم إرسال الرسائل", restrictEdit: "تقييد التعديل", restrictEditDesc: "فقط المشرفون يعدلون بيانات المجموعة", participantsCount: "المشاركون ({{count}})", creator: "المنشئ", admin: "مشرف", demoteAdmin: "تخفيض من مشرف", promoteAdmin: "ترقية إلى مشرف", removeFromGroup: "إزالة من المجموعة", dialogChangeName: "تغيير اسم المجموعة", groupName: "اسم المجموعة", cancel: "إلغاء", save: "حفظ", dialogChangeDesc: "تغيير وصف المجموعة", description: "الوصف", dialogInviteLink: "رابط الدعوة", close: "إغلاق", dialogAddParticipants: "إضافة مشاركين", phoneNumbers: "رقم(أرقام) الهاتف", phoneNumbersPlaceholder: "5521999999999 (افصل بفاصلة لعدة أرقام)", phoneNumbersHelper: "أدخل الرقم مع رمز الدولة والمنطقة، بدون مسافات. مثال: 5521999999999", add: "إضافة", dialogSendMessage: "إرسال رسالة للمجموعة", message: "الرسالة", mentionAll: "إشارة لجميع المشاركين (إشارة شبحية)", send: "إرسال", confirmRemoveParticipant: "هل أنت متأكد أنك تريد إزالة هذا المشارك؟", toasts: { loadError: "خطأ في تحميل المجموعات", selectConnectionFirst: "حدد اتصالاً أولاً", syncSuccess: "تمت مزامنة {{count}} مجموعة!", metadataError: "خطأ في تحميل بيانات المجموعة", nameUpdated: "تم تحديث اسم المجموعة!", nameError: "خطأ في تحديث اسم المجموعة", descUpdated: "تم تحديث الوصف!", descError: "خطأ في تحديث الوصف", inviteLinkError: "خطأ في إنشاء رابط الدعوة", linkCopied: "تم نسخ الرابط!", participantAdded: "تمت إضافة المشارك(ين)!", participantAddError: "خطأ في إضافة المشارك", messageSent: "تم إرسال الرسالة!", messageError: "خطأ في إرسال الرسالة", settingUpdated: "تم تحديث الإعداد!", settingError: "خطأ في تحديث الإعداد", participantRemoved: "تم إزالة المشارك!", removeError: "خطأ في إزالة المشارك", promoted: "تمت ترقية المشارك إلى مشرف!", promoteError: "خطأ في ترقية المشارك", demoted: "تم تخفيض المشرف!", demoteError: "خطأ في تخفيض المشارك" } },
    contactImportPage: { title: "استيراد جهات اتصال من ملف" },
    forwardMessageModal: { title: "إعادة توجيه الرسالة", noContactFound: "لم يتم العثور على جهة اتصال بالاسم {{name}}", sending: "جاري الإرسال {{id}}...", forward: "إعادة توجيه" },
    newTicketModalExtra: { selectQueue: "حدد قائمة", selectConnection: "حدد اتصال", createAndSendTemplate: "إنشاء وإرسال قالب" },
    finalizacaoVendaModal: { title: "إنهاء الخدمة - قيمة البيع", loading: "جاري تحميل الإعدادات...", saleCompleted: "هل تم إتمام البيع؟", yes: "نعم، تم إتمام البيع", no: "لا، لم يتم إتمام البيع", saleValue: "قيمة البيع", noSaleReason: "سبب عدم البيع *", finalizationReason: "سبب الإنهاء *", selectReason: "حدد سبباً", cancel: "إلغاء", finalizing: "جاري الإنهاء...", finalize: "إنهاء الخدمة", errorSaleValue: "الرجاء إدخال قيمة البيع.", errorNoSaleReason: "الرجاء تحديد سبب عدم البيع.", errorFinalizationReason: "الرجاء تحديد سبب الإنهاء." },
    forbiddenPage: { title: "403", message: "عذراً! تم رفض الوصول!", back: "رجوع" },
    showTicketLogModal: { close: "إغلاق" },
    promptModalExtra: { text: "نص", sectorRequired: "أدخل القطاع" },
    tagModalExtra: { clickToAttach: "انقر لإرفاق وسائط (صورة، PDF، صوت، فيديو)", maxSize: "الحد الأقصى: 10MB لكل ملف", fileTooLarge: "الملف {{name}} كبير جداً. الحد الأقصى: 10MB", unsupportedType: "نوع الملف {{type}} غير مدعوم" },
    fileModalExtra: { nameTooShort: "اسم قصير جداً" },
    queueModalExtra2: { clickSaveToRegister: "انقر على حفظ لتسجيل التغييرات", saturday: "السبت", sunday: "الأحد", minutes: "دقائق", selectRotationType: "حدد نوع التناوب" },
    messagesInputExtra: { internalMessage: "رسالة داخلية", placeholderPending: "اكتب رسالة للتذاكر المعلقة", placeholderPendingAccept: "اقبل أو أعد فتح هذه التذكرة لإرسال رسالة.", placeholderWindowExpired: "خارج نافذة 24 ساعة. استخدم قالباً لإرسال الرسالة.", ticketPendingTitle: "تذكرة معلقة.", ticketPendingMessage: "اقبل أو أعد فتح هذه التذكرة للرد.", flowProcessingTitle: "التدفق قيد التشغيل:", flowProcessingMessage: "حقل الرسالة معطل مؤقتاً.", windowExpiredTitle: "انتهت نافذة 24 ساعة:", windowExpiredMessage: "نوصي بإرسال قالب، ولكن يمكنك أيضاً الكتابة بشكل طبيعي." },
    quickMessageExtra: { required: "مطلوب", attachMedia: "إرفاق وسائط", editMedia: "تعديل الوسائط", removeMedia: "إزالة الوسائط", newFile: "ملف جديد", newRecordedAudio: "صوت مسجل جديد", newAudio: "صوت جديد", replaceMedia: "اختر وسائط جديدة للاستبدال:", chooseMedia: "اختر خياراً لإرفاق وسائط:", attachFile: "إرفاق ملف", recordAudio: "تسجيل صوت", cancelEdit: "إلغاء التعديل", type: "نوع", value: "قيمة" },
    settingsOptions: {
      generalSettings: 'الإعدادات العامة',
      schedulingBot: 'الجدولة والبوت',
      pushNotifications: 'إشعارات الدفع',
      pushProcessing: 'جاري المعالجة...',
      pushEnabled: '🔔 الإشعارات مفعلة',
      pushDisabled: '🔕 الإشعارات معطلة',
      pushDescription: 'قم بالتفعيل لتلقي إشعارات الدفع في هذا المتصفح عند وصول رسائل جديدة.',
      pushDeactivated: 'تم تعطيل إشعارات الدفع',
      pushActivated: 'تم تفعيل إشعارات الدفع بنجاح!',
      pushActivateError: 'تعذر تفعيل إشعارات الدفع. تحقق من أذونات المتصفح.',
      pushVapidError: 'إشعارات الدفع غير مُعدة على الخادم. قم بإعداد مفاتيح VAPID.',
      pushChangeError: 'خطأ في تغيير إشعارات الدفع',
      pushTestButton: 'اختبار الإشعار على هذا الجهاز',
      pushTestSent: 'تم إرسال إشعار الاختبار! أطفئ الشاشة وانتظر.',
      pushTestError: 'تعذر إرسال إشعار الاختبار.',
      pushTestNotSubscribed: 'يرجى تفعيل الإشعارات على هذا الجهاز أولاً.',
      pushTestExpired: 'انتهت صلاحية الاشتراك. يرجى إعادة تفعيل الإشعارات.',
      systemCurrency: 'عملة النظام',
      currency: 'العملة',
      currencyDescription: 'يحدد رمز العملة المعروض في قيم البيع والتقارير والمالية.',
      currencyUpdated: 'تم تحديث العملة بنجاح!',
      currencyPersistError: 'فشل في حفظ العملة',
      currencySaveError: 'خطأ في حفظ العملة',
      currencyUpdateError: 'خطأ في تحديث العملة',
      operationUpdated: 'تم تحديث العملية بنجاح.',
      supportNumber: '📞 رقم الدعم',
      supportNumberPlaceholder: 'مثال: 5511999998888',
      supportNumberHelper: 'رقم مع رمز الدولة (يُستخدم في زر الاتصال بالدعم)',
      supportNumberUpdated: 'تم تحديث رقم الدعم!',
      pixEfiConfig: 'إعداد PIX Efí (GerenciaNet)',
      pixKey: 'مفتاح PIX',
      tokenAsaas: 'رمز Asaas',
      text: 'نص',
      enabled: '✓ مُفعّل',
      disabledLabel: '✕ مُعطّل',
      copyContactPrefix: 'بادئة لنسخ جهات الاتصال',
      aiSection: '🤖 الذكاء الاصطناعي',
      autoAiSummary: 'ملخص تلقائي بالذكاء الاصطناعي عند إغلاق المحادثة',
      aiSuggestReply: 'اقتراح رد بالذكاء الاصطناعي في الدردشة',
    },
    whitelabelSettings: {
      operationUpdated: 'تم تحديث العملية بنجاح.',
      appName: 'اسم التطبيق',
      appNameHelper: 'الاسم المعروض في المتصفح والبريد الإلكتروني',
      mobileAppName: 'اسم الجوال (PWA)',
      mobileAppNameHelper: 'الاسم المعروض عند التثبيت على الجوال',
      languages: {
        ptBR: 'Português',
        en: 'English',
        es: 'Español',
      },
    },
    campaignsPhrase: {
      deleted: 'تم حذف الحملة بنجاح',
      newCampaign: 'حملة جديدة',
      active: 'نشط',
      inactive: 'معطل',
      editCampaign: 'تعديل الحملة',
      deleteCampaign: 'حذف الحملة',
      noCampaigns: 'لم يتم العثور على حملات',
      clickNewCampaign: 'انقر على "حملة جديدة" لإنشاء أول حملة تدفق',
      name: 'الاسم',
      connectionsCol: 'الاتصالات',
      statusCol: 'الحالة',
      nameNotDefined: 'اسم غير محدد',
      phrasesConfigured: 'عبارة(ات) مُعدة',
    },
    contactsPage: {
      importFromPhone: 'استيراد جهات الاتصال من الهاتف',
      selectAConnection: 'حدد اتصال',
      cancel: 'إلغاء',
      import: 'استيراد',
      notSynced: 'لم تتم مزامنة جهات الاتصال بعد. وصّل الهاتف وانتظر.',
      deleteAllContacts: 'حذف جميع جهات الاتصال',
      deleteSelectedContacts: 'حذف جهات الاتصال المحددة',
      cancelSelection: 'إلغاء التحديد',
      deleteSelected: 'حذف المحددة',
      status: 'الحالة',
      userNotFound: 'مستخدم غير موجود',
      notAssigned: 'غير مُعيّن',
      openConversation: 'فتح المحادثة',
    },
    financeiroPage: {
      paid: 'مدفوع',
      overdue: 'متأخر',
      open: 'مفتوح',
      yes: 'نعم',
      no: 'لا',
    },
    adminFinanceiro: {
      title: 'الإدارة المالية',
      totalRevenue: 'إجمالي الإيرادات',
      openInvoices: 'فواتير مفتوحة',
      overdueInvoices: 'فواتير متأخرة',
      totalInvoices: 'إجمالي الفواتير',
      paidInvoices: 'فواتير مدفوعة',
      allCompanies: 'جميع الشركات',
      statusDistribution: 'توزيع الحالة',
      revenueByMonth: 'الإيرادات حسب الشهر',
      defaultByMonth: 'التخلف حسب الشهر',
      revenue: 'الإيرادات',
      defaulting: 'التخلف',
      search: 'بحث فاتورة...',
      filterStatus: 'تصفية الحالة',
      all: 'الكل',
      paid: 'مدفوع',
      open: 'مفتوح',
      overdue: 'متأخر',
      company: 'الشركة',
      detail: 'التفاصيل',
      users: 'المستخدمون',
      connections: 'الاتصالات',
      value: 'القيمة',
      dueDate: 'تاريخ الاستحقاق',
      daysLeft: 'الأيام',
      status: 'الحالة',
      daysRemaining: 'أيام متبقية',
      daysOverdue: 'أيام متأخرة',
      action: 'الإجراء',
      refund: 'استرجاع',
      refunded: 'تم الاسترجاع',
      refundTitle: 'استرجاع الفاتورة',
      refundMessage: 'هل أنت متأكد أنك تريد استرجاع هذه الفاتورة؟',
      refundSuccess: 'تم استرجاع الفاتورة بنجاح.',
    },
    companyFinanceiro: {
      title: 'خطتي والمالية',
      myPlan: 'خطتي',
      company: 'الشركة',
      users: 'المستخدمون',
      connections: 'الاتصالات',
      queues: 'الطوابير',
      value: 'القيمة',
      daysLeft: 'أيام متبقية',
      daysOverdue: 'أيام متأخرة',
      expiresOn: 'ينتهي في',
      expiredTitle: 'اشتراك منتهي!',
      expiredMessage: 'انتهى اشتراكك. يرجى التجديد للاستمرار في استخدام النظام.',
      availablePlans: 'الخطط المتاحة',
      currentPlan: 'الخطة الحالية',
      changePlan: 'تغيير الخطة',
      earlyPayment: 'دفع مبكر',
      month: 'شهر',
      invoiceHistory: 'سجل الفواتير',
      detail: 'التفاصيل',
      dueDate: 'تاريخ الاستحقاق',
      status: 'الحالة',
      action: 'الإجراء',
      pay: 'دفع',
      refund: 'استرجاع',
      refundTitle: 'استرجاع الفاتورة',
      refundMessage: 'هل أنت متأكد أنك تريد استرجاع هذه الفاتورة؟',
      refundSuccess: 'تم استرجاع الفاتورة بنجاح.',
      features: {
        campaigns: 'الحملات',
        schedules: 'الجداول',
        internalChat: 'الدردشة الداخلية',
        integrations: 'التكاملات',
        flows: 'التدفقات',
        contacts: 'جهات الاتصال',
        realTime: 'الوقت الفعلي',
        kanban: 'كانبان',
        openai: 'OpenAI',
        telegram: 'تيليجرام',
        zapi: 'Z-API',
        dashboard: 'لوحة التحكم',
      },
    },
    checkout: {
      almostDone: 'اقتربت!',
      steps: { data: 'البيانات', customize: 'تخصيص', review: 'مراجعة' },
      back: 'رجوع',
      pay: 'دفع',
      next: 'التالي',
      select: 'اختيار',
      users: 'المستخدمون',
      connection: 'الاتصال',
      queues: 'الطوابير',
      perMonth: '/شهر',
      subscriptionSuccess: 'تم الاشتراك بنجاح! في انتظار الدفع.',
      total: 'المجموع',
      copied: 'تم النسخ',
      copyQrPix: 'نسخ رمز QR PIX',
      pixInstructions: 'لإتمام العملية، قم بالدفع عن طريق مسح أو لصق رمز Pix أعلاه أو اختر الدفع ببطاقة الائتمان أدناه.',
      payWithCard: 'الدفع ببطاقة الائتمان',
      payWithMercadoPago: 'الدفع عبر MercadoPago',
      payWithAsaas: 'الدفع عبر Asaas',
      licenseRenewed: 'تم تجديد ترخيصك حتى',
      subscriptionSummary: 'ملخص الاشتراك',
      planDetails: 'تفاصيل الخطة',
      billing: 'الفوترة',
      monthly: 'شهري',
      paymentInfo: 'معلومات الدفع',
      email: 'البريد الإلكتروني',
      name: 'الاسم',
      cpfCnpj: 'الرقم الضريبي',
      fullName: 'الاسم الكامل*',
      fullNameRequired: 'الاسم الكامل مطلوب',
      address: 'العنوان*',
      addressRequired: 'العنوان مطلوب',
      city: 'المدينة*',
      cityRequired: 'المدينة مطلوبة',
      state: 'الولاية*',
      stateRequired: 'الولاية مطلوبة',
      cpfCnpjLabel: 'الرقم الضريبي*',
      cpfCnpjRequired: 'الرقم الضريبي مطلوب',
      country: 'البلد*',
      countryRequired: 'البلد مطلوب',
    },
    chatPage: {
      loadUsersError: 'خطأ في تحميل المستخدمين',
      chatExists: 'المحادثة مع هذا المستخدم موجودة بالفعل!',
      chatCreated: 'تم إنشاء المحادثة بنجاح!',
      chatCreateError: 'خطأ في إنشاء المحادثة',
      group: 'مجموعة',
      user: 'مستخدم',
      internalChat: 'محادثة داخلية رقم ',
      chat: 'محادثة',
      noMessages: 'لا توجد رسائل',
      editGroup: 'تعديل المجموعة',
      createGroup: 'إنشاء مجموعة',
      changeGroupPhoto: 'تغيير صورة المجموعة',
      addGroupPhoto: 'إضافة صورة المجموعة',
      titleLabel: 'العنوان',
      titlePlaceholder: 'العنوان',
      descriptionLabel: 'الوصف',
      descriptionPlaceholder: 'وصف المجموعة',
      editTimeLimit: 'يمكن تعديل الرسائل المرسلة قبل أقل من 10 دقائق فقط.',
      messageDeleted: 'تم حذف هذه الرسالة',
      chatEditError: 'خطأ في إنشاء/تعديل المحادثة',
    },
    flowBuilderPage: {
      activeStatus: 'نشط',
      inactiveStatus: 'غير نشط',
      flowDeleted: 'تم حذف التدفق بنجاح',
      flowDuplicated: 'تم تكرار التدفق بنجاح',
      flowActivated: 'تم تفعيل التدفق بنجاح',
      flowDeactivated: 'تم إلغاء تفعيل التدفق بنجاح',
      searchFlows: 'بحث التدفقات...',
      createFlow: 'إنشاء تدفق',
      statTotal: 'إجمالي التدفقات',
      statActive: 'التدفقات النشطة',
      statPaused: 'متوقفة',
      statDrafts: 'مسودات',
    },
    instagramReplyCommentNode: {
      count: '{{count}} رد',
      help: '💬 يرد <b>علنياً</b> على التعليق (يراه الجميع). إذا كانت هناك عدة خيارات، يختار واحداً عشوائياً.',
    },
    n8nTriggerNode: {
      configureUrl: 'قم بتكوين عنوان webhook',
      help: 'يطلق webhook n8n مع الأحداث المحددة.',
    },
    flowBuilderConfigPage: {
      basics: 'الأساسيات',
      addNodes: 'إضافة عقد',
      start: 'البداية',
      startDesc: 'نقطة بداية التدفق',
      content: 'المحتوى',
      contentDesc: 'إرسال نص، صورة، صوت أو فيديو',
      textNode: 'نص',
      textDesc: 'رسالة نصية بسيطة',
      interaction: 'التفاعل',
      menu: 'القائمة',
      menuDesc: 'قائمة خيارات رقمية',
      interactiveApi: 'رسالة تفاعلية API',
      interactiveApiDesc: 'أزرار وقوائم (Baileys)',
      input: 'إدخال',
      inputDesc: 'جمع مدخلات المستخدم',
      interval: 'فاصل زمني',
      intervalDesc: 'إيقاف التنفيذ مؤقتاً لفترة',
      logic: 'منطق',
      randomizer: 'عشوائي',
      randomizerDesc: 'اختيار عشوائي للمسارات',
      ifElse: 'إذا/وإلا (If/Else)',
      ifElseDesc: 'تفريع التدفق بناءً على شرط',
      system: 'النظام',
      queues: 'قوائم الانتظار',
      queuesDesc: 'إدارة قوائم الخدمة',
      tags: 'العلامات',
      tagsDesc: 'إضافة علامات للمتصل',
      removeTag: 'إزالة علامة',
      removeTagDesc: 'إزالة علامات من المتصل',
      switchFlow: 'تبديل التدفق',
      switchFlowDesc: 'التوجيه إلى تدفق آخر',
      attendant: 'موظف',
      attendantDesc: 'تحويل إلى موظف',
      variable: 'متغير',
      variableDesc: 'تعيين المتغيرات العامة',
      aiAgent: 'وكيل ذكاء اصطناعي',
      aiAgentDesc: 'استخدام وكيل ذكاء اصطناعي مُعد',
      httpRequest: 'طلب HTTP',
      httpRequestDesc: 'طلب HTTP خارجي',
      flowEditor: 'محرر التدفقات',
      n8nTriggerName: 'مشغل n8n',
      n8nTriggerDesc: 'يطلق ويب هوك n8n قابل للتكوين (تذكرة، اتصال، رسالة، جهة اتصال) مع مصادقة أساسية وسجلات في الوقت الفعلي.',
      googleCalendarName: 'تقويم Google',
      googleCalendarDesc: 'ينشئ حدثًا في تقويم Google الخاص بالشركة باستخدام البيانات المجمعة في المحادثة (التاريخ، الوقت، المختص، العميل).',
      instagramCategory: 'إنستغرام',
      igTrigger: 'المشغل: تعليق إنستغرام',
      igTriggerDesc: 'ابدأ هنا! يبدأ التدفق عندما يعلق شخص ما على منشورك أو الريل.',
      igReply: 'الرد على التعليق',
      igReplyDesc: 'يرد علنًا على التعليق (يرى الجميع الرد).',
      igLike: 'إعجاب بالتعليق',
      igLikeDesc: 'يعجب بالتعليق تلقائيًا — يظهر أنك رأيته.',
      igIsFollower: 'هل هو متابع؟',
      igIsFollowerDesc: 'يتحقق مما إذا كان الشخص يتابعك. ينشئ مسارين: يتابع / لا يتابع.',
      igSendDm: 'إرسال رسالة خاصة',
      igSendDmDesc: 'يرسل رسالة خاصة (مباشرة) لمن علق.',
      igRewardPdf: 'إرسال مكافأة (PDF)',
      igRewardPdfDesc: 'يرسل ملفًا (PDF، صورة، فيديو) في الخاص. ممتاز للجذب.',
      waitInput: 'انتظار الرد',
      waitInputDesc: 'يوقف التدفق مؤقتًا حتى يرد العميل',
      exit: 'خروج / إنهاء',
      exitDesc: 'ينهي الخدمة (يغلق التذكرة)',
      exitNodeClosesTicket: 'يغلق الخدمة',
      waitInputSaveIn: 'حفظ في',
      waitInputNodePausesFlow: 'يوقف التدفق مؤقتًا حتى رد العميل',
      exitDefaultFarewell: 'انتهت الخدمة. شكرًا لتواصلك معنا!',
      exitModalTitle: 'خروج / إنهاء الخدمة',
      exitModalBody: 'عند الوصول إلى هذه العقدة يتم إنهاء الخدمة (إغلاق التذكرة). مثالي للربط بخيار "خروج" من قائمة.',
      exitModalFarewellLabel: 'رسالة الوداع (اختياري)',
      cancel: 'إلغاء',
      save: 'حفظ',
      waitInputDefaultReminder: 'مرحبًا {{name}}، هل ما زلت هناك؟ هل يمكننا متابعة خدمتك؟',
      waitInputModalTitle: 'انتظار رد العميل',
      waitInputModalBody: 'يتوقف التدفق عند هذه العقدة حتى يرسل العميل رسالة جديدة. يصبح الرد متاحًا كمتغير للعقد التالية.',
      waitInputVariableLabel: 'اسم المتغير',
      waitInputVariableHelp: 'سيتم حفظ الرد باسم {{nomeDaVariavel}}',
      waitInputSendReminder: 'إرسال تذكير إذا لم يرد العميل',
      waitInputReminderDelay: 'الانتظار قبل التذكير (دقائق)',
      waitInputReminderMessage: 'رسالة التذكير',
      waitInputAvailableVars: 'المتغيرات المتاحة: {{name}}, {{firstName}}, {{queue}}, {{protocol}}, {{userName}}, {{ms}}, {{date}}, {{hour}}, {{ticket_id}}, {{connection}}',
      waitInputTimeoutActionLabel: 'بعد التذكير، إذا لم يرد العميل',
      waitInputTimeoutContinueFlow: 'استئناف التدفق من حيث توقف',
      waitInputTimeoutCloseTicket: 'إنهاء الخدمة',
      waitInputTimeoutKeepWaiting: 'الاستمرار في الانتظار إلى أجل غير مسمى',
      waitInputTimeoutDelay: 'مدة الانتظار بعد التذكير (دقائق)',
      waitInputTimeoutDelayHelp: 'إذا كانت القيمة 0، يحدث الإجراء فور إرسال التذكير',
    },
    templateMetaModal: {
      title: 'قوالب واتساب',
      searchPlaceholder: 'البحث في القوالب',
      templateContent: 'محتوى القالب:',
      category: 'الفئة:',
      language: 'اللغة:',
      selectedDetails: 'تفاصيل القالب المحدد',
      name: 'الاسم:',
      content: 'المحتوى:',
      fillValue: 'أدخل القيمة لـ',
      requiredField: 'حقل مطلوب',
      sendTemplate: 'إرسال القالب',
      back: 'رجوع',
    },
    messagesAPIPage: {
      sendTextMedia: 'إرسال نص / وسائط',
      yourMessageHere: 'رسالتك هنا',
      sendImageUrl: 'إرسال صورة بالرابط',
      imageCaption: 'وصف الصورة',
      sendNoTicket: 'إرسال سريع (بدون تذكرة)',
      messageNoTicket: 'رسالة بدون تذكرة',
      batchSend: 'إرسال مجمّع',
      interactiveMessages: 'رسائل تفاعلية',
      chooseOption: 'اختر خياراً:',
      optionalFooter: 'تذييل اختياري',
      sales: 'المبيعات',
      support: 'الدعم',
      financial: 'المالية',
      sidebar: {
        playground: 'ساحة التجربة',
        history: 'السجل',
        intro: 'مقدمة',
        messages: 'واجهة الرسائل',
        contacts: 'جهات الاتصال',
        tickets: 'التذاكر / المحادثات',
        testEndpoint: 'اختبار نقطة النهاية',
        searchEndpoint: 'بحث عن نقطة نهاية...',
        requestCount: 'طلب(طلبات)',
        clearHistory: 'مسح السجل',
        noRequests: 'لا توجد طلبات بعد',
        remove: 'إزالة',
        supportsGroups: 'يدعم المجموعات',
        docSubtitle: 'وثائق كاملة — {{count}} نقطة نهاية',
      },
      introItems: {
        auth: 'المصادقة',
        rateLimit: 'حد المعدل',
        errorCodes: 'رموز الخطأ',
      },
      endpoints: {
        checkNumber: 'التحقق من الرقم',
        listConnections: 'قائمة الاتصالات',
        listContacts: 'قائمة جهات الاتصال',
        showContact: 'بحث عن جهة اتصال',
        createContact: 'إنشاء جهة اتصال',
        updateContact: 'تحديث جهة اتصال',
        deleteContact: 'حذف جهة اتصال',
        listTickets: 'قائمة التذاكر',
        showTicket: 'بحث عن تذكرة',
        createTicket: 'إنشاء تذكرة',
        updateTicket: 'تحديث تذكرة',
        deleteTicket: 'حذف تذكرة',
        closeAllTickets: 'إغلاق جميع التذاكر',
        messagesRange: 'رسائل حسب الفترة',
      },
      playground: {
        title: 'ساحة تجربة API',
        desc: 'اختبر نقاط نهاية API الخاصة بك مباشرة هنا. أدخل عنوان URL الأساسي للخادم ورمز المصادقة الخاص بك.',
        apiUrl: 'عنوان API',
        token: 'الرمز',
        copyCurl: 'نسخ cURL',
        selectEndpoint: 'اختر نقطة نهاية محددة مسبقاً',
        group: 'مجموعة',
        send: 'إرسال',
        uploadMedia: 'رفع وسائط',
        formatJson: 'تنسيق JSON',
        mediaHint: 'صورة، فيديو، صوت أو مستند. يعمل أيضاً مع المجموعات!',
        error: 'خطأ',
        response: 'استجابة',
        yourToken: '<رمزك>',
      },
      badges: {
        new: 'جديد',
        required: 'مطلوب',
        optional: 'اختياري',
      },
      docs: {
        authTitle: 'المصادقة',
        authDesc: 'تتطلب جميع نقاط النهاية مصادقة عبر رمز Bearer. يجب تسجيل الرمز في اتصال WhatsApp عبر قائمة <b>الاتصالات → تعديل → الرمز</b>.',
        rateLimitTitle: 'حد المعدل',
        rateLimitDesc: 'لتجنب حظر WhatsApp، يُوصى بفاصل زمني لا يقل عن <b>ثانيتين</b> بين الإرسالات. في الإرسال المجمّع، استخدم معامل <code>delay</code> للتحكم في الفاصل.',
        errorCodesTitle: 'رموز الخطأ',
        messagesSection: 'واجهة الرسائل',
        contactsSection: 'جهات الاتصال',
        ticketsSection: 'التذاكر / المحادثات',
        parameter: 'المعامل',
        type: 'النوع',
        description: 'الوصف',
        code: 'الرمز',
        meaning: 'المعنى',
        success: 'نجاح',
        invalidParams: 'معاملات غير صالحة أو مفقودة',
        invalidToken: 'رمز غير صالح أو غير مقدم',
        notFound: 'المورد غير موجود',
        serverError: 'خطأ داخلي في الخادم',
        sendTextTitle: 'إرسال نص / وسائط',
        sendTextDesc: 'يرسل رسالة نصية أو وسائط (صورة، فيديو، صوت، مستند) إلى جهات اتصال فردية أو <b>مجموعات</b>. للإرسال إلى مجموعة، اضبط <code>"isGroup": true</code> ومعرف المجموعة JID في حقل <code>number</code>.',
        paramNumber: 'رقم جهة الاتصال أو JID المجموعة',
        paramBody: 'نص الرسالة أو وصف الوسائط',
        paramIsGroup: 'إذا <code>true</code>، يرسل إلى المجموعة باستخدام <code>@g.us</code>',
        paramMedias: 'ملف وسائط (multipart/form-data)',
        paramUserId: 'معرف الوكيل للتعيين',
        paramQueueId: 'معرف قائمة الانتظار للتوجيه',
        paramSendSignature: 'تضمين اسم الوكيل في الرسالة',
        paramCloseTicket: 'إغلاق التذكرة بعد الإرسال',
        paramNoRegister: 'إرسال بدون إنشاء تذكرة',
        sendImageTitle: 'إرسال صورة بالرابط',
        sendImageDesc: 'يرسل صورة من رابط عام إلى جهة اتصال أو <b>مجموعة</b>.',
        paramUrl: 'رابط الصورة العام',
        paramCaption: 'وصف',
        paramIsGroupSend: 'إذا <code>true</code>، يرسل إلى المجموعة',
        sendNoTicketTitle: 'إرسال سريع (بدون تذكرة)',
        sendNoTicketDesc: 'يرسل رسالة نصية بدون إنشاء تذكرة. يعمل مع جهات الاتصال و<b>المجموعات</b>.',
        bulkTitle: 'إرسال مجمّع (Bulk)',
        bulkDesc: 'يرسل حتى 100 رسالة لكل دفعة. يمكن لكل رسالة أن تحتوي على <code>isGroup: true</code> بشكل فردي.',
        buttonsTitle: 'رسائل تفاعلية',
        buttonsDesc: 'يرسل رسائل تفاعلية مع أزرار، قوائم، روابط وPIX. يعمل مع جهات الاتصال و<b>المجموعات</b>.',
        checkNumberTitle: 'التحقق من الرقم',
        checkNumberDesc: 'يتحقق إذا كان الرقم يمتلك حساب WhatsApp نشط.',
        listContactsTitle: 'قائمة جهات الاتصال',
        listContactsDesc: 'يعيد جميع جهات اتصال الشركة. يدعم التصفح والبحث.',
        paramSearchParam: 'بحث بالاسم أو الرقم أو البريد',
        paramPageNumber: 'رقم الصفحة (افتراضي: 1)',
        showContactTitle: 'بحث عن جهة اتصال بالمعرف',
        showContactDesc: 'يعيد بيانات جهة اتصال محددة بالمعرف.',
        createContactTitle: 'إنشاء جهة اتصال',
        createContactDesc: 'ينشئ جهة اتصال جديدة في قاعدة البيانات.',
        paramName: 'اسم جهة الاتصال',
        paramNumberWhatsApp: 'رقم WhatsApp مع رمز البلد+المنطقة',
        paramEmail: 'بريد جهة الاتصال',
        paramExtraInfo: 'حقول مخصصة',
        updateContactTitle: 'تحديث جهة اتصال',
        updateContactDesc: 'يحدّث بيانات جهة اتصال موجودة.',
        deleteContactTitle: 'حذف جهة اتصال',
        deleteContactDesc: 'يحذف جهة اتصال نهائياً. <b>تحذير:</b> لا يمكن التراجع عن هذا الإجراء.',
        listTicketsTitle: 'قائمة التذاكر',
        listTicketsDesc: 'يعيد التذاكر مع فلاتر حسب الحالة وقائمة الانتظار والوكيل. يدعم التصفح.',
        paramStatus: '<code>open</code>، <code>pending</code>، <code>closed</code>',
        paramQueueIds: 'معرفات قوائم الانتظار مفصولة بفاصلة',
        paramSearchTicket: 'بحث بالرسالة أو جهة الاتصال أو التذكرة',
        paramShowAll: '<code>"true"</code> لعرض جميع التذاكر',
        showTicketTitle: 'بحث عن تذكرة بالمعرف',
        showTicketDesc: 'يعيد التفاصيل الكاملة لتذكرة، بما في ذلك جهة الاتصال وقائمة الانتظار والوكيل والرسائل.',
        createTicketTitle: 'إنشاء تذكرة',
        createTicketDesc: 'ينشئ تذكرة جديدة مرتبطة بجهة اتصال. مفيد لبدء المحادثات برمجياً.',
        paramContactId: 'معرف جهة الاتصال المرتبطة',
        paramStatusDefault: '<code>open</code>، <code>pending</code> (افتراضي: open)',
        paramQueueIdTicket: 'معرف قائمة الانتظار',
        paramUserIdTicket: 'معرف الوكيل المسؤول',
        updateTicketTitle: 'تحديث تذكرة',
        updateTicketDesc: 'يحدّث حالة أو قائمة انتظار أو وكيل تذكرة. مفيد لنقل أو إغلاق التذاكر عبر API.',
        paramNewQueueId: 'معرف قائمة الانتظار الجديدة',
        paramNewUserId: 'معرف الوكيل الجديد',
        deleteTicketTitle: 'حذف تذكرة',
        deleteTicketDesc: 'يحذف تذكرة ورسائلها نهائياً. <b>تحذير:</b> هذا الإجراء لا رجعة فيه.',
        closeAllTitle: 'إغلاق جميع التذاكر',
        closeAllDesc: 'يغلق جميع التذاكر المفتوحة دفعة واحدة. مثالي للتنظيف المجمّع.',
        messagesRangeTitle: 'رسائل حسب الفترة',
        messagesRangeDesc: 'يعيد الرسائل ضمن نطاق تاريخ.',
        paramCompanyId: 'معرف الشركة',
        paramStartDate: 'تاريخ البداية (YYYY-MM-DD)',
        paramEndDate: 'تاريخ النهاية (YYYY-MM-DD)',
        paramNumberOrJid: 'الرقم أو JID المجموعة',
      },
    },
    templateManagerPage: {
      title: 'إدارة القوالب',
      connection: 'اتصال',
      search: 'بحث...',
      syncTooltip: 'مزامنة مع Meta',
      sync: 'مزامنة',
      createTemplate: 'إنشاء قالب',
      submitApproval: 'إرسال للموافقة',
      noOfficialConnection: 'لم يتم العثور على اتصال API رسمي. أضف اتصالاً رسمياً لإدارة القوالب.',
      noTemplatesFound: 'لم يتم العثور على قوالب. انقر على "مزامنة" للمزامنة أو "إنشاء قالب" لإنشاء واحد جديد.',
      tableName: 'الاسم',
      tableCategory: 'الفئة',
      tableLanguage: 'اللغة',
      tableStatus: 'الحالة',
      tableActions: 'الإجراءات',
      viewDetails: 'عرض التفاصيل',
      editTemplate: 'تعديل (إعادة إنشاء القالب)',
      deleteTemplate: 'حذف القالب',
      marketing: 'تسويق',
      utility: 'خدمات',
      authentication: 'مصادقة',
    },
    userPerformance: {
      title: 'أداء الوكلاء',
      subtitle: 'تحليل مفصل لأداء كل وكيل على حدة',
      fetchError: 'خطأ في تحميل بيانات الأداء',
      loading: 'جار التحميل...',
      noData: 'لم يتم العثور على بيانات للفترة المحددة',
      summary: {
        totalTickets: 'إجمالي التذاكر',
        activeUsers: 'الوكلاء النشطون',
        avgSupportTime: 'متوسط وقت الدعم',
        avgWaitTime: 'متوسط وقت الانتظار',
        avgRating: 'متوسط التقييم',
      },
      charts: {
        ticketsByUser: 'التذاكر حسب الوكيل',
        statusDistribution: 'توزيع الحالة',
      },
      table: {
        title: 'تفاصيل حسب الوكيل',
        user: 'الوكيل',
        totalTickets: 'الإجمالي',
        open: 'مفتوحة',
        pending: 'معلقة',
        closed: 'مغلقة',
        avgTime: 'الوقت المتوسط',
        avgWait: 'الانتظار المتوسط',
        minTime: 'أقل وقت',
        maxTime: 'أقصى وقت',
        rating: 'التقييم',
        distribution: 'التوزيع',
      },
    },
    messagePreview: {
      title: "معاينة",
      subtitle: "شاهد كيف ستظهر رسالتك",
      contact: "جهة الاتصال",
      online: "متصل",
      emptyState: "لا توجد رسائل للمعاينة",
      typePlaceholder: "اكتب رسالة...",
      availableVars: "المتغيرات المتاحة:",
      greetingExample: "صباح الخير",
      attachedMedia: "وسائط مرفقة",
    },
    reportsExtra: {
      statusDistribution: "توزيع حسب الحالة",
      ticketsByQueue: "التذاكر حسب القسم",
      ticketsByUser: "التذاكر حسب المستخدم",
      noQueue: "بدون قسم",
      noUser: "بدون مستخدم",
      noDataForChart: "لا توجد بيانات للعرض",
    },
    flowDefaultPage: {
      title: "التدفق الافتراضي",
      welcomeFlow: "تدفق الترحيب",
      welcomeFlowDesc: "يتم تشغيل هذا التدفق فقط لجهات الاتصال الجديدة، الأشخاص غير الموجودين في قائمة جهات الاتصال الخاصة بك والذين أرسلوا رسالة",
      defaultResponseFlow: "تدفق الرد الافتراضي",
      defaultResponseFlowDesc: "يتم إرسال الرد الافتراضي مع أي حرف مختلف عن كلمة مفتاحية. تنبيه! سيتم تشغيله إذا كانت التذكرة مغلقة بالفعل.",
      defaultResponseFlowDescLong: "يتم إرسال الرد الافتراضي مع أي حرف مختلف عن كلمة مفتاحية. تنبيه! سيتم تشغيله إذا كانت التذكرة مغلقة بالفعل ومرت 6 ساعات على إغلاقها.",
      linkedFlow: "التدفق المرتبط",
      linkedFlowDesc: "تدفق يتم تنفيذه في هذا الاتصال لجهات الاتصال الجديدة وللرسائل خارج الكلمات المفتاحية. يعمل بشكل مستقل عن أي تكامل خارجي.",
      disabled: "معطل",
      chooseFlow: "اختر تدفقاً",
      disconnect: "قطع الاتصال",
      save: "حفظ",
      deleteConfirm: "هل أنت متأكد من رغبتك في حذف هذا التدفق؟ ستفقد جميع التكاملات المرتبطة.",
    },
    flowBuilderAIGenerate: {
      button: "إنشاء بالذكاء الاصطناعي",
      title: "إنشاء تدفق بالذكاء الاصطناعي",
      help: "صف ما يجب أن يفعله التدفق. سينشئ الذكاء الاصطناعي جميع العقد والاتصالات تلقائيًا، جاهزة للربط باتصال.",
      category: "الفئة",
      namePlaceholder: "اسم التدفق (اختياري)",
      description: "وصف التدفق",
      examplesLabel: "أمثلة سريعة (انقر للاستخدام)",
      keyNotice: "يستخدم الذكاء الاصطناعي المفتاح المُهيأ في الإعدادات > الذكاء الاصطناعي للشركة. يبدأ التدفق المُنشأ متوقفًا مؤقتًا، جاهزًا للتحرير والربط بالاتصالات.",
      generate: "إنشاء التدفق",
      generating: "جارٍ الإنشاء...",
      cancel: "إلغاء",
      success: "تم إنشاء التدفق بنجاح!",
      descriptionTooShort: "يرجى وصف التدفق بمزيد من التفصيل.",
      categories: {
        customerService: "خدمة العملاء",
        sales: "المبيعات / ما قبل البيع",
        support: "الدعم الفني",
        leadQualification: "تأهيل العملاء المحتملين",
        scheduling: "الجدولة",
        nps: "استطلاع الرضا (NPS)",
        welcome: "الترحيب / القائمة الرئيسية",
        billing: "الفوترة / المالية",
        other: "أخرى"
      },
      examples: {
        example1: "قائمة رئيسية بخيارات: التحدث إلى المبيعات، الدعم الفني، المالية. كل خيار يحوّل إلى قائمة الانتظار المطابقة.",
        example2: "تأهيل العميل المحتمل: اسأل عن الاسم والشركة والميزانية، ثم حوّل إلى المبيعات.",
        example3: "استطلاع NPS بعد الخدمة: اطلب تقييمًا من 0 إلى 10 واشكر العميل.",
        example4: "الجدولة: اسأل عن الاسم والتاريخ والوقت المفضل، ثم حوّل إلى قائمة الانتظار."
      }
    },
    flowBuilderPageExtra: {
      title: "تدفقات المحادثة",
      newFlow: "تدفق جديد",
      importZip: "استيراد (.zip)",
      noFlowFound: "لم يتم العثور على تدفق",
      noFlowCreated: "لم يتم إنشاء أي تدفق بعد",
      tryOtherSearch: "حاول استخدام مصطلحات بحث أخرى",
      createFirstFlowDesc: "أنشئ أول تدفق محادثة لأتمتة الدعم",
      createFirstFlow: "إنشاء أول تدفق",
    },
    floupPage: {
      title: "Follow UP - قوالب التدفق",
      filterActive: "نشط",
      filterError: "بأخطاء",
      filterPaused: "متوقف",
      filterAll: "الكل",
      newTemplate: "قالب جديد",
      editTemplate: "تعديل القالب",
      basicInfo: "المعلومات الأساسية",
      templateName: "اسم القالب",
      templateType: "نوع القالب",
      description: "الوصف",
      triggerCondition: "شرط التشغيل",
      triggerConditionDesc: "حدد متى يجب تشغيل هذا Follow UP. بمجرد التشغيل، سيتم تنفيذ جميع الخطوات بالتسلسل حتى يتم استيفاء شروط الإيقاف.",
      condition: "الشرط",
      systemQueue: "قائمة انتظار النظام",
      systemTag: "وسم النظام",
      firstClientInteraction: "أول تفاعل للعميل",
      firstAttendantInteraction: "أول تفاعل للموظف",
      queue: "قائمة الانتظار",
      selectQueue: "اختر قائمة الانتظار",
      tag: "الوسم",
      selectTag: "اختر الوسم",
      conditionDescription: "وصف الشرط",
      conditionPlaceholder: "مثال: أرسل العميل الرسالة الأولى",
      flowStopControls: "أدوات إيقاف التدفق",
      stopAnyMessage: "1. إذا رد جهة الاتصال بأي رسالة",
      stopKeyword: "2. إذا رد جهة الاتصال بكلمة مفتاحية",
      keyword: "كلمة مفتاحية",
      keywordPlaceholder: "مثال: توقف، إلغاء، خروج",
      stopTicketClosed: "3. إذا تم إغلاق التذكرة",
      flowSteps: "خطوات التدفق",
      addStep: "إضافة خطوة",
      cancel: "إلغاء",
      saveTemplate: "حفظ القالب",
      confirmDeleteTitle: "تأكيد الحذف",
      confirmDeleteMessage: "هل أنت متأكد من رغبتك في حذف Follow UP",
      confirmDeleteWarning: "لا يمكن التراجع عن هذا الإجراء وسيتم حذف جميع الوسائط المرتبطة نهائياً.",
      delete: "حذف",
      duplicate: "تكرار",
      edit: "تعديل",
      steps: "خطوات",
      active: "نشط",
      inactive: "غير نشط",
      customized: "مخصص",
      client: "عميل",
      lead: "عميل محتمل",
      basicInfoDesc: "قم بتكوين اسم ونوع Follow Up الخاص بك. النوع يحدد قالب الرسائل الأولي.",
      stepsDesc: "قم بتكوين خطوات تدفق Follow Up. استخدم الأسهم لإعادة الترتيب.",
      stopControlsDesc: "حدد متى يجب أن يتوقف Follow Up تلقائياً.",
      subtitle: "إدارة قوالب Follow Up",
      noFlowsYet: "لم يتم إنشاء أي Follow UP بعد",
      step: "خطوة",
      emptyMessage: "رسالة فارغة",
      message: "رسالة",
      variablesHint: "المتغيرات: {" + "{الاسم}}, {" + "{البروتوكول}}, {" + "{قائمة_الانتظار}}",
      interval: "الفاصل الزمني",
      unit: "الوحدة",
      minutesLabel: "دقائق",
      hoursLabel: "ساعات",
      daysLabel: "أيام",
      weeksLabel: "أسابيع",
      monthsLabel: "أشهر",
      attachment: "مرفق/وسائط",
      pasteUrl: "الصق الرابط...",
      choose: "اختيار",
      uploadError: "خطأ في الرفع.",
      removeStep: "إزالة الخطوة",
      conversationPreview: "معاينة المحادثة",
      addStepsForPreview: "أضف خطوات لرؤية المعاينة",
      afterLabel: "بعد",
      fileLabel: "ملف",
      previous: "السابق",
      next: "التالي",
      queueLabel: "قائمة الانتظار",
      tagLabel: "الوسم",
      interactionLabel: "التفاعل",
      stepsCount: "خطوات",
    },
    templateManagerPageExtra: {
      createNewTemplate: "إنشاء قالب جديد",
      templateNameLabel: "اسم القالب",
    },
    templateManagerForm: {
      rejected: "تم رفضه من قبل Meta",
      syncComplete: "اكتملت المزامنة",
      statusChanged: "مع تغييرات في الحالة",
      syncNoChanges: "تمت مزامنة القوالب - لا توجد تغييرات في الحالة",
      tokenExpired: "⚠️ انتهت صلاحية رمز API الرسمي أو أنه غير صالح! قم بتحديث رمز الوصول من Meta في إعدادات الاتصال.",
      nameBodyRequired: "الاسم ونص الرسالة مطلوبان",
      nameValidation: "يجب أن يحتوي اسم القالب على أحرف صغيرة وأرقام وشرطات سفلية (_) فقط",
      sentForApproval: "تم إرسال القالب للموافقة من Meta!",
      deleteSuccess: "تم حذف القالب بنجاح!",
      confirmDeleteMessage: "سيؤدي هذا الإجراء إلى حذف القالب في Meta ومحلياً. هل تريد المتابعة؟",
      templateDetails: "تفاصيل القالب",
      name: "الاسم",
      language: "اللغة",
      status: "الحالة",
      category: "الفئة",
      components: "المكونات",
      close: "إغلاق",
      nameHelper: "أحرف صغيرة وأرقام و _ فقط",
      headerOptional: "رأس (اختياري)",
      headerHelper: "نص يظهر في أعلى القالب",
      messageBody: "نص الرسالة",
      messageBodyHelper: "استخدم {{1}}، {{2}}، إلخ للمتغيرات. مثال: مرحباً {{1}}، طلبك {{2}} جاهز!",
      footerOptional: "تذييل (اختياري)",
      footerHelper: "نص صغير في نهاية القالب",
      buttonsOptional: "أزرار (اختياري - حد أقصى 3)",
      quickReply: "رد سريع",
      phone: "هاتف",
      text: "نص",
      preview: "معاينة",
      button: "زر",
      cancel: "إلغاء",
    },
    whatsappModalRel: {
      form: {
        resolveAndTriggerIntegration: "حل وتشغيل التكامل",
        reportFilename: "تقرير_التذكرة_",
        elementNotFoundForExport: "العنصر غير موجود للتصدير",
      },
    },
    announcementsPopover: {
      title: "الإعلانات",
      dontShowAgain: "لا تعرض مرة أخرى",
      dismiss: "تجاهل",
      dismissAll: "تجاهل الكل",
      close: "إغلاق",
      backToList: "العودة للقائمة",
      dismissedToast: "لن يتم عرض هذا الإعلان بعد الآن. سيظهر مجدداً فقط عند وجود تحديثات.",
      priority: {
        high: "عالية",
        medium: "متوسطة",
        low: "منخفضة",
      },
      priorityLabel: "الأولوية",
    },
    ticketsManagerExtra: {
      viewAll: "الكل",
      ascending: "تصاعدي",
      descending: "تنازلي",
      searchOnMessages: "حدد للبحث أيضًا في محتوى الرسائل (أبطأ)",
    },
    announcementsPage: {
      noPermission: "هذه الشركة ليس لديها إذن للوصول إلى هذه الصفحة! جارٍ إعادة التوجيه.",
      priorityHigh: "عالية",
      priorityMedium: "متوسطة",
      priorityLow: "منخفضة",
    },
    pairingCodeModalExtra: {
      phoneRequired: "أدخل رقم الهاتف.",
      phoneTooShort: "الرقم قصير جدًا. أضف رمز البلد + رمز المنطقة.",
      phoneTooLong: "الرقم طويل جدًا.",
      phoneBrazil: "للأرقام البرازيلية، استخدم 55 + رمز المنطقة + الرقم.",
      connectedSuccess: "✅ تم توصيل WhatsApp بنجاح!",
      pairingFailed: "⚠️ فشل الاقتران. حاول مرة أخرى.",
      instructionText: "أدخل رقم WhatsApp مع",
      instructionHighlight: "رمز البلد + رمز المنطقة",
      exampleNumber: "5511999998888",
      digitsHelper: "أرقام — رمز البلد + رمز المنطقة + الرقم",
      whatsappInstructions: "في WhatsApp الخاص بك، اذهب إلى:",
      whatsappSteps: "الإعدادات → الأجهزة المرتبطة → ربط جهاز",
      tapLink: "اضغط على",
      linkWithPhone: "الربط برقم الهاتف",
      enterCodeExact: "وأدخل الرمز كما هو معروض بالضبط (بدون مسافات):",
      stepCodeGenerated: "تم إنشاء الرمز",
      stepWaitingPairing: "في انتظار الاقتران",
      stepSyncing: "جارٍ المزامنة",
      stepConnected: "متصل",
    },
    newTicketOficialModal: {
      title: "محادثة جديدة - API رسمي",
      selectQueue: "اختر قائمة انتظار",
      selectOfficialConnection: "اختر اتصالاً رسمياً",
      selectQueuePlaceholder: "اختر قائمة انتظار",
      selectConnectionPlaceholder: "اختر اتصالاً رسمياً",
      officialApiLabel: "API رسمي",
      createAndSendTemplate: "إنشاء وإرسال قالب",
      templateSentSuccess: "تم إرسال القالب بنجاح!",
      selectQueueError: "اختر قائمة انتظار",
      selectConnectionError: "اختر اتصالاً رسمياً",
    },
    interactiveMessageModalExtra: {
      sendInteractiveMessage: "إرسال رسالة تفاعلية",
      modelsCount: "نماذج ({{count}})",
      saveCurrentConfig: "احفظ التكوين الحالي كنموذج قابل لإعادة الاستخدام للنوع",
      saveButton: "حفظ",
      templateLoaded: "تم تحميل القالب \"{{name}}\"",
      buttonsInfo: "ℹ️ أرسل حتى 3 أزرار قابلة للنقر. يمكن للعميل الضغط على زر للرد بسرعة.",
      messageText: "نص الرسالة *",
      footer: "تذييل (اختياري)",
      buttonsMax: "أزرار (الحد الأقصى 3)",
      add: "إضافة",
      optionPlaceholder: "خيار {{n}}",
      listInfo: "ℹ️ أرسل قائمة بحد أقصى 10 خيارات. يفتح العميل قائمة للاختيار.",
      buttonText: "نص الزر",
      sectionTitle: "عنوان القسم",
      titleLabel: "العنوان",
      descriptionLabel: "الوصف",
      addOption: "إضافة خيار",
      offerInfo: "🏷️ أرسل عرضًا بالعنوان والسعر والوصف.",
      offerTitle: "عنوان العرض",
      offerBody: "الوصف / نص الرسالة *",
      offerPrice: "السعر (مثال: 99.90 ريال)",
      offerDetails: "تفاصيل إضافية",
      pixInfo: "💰 أرسل بيانات PIX منسقة للعميل.",
      pixKey: "مفتاح PIX *",
      pixKeyPlaceholder: "CPF أو CNPJ أو بريد إلكتروني أو هاتف أو مفتاح عشوائي",
      pixBeneficiary: "اسم المستفيد",
      pixCity: "المدينة",
      pixAmount: "المبلغ",
      pixCopyPasteLabel: "رمز PIX للنسخ واللصق (زر النسخ)",
      pixCopyPasteHelper: "املأه لإرسال زر أصلي 'نسخ رمز PIX' (موصى به).",
      pixButtonTextLabel: "نص زر النسخ",
      pixQrCodeLabel: "إرسال رمز QR (صورة) مع الزر",
      pixDocInfo: "📄 مستند (PDF) كمرفق + زر \"نسخ مفتاح Pix\" في نفس الفقاعة.",
      pixTotalLabel: "الإجمالي المعروض (اختياري)",
      pixTotalHelper: "يظهر كـ 'الإجمالي' في نص الرسالة.",
      pixDocUrlLabel: "رابط ملف PDF (فاتورة)",
      pixDocUrlHelper: "رابط عام لملف PDF الذي سيتم إرفاقه ببطاقة PIX.",
      pixDocNameLabel: "اسم الملف (اختياري)",
      urlInfo: "🔗 أرسل رابطًا قابلًا للنقر مع نص مخصص.",
      linkText: "نص الرابط",
      linkPlaceholder: "انقر هنا",
      urlLabel: "URL *",
      callInfo: "📞 أرسل رسالة مع رقم للاتصال.",
      callButtonText: "نص الزر",
      callPlaceholder: "اتصل الآن",
      callPhoneLabel: "رقم الهاتف *",
      callContactSelect: "اختر من قائمة جهات الاتصال",
      callContactPlaceholder: "ابحث عن جهة اتصال...",
      callContactNoOptions: "لم يتم العثور على جهة اتصال",
      callContactLoading: "جاري البحث...",
      callPhoneHelper: "اختر جهة اتصال أعلاه أو اكتب يدويًا",
      locationInfo: "📍 أرسل موقعًا للعميل.",
      locationMessageText: "نص الرسالة",
      locationName: "اسم الموقع",
      locationAddress: "العنوان",
      latitudeLabel: "خط العرض *",
      longitudeLabel: "خط الطول *",
      carouselInfo: "🎠 أرسل بطاقات متعددة ككاروسيل.",
      cardLabel: "بطاقة {{n}}",
      cardTitle: "العنوان",
      cardDescription: "الوصف",
      cardButtonText: "نص الزر",
      addCard: "إضافة بطاقة",
      catalogInfo: "🛍️ أرسل منتجات من الكتالوج كبطاقات.",
      productLabel: "منتج {{n}}",
      productName: "اسم المنتج",
      productDescription: "الوصف / السعر",
      addProduct: "إضافة منتج",
      pollInfo: "📊 أنشئ استطلاعًا ليصوت العميل.",
      pollOfficialNote: "(سيتم إرسالها كنص منسق في API الرسمي)",
      pollQuestion: "سؤال الاستطلاع *",
      pollOptionsLabel: "خيارات (الحد الأدنى 2، الحد الأقصى 12)",
      billingInfo: "🧾 أرسل فاتورة مع تفاصيل الدفع وزر \"مراجعة ودفع\".",
      billingNumber: "رقم الفاتورة",
      billingDescription: "وصف الفاتورة *",
      billingQuantity: "الكمية",
      billingTotalAmount: "المبلغ الإجمالي *",
      billingCustomMessage: "رسالة مخصصة",
      billingAttachPdf: "📄 إرفاق PDF / فاتورة (اختياري)",
      billingSelectPdf: "اختر PDF",
      billingPaymentButton: "زر الدفع",
      billingButtonText: "نص الزر",
      billingPaymentUrl: "رابط الدفع (اختياري)",
      billingPaymentUrlHelper: "إذا تم ملؤه، سيكون الزر رابطًا قابلًا للنقر",
      billingNumberPreview: "رقم الفاتورة",
      billingQuantityPreview: "الكمية",
      billingTotal: "الإجمالي",
      billingDefaultBody: "نص الرسالة...",
      billingDefaultDescription: "وصف الفاتورة...",
      billingDefaultButton: "مراجعة ودفع",
    },
    whatsAppModalExtra: {
      saturday: "السبت",
      sunday: "الأحد",
      saveSchedulesHint: "انقر على حفظ لتسجيل التغييرات",
    },
    tagsKanbanContainer: {
      label: "مرحلة كانبان",
      selectStep: "اختر مرحلة",
      selectKanbanStep: "اختر مرحلة كانبان",
      none: "بدون",
      loadingSteps: "جارٍ تحميل المراحل...",
    },
    pendingTicketOverlay: {
      blockedTitle: "المحادثة مقفلة",
      blockedSubtitle: "هذا التذكرة في انتظار القبول. اقبل المحادثة لعرض رسائل العميل والرد عليها.",
      statusWaiting: "الحالة: في الانتظار",
      contact: "جهة اتصال",
      ticketId: "تذكرة #{{id}}",
      accepting: "جارٍ القبول...",
      acceptConversation: "قبول المحادثة",
      warningText: "🚫 لا يمكنك عرض الرسائل قبل قبول التذكرة",
    },
    documentModalExtra: {
      viewDocument: "عرض المستند",
      open: "فتح",
      download: "تحميل",
      emailOutlook: "بريد Outlook",
      keynotePresentation: "عرض Keynote",
      numbersSpreadsheet: "جدول Numbers",
      pagesDocument: "مستند Pages",
      executable: "ملف تنفيذي",
      retFile: "ملف RET",
      document: "مستند",
    },
    statusFilterExtra: {
      groups: "مجموعات",
    },
    callReport: {
      title: "تقرير المكالمات",
      subtitle: "السجل الكامل للمكالمات الصادرة والواردة",
      exportCsv: "تصدير CSV",
      totalCalls: "إجمالي المكالمات",
      made: "الصادرة",
      answered: "مجابة",
      received: "مستلمة",
      errorsRejected: "أخطاء / مرفوضة",
      callsByHour: "المكالمات بالساعة",
      callsByDay: "المكالمات باليوم",
      callStatus: "حالة المكالمات",
      average: "المتوسط",
      dateStart: "تاريخ البداية",
      dateEnd: "تاريخ النهاية",
      provider: "المزود",
      attendant: "المشغل",
      status: "الحالة",
      all: "الكل",
      dateTime: "التاريخ/الوقت",
      phone: "الهاتف",
      contact: "جهة الاتصال",
      connection: "الاتصال",
      duration: "المدة",
      recording: "التسجيل",
      downloadRecording: "تحميل التسجيل",
      noRecords: "لم يتم العثور على سجلات",
      showing: "عرض",
      of: "من",
      completed: "مكتملة",
      rejected: "مرفوضة",
      notAnswered: "لم يُرد عليها",
      pending: "معلقة",
      system: "النظام",
      sun: "أحد",
      mon: "إثن",
      tue: "ثلا",
      wed: "أرب",
      thu: "خمي",
      fri: "جمع",
      sat: "سبت",
    },
    n8nNodes: {
      webhook: "n8n Webhook",
      wait: "n8n انتظار",
      query: "n8n استعلام",
      sendMessage: "n8n رسالة",
      configureUrl: "تكوين رابط Webhook",
      configureQuery: "تكوين الاستعلام",
      configureWebhook: "تكوين Webhook",
      waitingReturn: "في انتظار رد n8n",
      receiveAndSend: "استقبال وإرسال رسالة",
      sendsTicketData: "يرسل بيانات التذكرة",
      sendsContactData: "يرسل بيانات جهة الاتصال",
      queryN8n: "استعلام n8n",
      resultIn: "النتيجة في",
      sendsResponseToClient: "يرسل الرد للعميل",
      waitsN8nResponse: "ينتظر رد n8n",
      field: "حقل",
      variable: "متغير",
      saveIn: "حفظ في",
      error: "خطأ",
    },
    n8nModal: {
      editWebhook: "تعديل n8n Webhook",
      editWait: "تعديل n8n انتظار الرد",
      editQuery: "تعديل n8n استعلام",
      editSendMessage: "تعديل n8n إرسال رسالة",
      addWebhook: "n8n - Webhook",
      addWait: "n8n - انتظار الرد",
      addQuery: "n8n - استعلام",
      addSendMessage: "n8n - إرسال رسالة",
      nodeType: "نوع عقدة n8n",
      webhookOption: "Webhook - إرسال بيانات",
      waitOption: "انتظار الرد - إيقاف حتى callback",
      queryOption: "استعلام - جلب وإرجاع بيانات",
      sendMessageOption: "إرسال رسالة - استقبال نص من n8n وإرساله",
      webhookInfo: "يرسل البيانات إلى webhook الخاص بـ n8n. يستمر التدفق فوراً بعد الإرسال.",
      waitInfo: "يرسل البيانات إلى n8n ويوقف التدفق حتى استقبال callback.",
      queryInfo: "يقوم باستعلام متزامن إلى n8n ويحفظ الاستجابة في متغير.",
      sendMessageInfo: "يرسل بيانات التذكرة/جهة الاتصال إلى n8n وينتظر النص المعالج ويرسله تلقائياً كرسالة للعميل.",
      webhookUrlLabel: "رابط Webhook الخاص بـ n8n",
      webhookUrlPlaceholder: "https://your-n8n.com/webhook/...",
      authTokenLabel: "رمز المصادقة (اختياري)",
      authTokenPlaceholder: "رمز للمصادقة مع n8n",
      dataToSend: "البيانات المراد إرسالها",
      ticketData: "بيانات التذكرة",
      contactData: "بيانات جهة الاتصال",
      lastMessage: "آخر رسالة مستلمة",
      customPayload: "حمولة مخصصة (JSON اختياري)",
      waitConfig: "إعدادات الانتظار",
      timeoutMinutes: "مهلة (دقائق)",
      timeoutHelper: "أقصى وقت انتظار.",
      saveResponseVar: "متغير لحفظ الاستجابة",
      saveResponseHelper: "سيتم حفظ استجابة n8n في هذا المتغير.",
      waitingMessage: "رسالة أثناء الانتظار (اختياري)",
      queryConfig: "إعدادات الاستعلام",
      queryNameLabel: "اسم الاستعلام",
      queryPayloadLabel: "حمولة الاستعلام (JSON)",
      queryPayloadHelper: "استخدم {{variable}} لإدراج متغيرات التدفق",
      queryResultVar: "متغير لحفظ النتيجة",
      queryResultHelper: "سيتم حفظ نتيجة الاستعلام في هذا المتغير",
      sendResultAsMessage: "إرسال النتيجة كرسالة للعميل",
      messageTemplate: "قالب الرسالة",
      messageTemplateHelper: "استخدم {{variable}} لإدراج النتيجة",
      sendConfig: "إعدادات الإرسال",
      responseFieldLabel: "حقل الاستجابة الذي يحتوي الرسالة",
      responseFieldHelper: "حقل JSON الذي يحتوي على النص.",
      timeoutSeconds: "مهلة (ثوانٍ)",
      timeoutSecondsHelper: "أقصى وقت انتظار لاستجابة n8n",
      saveResponseVarOptional: "متغير لحفظ الاستجابة (اختياري)",
      saveResponseVarHelper: "يحفظ النص المرتجع في متغير للاستخدام لاحقاً",
      fallbackMessage: "رسالة احتياطية (إذا فشل n8n)",
      fallbackHelper: "تُرسل للعميل إذا لم يستجب n8n أو حدث خطأ",
      flowWarning: "يتم إرسال بيانات التذكرة وجهة الاتصال إلى n8n → يعالج n8n ويعيد النص → يُرسل النص تلقائياً للعميل عبر واتساب.",
      webhookRequired: "رابط Webhook مطلوب",
      cancel: "إلغاء",
      save: "حفظ",
      add: "إضافة",
    },
    n8nMonitor: {
      title: "مراقبة n8n",
      total: "الإجمالي",
      success: "نجاح",
      errors: "أخطاء",
      pending: "معلق",
      avgDuration: "متوسط المدة",
      successRate: "معدل النجاح",
      startDate: "تاريخ البداية",
      endDate: "تاريخ النهاية",
      status: "الحالة",
      nodeType: "نوع العقدة",
      all: "الكل",
      webhook: "Webhook",
      waitReturn: "انتظار الرد",
      query: "استعلام",
      sendMessage: "إرسال رسالة",
      id: "ID",
      dateTime: "التاريخ/الوقت",
      type: "النوع",
      ticket: "تذكرة",
      contact: "جهة اتصال",
      duration: "المدة",
      details: "التفاصيل",
      noLogs: "لم يتم العثور على سجلات",
      executionDetail: "تفاصيل التنفيذ",
      nodeTypeLabel: "نوع العقدة",
      webhookUrl: "رابط Webhook",
      errorMessage: "رسالة الخطأ",
      payloadSent: "الحمولة المرسلة",
      responseReceived: "الاستجابة المستلمة",
      noData: "لا توجد بيانات",
      close: "إغلاق",
      loadError: "خطأ في تحميل سجلات n8n",
      detailError: "خطأ في تحميل التفاصيل",
      of: "من",
    },
    flowBuilderN8N: {
      integrations: "التكاملات",
      webhookName: "n8n Webhook",
      webhookDesc: "إرسال بيانات إلى webhook n8n",
      waitName: "n8n انتظار",
      waitDesc: "إيقاف حتى رد n8n",
      queryName: "n8n استعلام",
      queryDesc: "جلب بيانات عبر n8n",
      sendMessageName: "n8n رسالة",
      sendMessageDesc: "استقبال نص من n8n وإرساله",
    },
    n8nMenuLabel: "مراقبة n8n",
    hardcoded: {
      flowSavedSuccess: "تم حفظ التدفق بنجاح",
      flowSaveError: "خطأ في حفظ التدفق",
      flowDeletedSuccess: "تم حذف التدفق بنجاح",
      flowDefaultsUpdated: "تم تحديث التدفقات الافتراضية",
      mediaError: "خطأ في معالجة الوسائط",
      noDataFound: "لم يتم العثور على بيانات",
      selectFollowUp: "اختر متابعة",
      noPermission: "هذه الشركة لا تملك إذن الوصول لهذه الصفحة! جارٍ إعادة التوجيه.",
      noPermissionShort: "هذه الشركة لا تملك إذن الوصول لهذه الصفحة!",
      loadError: "خطأ في تحميل بيانات الشحن",
      generatingExcel: "جارٍ إنشاء تقرير Excel، يرجى الانتظار...",
      loadingData: "جارٍ تحميل البيانات... تم العثور على {{count}} سجل",
      noDataToExport: "لم يتم العثور على بيانات للتصدير",
      excelReportHeader: "تقرير الحملة",
      excelCampaignLabel: "الحملة: {{name}}",
      excelGeneratedAt: "تاريخ الإنشاء: {{date}}",
      excelColId: "المعرف",
      excelColRecipient: "المستلم",
      excelColMessage: "الرسالة",
      excelColSentAt: "أُرسل في",
      excelColDeliveredAt: "تم التسليم في",
      excelColStatus: "الحالة",
      excelDelivered: "تم التسليم",
      excelPending: "معلق",
      excelSheetName: "تقرير الحملة",
      excelSuccess: "تم إنشاء تقرير Excel بنجاح! تم تصدير {{count}} سجل.",
      excelError: "خطأ في إنشاء تقرير Excel",
      settingsSaved: "تم حفظ الإعدادات",
      campaignDeleted: "تم حذف الحملة بنجاح",
      enterToken: "أدخل رمز المصادقة",
      requestSuccess: "✅ تم إرسال الطلب بنجاح",
      requestLoaded: "تم تحميل الطلب — انقر إرسال للتكرار",
      historyCleared: "تم مسح السجل",
      copied: "تم النسخ!",
      invalidJson: "JSON غير صالح",
      chatCreated: "تم إنشاء المحادثة بنجاح!",
      chatsGenerated: "تم إنشاء المحادثات بنجاح!",
      confirmBackfill: "هل أنت متأكد من إنشاء محادثات لجميع المستخدمين الحاليين؟ قد يستغرق وقتاً وينشئ محادثات كثيرة.",
      walletNotFound: "المحفظة غير موجودة",
      maxButtonsReached: "الحد الأقصى 3 أزرار مسموح",
      schedulesUpdated: "تم تحديث المواعيد بنجاح.",
      pushDeactivateError: "خطأ في تعطيل إشعارات Push",
      metaUpdated: "تم تحديث {{field}}!",
      clickSaveToRegister: "انقر حفظ لتسجيل التغييرات",
      contactsImported: "تم استيراد جهات اتصال WhatsApp بنجاح!",
      couldNotLoadRecords: "تعذر تحميل قائمة السجلات",
      selectPeriod: "يرجى تحديد الفترة",
      fillAllFields: "املأ جميع الحقول بقيم رقمية صالحة.",
      slaLimitsOrder: "يجب أن تكون الحدود تصاعدية: أخضر < أصفر < أحمر.",
      slaUpdated: "تم تحديث إعدادات SLA بنجاح!",
      slaError: "خطأ في حفظ إعدادات SLA.",
      slaTitle: "إعدادات SLA للكانبان",
      slaTimeLimitsAndColors: "حدود الوقت والألوان",
      slaDescription: "حدد حدود الوقت (بالدقائق) وألوان كل مستوى تنبيه SLA في الكانبان.",
      slaOnTimeLabel: "🟢 في الوقت — حتى (دقيقة)",
      slaWarningLabel: "🟡 تنبيه — حتى (دقيقة)",
      slaLateLabel: "🔴 متأخر — أكثر من (دقيقة)",
      slaOnTimeHelper: "الحد الأقصى للوقت للحالة الخضراء",
      slaWarningHelper: "الحد الأقصى للوقت للحالة الصفراء",
      slaLateHelper: "فوق هذه القيمة يظهر النبض",
      slaOnTimePreview: "في الوقت — حتى {{m}} دقيقة",
      slaWarningPreview: "تنبيه — حتى {{m}} دقيقة",
      slaLatePreview: "متأخر — أكثر من {{m}} دقيقة",
      slaSaveBtn: "حفظ إعدادات SLA",
      slaSaving: "جاري الحفظ...",
      slaClose: "إغلاق",
      slaSelectColor: "اختر لوناً",
      cancelRequested: "تم طلب الإلغاء. انتظر حتى ينتهي الدردشة الحالية...",
      parameterizeFilter: "حدد معلمات الفلتر",
      intervalValue: "قيمة الفاصل الزمني",
      sendHowManyTimes: "إرسال كم مرة",
      sendNormallyNonBusiness: "إرسال عادي في أيام غير عمل",
      sendBusinessDayBefore: "إرسال قبل يوم عمل واحد",
      sendBusinessDayAfter: "إرسال بعد يوم عمل واحد",
      showUser: "إظهار المستخدم",
      users: "المستخدمون",
      createTicket: "إنشاء تذكرة",
      filterByTags: "تصفية بالعلامات",
      unknown: "غير معروف",
      accessTicket: "الوصول للتذكرة",
      downloadFile: "تحميل الملف",
      clickToDownload: "📎 انقر للتحميل",
      select: "اختيار",
      options: "خيارات",
      reviewAndPay: "مراجعة ودفع",
      followUpInfo: "معلومات عن المتابعة",
      followUpPanel: "لوحة المتابعة",
      aboutFollowUpTitle: "حول نظام المتابعة",
      aboutFollowUpDesc: "يتيح لك نظام المتابعة إنشاء تدفقات رسائل وتعيينها لجهة اتصال أو تذكرة للتنفيذ التلقائي.",
      aboutFollowUpSelect: "اختر قالبًا نشطًا للبدء. يمكنك التوقف في أي وقت.",
      understood: "فهمت",
      noAgent: "بدون وكيل",
      salesReport: "تقرير المبيعات",
      startDate: "تاريخ البداية",
      endDate: "تاريخ النهاية",
      agent: "الوكيل",
      all: "الكل",
      generating: "جارٍ الإنشاء...",
      generateReport: "إنشاء التقرير",
      totalSales: "إجمالي المبيعات",
      totalSalesValue: "إجمالي قيمة المبيعات",
      nonSales: "غير مباع",
      avgTicketsPerAgent: "متوسط التذاكر لكل وكيل",
      nonSaleReasons: "أسباب عدم البيع",
      closedTickets: "التذاكر المغلقة",
      saleValue: "قيمة البيع",
      nonSaleReason: "سبب عدم البيع",
      closingReason: "سبب الإغلاق",
      closingReasonFilter: "سبب الإغلاق",
      nonSaleReasonFilter: "سبب عدم البيع",
      agentPerformance: "أداء الوكيل",
      totalTickets: "إجمالي التذاكر",
      avgTickets: "متوسط التذاكر",
      date: "التاريخ",
      allowCrossQueueTicket: "السماح بفتح تذكرة في أي قسم/اتصال",
      refresh: "تحديث",
      openNewTab: "فتح في علامة تبويب جديدة",
      whatsappConnection: "اتصال WhatsApp",
      tagUsed: "العلامة المستخدمة",
      notSpecified: "غير محدد",
      downloadSampleSheet: "تحميل جدول نموذجي",
      saveFlow: "حفظ التدفق",
      intervals: "الفواصل الزمنية",
      connected: "متصل",
      connecting: "جارٍ الاتصال...",
      unknownNumber: "رقم غير معروف",
      incomingCall: "مكالمة واردة",
      readyForCalls: "جاهز للمكالمات",
      connectingToServer: "جارٍ الاتصال بالخادم...",
      minimize: "تصغير",
      backspace: "حذف",
      unmute: "إلغاء كتم الصوت",
      mute: "كتم الصوت",
      endCall: "إنهاء",
      answerCall: "رد",
      rejectCall: "رفض",
      makeCall: "اتصال",
      typeNumberToCall: "اكتب رقماً للاتصال",
      calling: "جارٍ الاتصال...",
      inCall: "في مكالمة",
      numberTooShort: "الرقم قصير جداً",
      numberTooLong: "الرقم طويل جداً",
      callError: "خطأ في إجراء المكالمة",
      recordAudio: "تسجيل صوت",
      recording: "جارٍ التسجيل...",
      audioRecorded: "تم تسجيل الصوت",
      confirmOrDelete: "انقر ✓ للتأكيد أو 🗑️ للحذف",
      dashboardSubtitle: "تابع تقدم تدفقات المتابعة",
      totalContacts: "إجمالي جهات الاتصال",
      active: "نشط",
      paused: "متوقف",
      withErrors: "مع أخطاء",
      steps: "الخطوات",
      completionRate: "معدل الإكمال",
      responseRate: "معدل الاستجابة",
      contactDistribution: "توزيع جهات الاتصال حسب الخطوة",
      searchContact: "بحث عن جهة اتصال...",
      allChannels: "جميع القنوات",
      allFilter: "الكل",
      withErrorsFilter: "مع أخطاء",
      pausedFilter: "متوقف",
      noContact: "لا توجد جهات اتصال",
      noStepFound: "لم يتم العثور على خطوات",
      noHistoryFound: "لم يتم العثور على سجل",
      lastSendError: "خطأ في آخر إرسال",
      step: "خطوة",
      resume: "استئناف",
      pause: "إيقاف",
      history: "السجل",
      timelineFollowUp: "خط زمني للمتابعة",
      created: "تم الإنشاء",
      sent: "تم الإرسال",
      next: "التالي",
      inactive: "غير نشط",
      deliveryStatus: "حالة التسليم",
      delivered: "تم التسليم",
      waiting: "في الانتظار",
      failures: "فشل",
      messagesSent: "الرسائل المرسلة",
      uniqueRecipients: "المستلمون الفريدون",
      messagesDelivered: "الرسائل المسلمة",
      messageDetails: "تفاصيل الرسائل",
      exportExcel: "تصدير Excel",
      rowsPerPage: "صفوف لكل صفحة:",
      chipDelivered: "تم التسليم",
      chipPending: "معلق",
      chipFailed: "فشل",
      chipUnknown: "غير معروف",
      loading: "جارٍ التحميل...",
      noMessagesFound: "لم يتم العثور على رسائل",
      notScheduled: "غير مجدول",
      notCompleted: "غير مكتمل",
      approved: "موافق عليه",
      pending: "معلق",
      rejected: "مرفوض",
      noContactInList: "لا توجد جهات اتصال في هذه القائمة بعد.",
      importViaExcelOrWhatsapp: "استورد عبر Excel أو WhatsApp باستخدام الأزرار أعلاه.",
      loadingTags: "جارٍ تحميل العلامات...",
      noTagAvailable: "لا توجد علامات متاحة.",
      selectAllShown: "تحديد الكل ({{count}} معروض)",
      noContactFound: "لم يتم العثور على جهات اتصال.",
      trySearchOther: "حاول البحث باسم أو رقم آخر.",
      clickNewListToStart: "انقر \"قائمة جديدة\" للبدء.",
      filterByTag: "تصفية حسب العلامة:",
      clearTags: "مسح ({{count}})",
      addingToList: "إضافة إلى القائمة:",
      addToList: "إضافة {{count}} إلى القائمة",
      listCreatedImport: "تم إنشاء القائمة \"{{name}}\"! الآن استورد جهات الاتصال (اختياري).",
      dragExcelHere: "اسحب ملف Excel هنا أو انقر للتحديد",
      acceptedFormats: "الصيغ المقبولة: .xls, .xlsx",
      downloadTemplate: "📥 تحميل نموذج الجدول (.xlsx)",
      skipImport: "تخطي الاستيراد",
      nameListHint: "أعطِ اسماً لتحديد قائمة جهات الاتصال هذه.",
      characters: "حرف",
      listNameMinLength: "يجب أن يكون الاسم حرفين على الأقل.",
      listCreatedSuccess: "تم إنشاء القائمة \"{{name}}\" بنجاح!",
      contactsAddedToList: "تمت إضافة {{count}} جهة اتصال إلى القائمة \"{{name}}\"!",
      listSelectedForCampaign: "تم اختيار القائمة \"{{name}}\" للحملة!",
      backToCampaign: "العودة للحملة ←",
      excelModel: "نموذج Excel",
      importExcel: "استيراد Excel",
      loadMore: "تحميل المزيد",
      contactLists: "قوائم جهات الاتصال",
      contactListsSubtitle: "أنشئ قوائم، استورد جهات اتصال واختر القائمة لاستخدامها في هذه الحملة.",
      simpleList: "قائمة بسيطة",
      newListExcel: "قائمة جديدة + Excel",
      selectedListLabel: "القائمة المختارة: {{name}}",
      selectedListDesc: "{{count}} جهة اتصال — سيتم استخدام هذه القائمة في الحملة",
      remove: "إزالة",
      deleteListConfirm: "حذف القائمة \"{{name}}\"?",
      addCaption: "أضف وصفاً (اختياري)",
      previewNotAvailable: "المعاينة غير متاحة",
      departments: "الأقسام",
      name: "الاسم",
      noTagFound: "لم يتم العثور على علامات. اكتب لإنشاء واحدة جديدة.",
      selectWhatsappConnection: "اختر اتصال WhatsApp لاستيراد جهات الاتصال منه:",
      noWhatsappConnectionFound: "لم يتم العثور على اتصال WhatsApp متصل.",
      cancel: "إلغاء",
      import: "استيراد",
      imageNotAvailable: "الصورة غير متاحة",
    },
    todoList: {
      title: "قائمة المهام",
      counter: "{{pending}} معلقة من {{total}} مهمة",
      newTask: "مهمة جديدة",
      editTask: "تعديل المهمة",
      add: "إضافة",
      save: "حفظ",
      cancel: "إلغاء",
      priority: "الأولوية",
      category: "الفئة",
      status: "الحالة",
      dueDate: "تاريخ الاستحقاق",
      assignTo: "تعيين إلى",
      nobody: "لا أحد",
      notes: "ملاحظات",
      notesLabel: "ملاحظات",
      search: "بحث...",
      allTabs: "الكل",
      pendingTabs: "معلقة",
      doneTabs: "مكتملة",
      allPriorities: "الكل",
      allUsers: "الكل",
      sortBy: "ترتيب حسب",
      sortCreatedAt: "تاريخ الإنشاء",
      sortPriority: "الأولوية",
      sortDueDate: "تاريخ الاستحقاق",
      sortManual: "يدوي (سحب)",
      user: "المستخدم",
      priorities: { high: "عالية", medium: "متوسطة", low: "منخفضة" },
      statuses: { pending: "معلقة", in_progress: "قيد التنفيذ", done: "مكتملة" },
      categories: { general: "عام", work: "عمل", personal: "شخصي", urgent: "عاجل", study: "دراسة" },
      emptyNoTasks: "لا توجد مهام بعد",
      emptyFiltered: "لم يتم العثور على مهام",
      emptyAddFirst: "أضف مهمتك الأولى أعلاه!",
      emptyAdjustFilters: "حاول تعديل الفلاتر",
      dueSoonAlert: "مهمة تستحق قريباً:",
      overdue: "متأخرة!",
      subtasks: "مهام فرعية",
      newSubtask: "مهمة فرعية جديدة...",
      createdBy: "أنشأها",
      assignedTo: "معينة لـ",
      deleteTitle: "تأكيد الحذف",
      deleteMessage: "هل تريد حقاً حذف هذه المهمة؟",
      deleteConfirm: "حذف",
      toasts: {
        loadError: "خطأ في تحميل المهام",
        saveError: "خطأ في حفظ المهمة",
        statusError: "خطأ في تحديث الحالة",
        deleteError: "خطأ في حذف المهمة",
        subtaskError: "خطأ في تحديث المهام الفرعية",
      },
    },
    accountSwitch: {
      title: "حساباتك",
      subtitle: "اختر حسابًا للتبديل تلقائيًا",
      addAccount: "إضافة حساب",
      savePassword: "حفظ كلمة المرور",
      saveCurrentPassword: "حفظ كلمة مرور الحساب الحالي",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      cancel: "إلغاء",
      save: "حفظ",
      admin: "مدير",
      agent: "وكيل",
      saved: "محفوظة",
      noPassword: "بدون كلمة مرور",
      active: "نشط",
      passwordHelper: "يتم حفظ كلمة المرور محليًا للتبديل السريع",
      saveWarning: "احفظ كلمة المرور لتمكين التبديل السريع",
      toasts: {
        accountAdded: "تم التحقق من الحساب وإضافته!",
        invalidCredentials: "بيانات اعتماد غير صالحة. تحقق من البريد وكلمة المرور.",
        passwordSaved: "تم حفظ كلمة المرور بنجاح!",
        cannotRemoveActive: "لا يمكن إزالة الحساب النشط.",
        accountRemoved: "تمت إزالة الحساب.",
        noCredentials: "لم يتم حفظ بيانات الاعتماد. احفظ كلمة المرور أولاً.",
        connectedAs: "متصل كـ {{name}}",
      },
    },
        backupRestore: {
          backupTitle: "نسخ احتياطي لقاعدة البيانات",
          backupDescription: "قم بتنزيل نسخة كاملة من قاعدة البيانات. اختر التنسيق المطلوب:",
          backupSQL: "نسخ احتياطي SQL (.sql)",
          backupJSON: "نسخ احتياطي JSON (.json)",
          generating: "جارٍ التوليد...",
          tip: "النسخ الاحتياطي SQL مثالي للاستعادة الكاملة. النسخ الاحتياطي JSON مفيد لتحليل البيانات وترحيلها.",
          restoreTitle: "استعادة قاعدة البيانات",
          dangerZone: "منطقة خطر",
          dangerDescription: "ستؤدي الاستعادة إلى الكتابة فوق جميع البيانات الحالية في قاعدة البيانات. تأكد من وجود نسخة احتياطية محدثة قبل المتابعة.",
          restoring: "جارٍ الاستعادة...",
          uploadRestore: "إرسال ملف .sql للاستعادة",
          confirmRestore: "⚠️ تحذير: ستؤدي الاستعادة إلى الكتابة فوق البيانات الحالية. هل أنت متأكد أنك تريد المتابعة؟ نوصي بعمل نسخة احتياطية أولاً.",
          important: "مهم",
          importantText: "بعد استعادة النسخة الاحتياطية، أعد تشغيل الخادم حتى يتم إعادة إنشاء اتصالات Redis/Bull بشكل صحيح.",
          toasts: {
            sqlSuccess: "تم تنزيل النسخة الاحتياطية SQL بنجاح!",
            sqlError: "خطأ في توليد النسخة الاحتياطية SQL.",
            jsonSuccess: "تم تنزيل النسخة الاحتياطية JSON بنجاح!",
            jsonError: "خطأ في توليد النسخة الاحتياطية JSON.",
            sqlOnly: "يُقبل فقط ملفات .sql للاستعادة.",
            restoreSuccess: "تمت استعادة قاعدة البيانات بنجاح! أعد تحميل الصفحة.",
            restoreError: "خطأ في استعادة قاعدة البيانات.",
          },
        },
        smtpSettings: {
          title: "إعدادات SMTP",
          description: "قم بإعداد خادم البريد الإلكتروني لإرسال رموز استعادة كلمة المرور والإشعارات.",
          server: "خادم SMTP",
          port: "المنفذ",
          secure: "اتصال آمن (SSL/TLS على المنفذ 465)",
          secureHelp: "قم بالتفعيل لاستخدام SSL/TLS مباشر (المنفذ 465). معطل يستخدم STARTTLS (المنفذ 587).",
          senderEmail: "بريد المرسل",
          senderName: "اسم المرسل",
          senderNameHelp: "مثال: CRM Moovein. سيكون بريد المرسل هو الحقل أعلاه.",
          authentication: "المصادقة",
          authMethod: "طريقة المصادقة",
          password: "كلمة مرور (افتراضي)",
          passwordLabel: "كلمة المرور",
          gmailHelp: "لـ Gmail، استخدم \"كلمة مرور التطبيق\" المُنشأة في myaccount.google.com/apppasswords",
          save: "حفظ",
          testConfig: "اختبار الإعدادات",
          testEmail: "بريد للاختبار",
          sendTest: "إرسال اختبار",
          toasts: {
            saveSuccess: "تم حفظ إعدادات SMTP بنجاح!",
            saveError: "خطأ في حفظ إعدادات SMTP.",
            emailRequired: "أدخل بريداً إلكترونياً للاختبار.",
            testSuccess: "تم إرسال بريد الاختبار بنجاح!",
            testError: "فشل في إرسال بريد الاختبار. تحقق من الإعدادات.",
          },


        },
    templateManagerExtraV2: {
      deleteTemplateConfirm: "حذف القالب \"{{name}}\"؟",
      headerTypeTitle: "الترويسة:",
      headerTypeNone: "لا شيء",
      headerTypeText: "نص",
      headerTypeImage: "صورة",
      headerTypeVideo: "فيديو",
      headerTypeDocument: "مستند",
      mediaUrlImageLabel: "رابط عام للصورة (عينة للموافقة)",
      mediaUrlVideoLabel: "رابط عام للفيديو (عينة للموافقة)",
      mediaUrlDocumentLabel: "رابط عام للمستند (عينة للموافقة)",
      mediaUrlHelper: "تتطلب Meta عينة. الصق رابط HTTPS عام أو انقر على \"رفع ملف\" لاستضافته الآن. عند الإرسال يمكنك استبدال الوسائط بوسائط مرفقة بالحملة/المحادثة.",
      uploading: "جارٍ الرفع...",
      uploadFile: "رفع ملف",
      uploadSuccess: "تم رفع الملف وتعبئة الرابط.",
      uploadNoUrl: "اكتمل الرفع لكن لم يُرجَع رابط.",
      fileNameLabel: "اسم الملف (اختياري)",
      preview: "معاينة",
      imageLoadError: "تعذر تحميل الصورة من هذا الرابط.",
      documentFallback: "مستند",
      openDocument: "فتح المستند",
      bodyRequiredTitle: "نص الرسالة *",
      insertVariable: "+ إدراج متغير",
      varExamplesTitle: "قيم نموذجية (إلزامية للموافقة)",
      varExamplesDesc: "تستخدم Meta هذه القيم للتحقق من القالب فقط. لا تظهر في الإرسال الفعلي.",
      varExampleLabel: "مثال لـ {{var}}",
      link: "رابط",
      previewImage: "صورة",
      previewVideo: "فيديو",
      previewDocumentAttached: "مستند مرفق",
      previewDocument: "مستند",
      seeAllOptions: "عرض كل الخيارات",
      previewVarsNote: "تُستخدم قيم الأمثلة فقط لهذه المعاينة.",
    },
    campaignModalExtraV2: {
      sectionHeader: "الترويسة",
      sectionBody: "النص",
      sectionFooter: "التذييل",
      sectionButtons: "الأزرار",
      buttonFallback: "زر",
      templateMediaAuto: "📎 وسائط تلقائية من القالب ({{format}}): {{name}}",
      templateMediaSample: "📎 وسائط تلقائية من القالب ({{format}}): عينة معتمدة من Meta",
      templateMediaMissing: "⚠️ يتطلب القالب ترويسة {{format}}. أرفق ملفًا أدناه أو احفظ الوسائط في القالب.",
      templateMediaAttached: "مرفقة",
      templateVarsTitle: "متغيرات القالب",
      templateVarsDesc: "املأ القيم التي ستحل محل العناصر النائبة {{...}} عند الإرسال.",
      varValuePlaceholder: "قيمة لـ {{key}}",
      varAppearsIn: "يظهر في: {{sections}}",
      varSection: "القسم: {{section}}",
      messagePreviewTitle: "معاينة الرسالة",
      messagePreviewDesc: "معاينة بعد استبدال المتغيرات. تظهر العناصر غير المملوءة كـ {{...}}.",
      scheduleTimezoneHelper: "المنطقة الزمنية: {{tz}} ({{offset}})",
    },
    closeTicketModal: {
      title: "إغلاق التذكرة",
      subtitle: "هل أنت متأكد أنك تريد إغلاق التذكرة؟",
      subject: "موضوع التذكرة",
      selectPlaceholder: "اختر",
      summary: "ملخص الخدمة",
      summaryPlaceholder: "اكتب ملخص الخدمة",
      cancel: "إلغاء",
      confirm: "إغلاق التذكرة",
    },
    ticketReport: {
      menuItem: "تقرير الخدمة",
      title: "تقرير الخدمة",
      filename: "service-report",
      contact: "جهة الاتصال",
      ticketId: "التذكرة",
      subject: "موضوع التذكرة",
      summary: "ملخص الخدمة",
      timing: "مدة الخدمة",
      totalDuration: "المدة الإجمالية",
      startedAt: "البدء",
      closedAt: "الإغلاق",
      connection: "الاتصال",
      agents: "الموظفون",
      queues: "قوائم الانتظار",
      timeline: "سجل الخدمة",
      notInformed: "غير محدد",
      exportPDF: "تصدير PDF",
      close: "إغلاق",
      duration: {
        days: "ي",
        hours: "س",
        minutes: "د",
        seconds: "ث",
      },
    },
    closingReport: {
      title: "تقرير الإغلاق",
      filename: "closing-report",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      subject: "موضوع الإغلاق",
      allSubjects: "جميع المواضيع",
      filter: "تصفية",
      exportExcel: "تصدير Excel",
      exportPDF: "تصدير PDF",
      total: "الإجمالي",
      noData: "لم يتم العثور على محادثات للفلاتر المحددة",
      columns: {
        protocol: "البروتوكول",
        contact: "جهة الاتصال",
        agent: "الموظف",
        queue: "الطابور",
        status: "الحالة",
        subject: "الموضوع",
        summary: "الملخص",
        openDate: "تاريخ الفتح",
        closeDate: "تاريخ الإغلاق",
        duration: "المدة",
      },
      statusLabels: {
        FECHADO: "مغلق",
        ABERTO: "مفتوح",
        PENDENTE: "قيد الانتظار",
        GRUPO: "مجموعة",
        OPEN: "مفتوح",
        CLOSED: "مغلق",
        PENDING: "قيد الانتظار",
      },
    },

  },

};

export { messages };

// Appended by Lovable: i18n for new screens
if (typeof messages !== "undefined" && messages["ar"] && messages["ar"].translations) {
  messages["ar"].translations.webhookUnified = {
      "title": "Unified Meta Webhook",
      "subtitle": "One single webhook for all your official numbers",
      "description": "Meta allows only one webhook URL per App. This tool receives events from all numbers and routes them internally by phone_number_id.",
      "openMeta": "Open Meta",
      "loadError": "Could not load webhook info. Make sure the Official API is configured and at least one official connection is registered.",
      "oneUrl": "one URL"
  };
  messages["ar"].translations.templateManager = {
      "title": "Template Management",
      "health": "Health",
      "webhookMeta": "Meta Webhook",
      "name": "Name",
      "category": "Category",
      "marketing": "Marketing",
      "utility": "Utility",
      "authentication": "Authentication"
  };
  Object.assign(messages["ar"].translations.whatsappHealth = messages["ar"].translations.whatsappHealth || {}, {
      "searchPlaceholder": "Search number, WABA, name...",
      "downloadPdf": "Download PDF",
      "history": "History",
      "templates": "Templates",
      "templatesTooltip": "Manage Meta message templates",
      "reloadTooltip": "Reload",
      "historyTooltip": "Daily reports automatically generated at 09:00",
      "statConnected": "Connected numbers",
      "statHigh": "High quality",
      "statMedium": "Medium quality",
      "statAttention": "Attention / errors",
      "summaryTitle": "Messages via Official API",
      "summarySub": "Real-time · last 24h",
      "sent": "Sent",
      "delivered": "Delivered",
      "availableMeta": "Available from Meta",
      "of": "of",
      "usage24h": "24h window usage",
      "limit24h": "Limit (24h)",
      "shipments24h": "SENDS · 24H",
      "sentLow": "sent",
      "deliveredLow": "delivered",
      "available": "Available",
      "emptyAll": "No official number found.",
      "emptyFiltered": "No results for the search.",
      "unlimited": "Unlimited"
  });
  messages["ar"].translations.campaignWizard = {
      "stepsLabel": "STEPS",
      "configuration": "Configuration",
      "campaignTab": "Campaign",
      "campaignTabSub": "Messages, scheduling and ticket",
      "contactsTab": "Contact Lists",
      "contactsTabSub": "Select recipients",
      "settingsTab": "Settings",
      "settingsTabSub": "Intervals and anti-ban",
      "preview": "PREVIEW",
      "back": "← Back",
      "continue": "Continue →",
      "close": "Close",
      "save": "Save",
      "step1": "Identification",
      "step2": "Distribution",
      "step3": "Scheduling",
      "step4": "Ticket",
      "step5": "Message",
      "step6": "Contacts",
      "identificationTitle": "CAMPAIGN IDENTIFICATION",
      "distributionTitle": "DISPATCH DISTRIBUTION",
      "scheduleTitle": "SCHEDULING",
      "ticketTitle": "TICKET",
      "messageTitle": "MESSAGE & PREVIEW",
      "contactsTitle": "CONTACT LIST",
      "splitByConnection": "Split dispatches into blocks by connection",
      "connectionsOrder": "Connections (in block order)",
      "connectionsHelp": "The selection order defines which connection serves each block.",
      "contactsPerBlock": "Contacts per block",
      "sequentialBlocks": "Sequential between blocks",
      "recurrenceTitle": "Recurrence Settings",
      "enableRecurrence": "Enable recurrence",
      "intervalsTitle": "Dispatch Intervals",
      "intervalsSubtitle": "Configure time intervals between dispatches to avoid blocks.",
      "randomInterval": "Random dispatch interval",
      "biggerIntervalAfter": "Larger interval after",
      "biggestInterval": "Largest send interval",
      "antiBan": "Anti-Ban",
      "antiBanSub": "Humanizes dispatch to reduce block risk",
      "variation": "Random variation (jitter)",
      "extraPauseEvery": "Extra pause every N msgs",
      "extraPauseDuration": "Extra pause duration",
      "guardFill": "Fill the {step} fields to unlock the next steps.",
      "previewLabel": "Preview",
      "messageOficialNote": "For Official API, use the template selected on the side. The message field and media attachment are not available.",
      "followUpNote": "Follow-up available only for Baileys channels. In campaigns via Official API, only the template is sent.",
      "campaignMessage": "Campaign Message",
      "msgPreviewSection": "MESSAGE & PREVIEW"
  };
}

if (typeof messages !== "undefined" && messages["ar"] && messages["ar"].translations) {
  messages["ar"].translations.login = messages["ar"].translations.login || {};
  messages["ar"].translations.login.form = Object.assign(messages["ar"].translations.login.form || {}, {
    emailPlaceholder: "Email",
    passwordPlaceholder: "Password"
  });
  messages["ar"].translations.login.noAccount = "No account?";
  messages["ar"].translations.login.secureNote = "Your data is protected with end-to-end encryption.";
  messages["ar"].translations.templateManagerPage = messages["ar"].translations.templateManagerPage || {};
  messages["ar"].translations.templateManagerPage.summary = { total: "Total", approved: "Approved", pending: "Pending", rejected: "Rejected" };
}

// Appended by Lovable
if (typeof messages !== "undefined" && messages["ar"] && messages["ar"].translations) {
  const T = messages["ar"].translations;
  T.flowBuilderInstagramTriggerModal = {
    title: "المحفز: تعليق على Instagram",
    account: "حساب Instagram",
    selectPost: "اختر منشور/ريل (فارغ = أي)",
    searchPlaceholder: "بحث بالتسمية التوضيحية...",
    emptyHint: "اتركه فارغاً للتفعيل على أي منشور",
    noAccounts: "لا يوجد حساب Instagram متصل",
    loading: "جارٍ التحميل...",
    noResults: "لم يتم العثور على منشورات",
    pasteIdManually: "الصق المعرف يدوياً",
    chooseFromList: "اختر من القائمة",
    mediaId: "معرف الوسائط (منشور/ريل)",
    mediaIdPlaceholder: "مثال: 17900000000000000",
    keyword: "كلمة مفتاحية", add: "إضافة",
    matchAny: "تفعيل عند احتواء أي كلمة",
    matchAll: "تفعيل فقط عند احتواء جميع الكلمات",
    hint: "بدون كلمات مفتاحية = يتم التفعيل على أي تعليق.",
    cancel: "إلغاء", save: "حفظ", noCaption: "بدون تسمية"
  };
  T.flowBuilderInstagramReplyModal = {
    title: "الرد على التعليق علناً",
    hint: "سيتم اختيار إحدى التغييرات بشكل عشوائي لتجنب التكرار.",
    variation: "تغيير", addVariation: "إضافة تغيير", cancel: "إلغاء", save: "حفظ"
  };
  T.flowBuilderInstagramRewardModal = {
    title: "إرسال مكافأة (ملف/PDF)",
    selectFile: "اختر ملف", uploading: "جارٍ الرفع...", file: "الملف:",
    caption: "تسمية توضيحية (اختياري)",
    hint: "سيتم إرفاق الملف برسالة خاصة لمؤلف التعليق.",
    cancel: "إلغاء", save: "حفظ"
  };
  T.flowBuilderInstagramDmModal = {
    title: "إرسال رسالة خاصة", message: "الرسالة",
    hint: "استخدم ${name} للمتغيرات. يتم إرسال الرسالة لمؤلف التعليق.",
    cancel: "إلغاء", save: "حفظ"
  };
  T.facebookPostPreview = { fbPost: "منشور Facebook", yourComment: "تعليقك:", viewPost: "عرض المنشور" };
  T.flowBuilderTestModal = {
    title: "اختبار التدفق (محاكاة)",
    hintIntro: "هذه محاكاة مرئية — لا يتم إرسال شيء فعلياً. استخدمها للتحقق من ترتيب العقد.",
    igDetected: "(تم اكتشاف تدفق Instagram.)",
    genericDetected: "(تم اكتشاف تدفق عام.)",
    commentLabel: "تعليق محاكى", messageLabel: "رسالة محاكاة",
    defaultComment: "أريد ملف PDF!", defaultMessage: "مرحبا",
    commentSimulated: "محاكاة استلام تعليق: \"{{text}}\"",
    messageSimulated: "محاكاة استلام رسالة: \"{{text}}\"",
    simulatedUser: "المستخدم المحاكى:", follows: "يتابع الحساب", notFollows: "لا يتابع",
    clickToToggle: "انقر للتبديل",
    clickStart: "انقر على بدء المحاكاة لرؤية الخطوات.",
    simulating: "جارٍ المحاكاة...", start: "بدء المحاكاة", clear: "مسح", close: "إغلاق",
    loopDetected: "تم اكتشاف حلقة — توقفت المحاكاة.",
    end: "نهاية التدفق. ✅ ({{n}} خطوة منفذة)",
    maxSteps: "تم الوصول للحد الأقصى (100) — توقفت المحاكاة.",
    noNodes: "لم يتم العثور على عقدة في التدفق.",
    nextNotFound: "العقدة التالية (id={{id}}) غير موجودة في التدفق.",
    step: {
      startTitle: "بداية التدفق", startDetail: "بدأ التدفق.",
      igTriggerTitle: "محفز Instagram", igTriggerDetail: "في انتظار تعليق على المنشور",
      keyword: "كلمة مفتاحية", anyKeyword: "أي",
      igReplyTitle: "الرد على التعليق", igReplyDetail: "سيرد علناً",
      igLikeTitle: "إعجاب بالتعليق", igLikeDetail: "سيعجب البوت بالتعليق.",
      igFollowerTitle: "تحقق من المتابع",
      igFollowerYes: "✓ المستخدم يتابع الحساب — مخرج أخضر.",
      igFollowerNo: "✗ المستخدم لا يتابع — مخرج أحمر.",
      igDmTitle: "إرسال رسالة خاصة", igDmDetail: "تم إرسال الرسالة",
      igRewardTitle: "تسليم المكافأة", igRewardDetail: "سيرسل الملف",
      noText: "بدون نص", emptyMsg: "(رسالة فارغة)",
      messageTitle: "رسالة",
      imageTitle: "صورة", imageEmpty: "(صورة)",
      audioTitle: "صوت", audioEmpty: "(صوت)",
      videoTitle: "فيديو", videoEmpty: "(فيديو)",
      singleBlockTitle: "كتلة واحدة", singleBlockDetail: "محتوى مجمع.",
      menuTitle: "قائمة", menuDetail: "قائمة بـ {{n}} خيار.",
      interactiveTitle: "قائمة تفاعلية", interactiveDetail: "قائمة تفاعلية", buttons: "أزرار",
      inputTitle: "إدخال", inputDetail: "سينتظر إدخال المستخدم", variable: "متغير",
      intervalTitle: "فاصل", intervalDetail: "سينتظر {{sec}} ثانية.",
      randomTitle: "عشوائي", randomDetail: "سيختار مساراً عشوائياً.",
      conditionTitle: "شرط", conditionDetail: "سيقارن",
      ticketTitle: "تذكرة", ticketDetail: "سينشئ/يحدث التذكرة.",
      tagTitle: "وسم", tagDetail: "سيضيف وسم",
      removeTagTitle: "إزالة وسم", removeTagDetail: "سيزيل وسم",
      switchFlowTitle: "تبديل التدفق", switchFlowDetail: "سينتقل إلى تدفق",
      attendantTitle: "موظف", attendantDetail: "سينقل إلى موظف بشري.",
      httpTitle: "طلب HTTP", noUrl: "(بدون URL)",
      variableTitle: "متغير", variableDetail: "سيعرف",
      aiTitle: "وكيل الذكاء الاصطناعي", aiDetail: "سيرد باستخدام وكيل الذكاء الاصطناعي.",
      typebotTitle: "Typebot", typebotDetail: "تكامل Typebot.",
      n8nTitle: "n8n", n8nDetail: "تكامل n8n.",
      asaasTitle: "Asaas", asaasDetail: "سينشئ فاتورة عبر Asaas.",
      genericTitle: "عقدة", genericDetail: "سينفذ هذه الخطوة."
    }
  };
}

if (typeof messages !== "undefined" && messages["ar"] && messages["ar"].translations) {
  messages["ar"].translations.login = messages["ar"].translations.login || {};
  messages["ar"].translations.login.or = "أو";
  messages["ar"].translations.login.buttons = messages["ar"].translations.login.buttons || {};
  messages["ar"].translations.login.buttons.google = "المتابعة باستخدام Google";
  messages["ar"].translations.signup = messages["ar"].translations.signup || {};
  messages["ar"].translations.signup.buttons = messages["ar"].translations.signup.buttons || {};
  messages["ar"].translations.signup.buttons.google = "التسجيل باستخدام Google";
  messages["ar"].translations.settings = messages["ar"].translations.settings || {};
  messages["ar"].translations.settings.settings = messages["ar"].translations.settings.settings || {};
  messages["ar"].translations.settings.settings.options = messages["ar"].translations.settings.settings.options || {};
  messages["ar"].translations.settings.settings.options.googleLogin = "تسجيل الدخول عبر Google";
}

if (typeof messages !== "undefined" && messages["ar"] && messages["ar"].translations) {
  messages["ar"].translations.settings = messages["ar"].translations.settings || {};
  messages["ar"].translations.settings.nav = Object.assign(messages["ar"].translations.settings.nav || {}, {
    companiesDesc: "إدارة الشركات",
    plansDesc: "الخطط والأسعار",
    helpsDesc: "المساعدة والدعم",
  });
  messages["ar"].translations.transferTicketModalCustom = Object.assign(messages["ar"].translations.transferTicketModalCustom || {}, {
    connection: "اتصال",
  });
  messages["ar"].translations.templateMetaModal = Object.assign(messages["ar"].translations.templateMetaModal || {}, {
    empty: "لم يتم العثور على قالب",
  });
  messages["ar"].translations.whatsappHealth = Object.assign(messages["ar"].translations.whatsappHealth || {}, {
    reportsDialog: {
      title: "التقارير اليومية (تُنشأ في 09:00)",
      empty: "لم يتم إنشاء أي تقرير بعد. سيُنشأ تلقائياً غداً في 09:00.",
      download: "تنزيل",
      close: "إغلاق",
    },
  });
  messages["ar"].translations.connections = Object.assign(messages["ar"].translations.connections || {}, {
    noResults: "لم يتم العثور على أي اتصال.",
    facebook: Object.assign(
      (messages["ar"].translations.connections || {}).facebook || {},
      { success: "تم إنشاء اتصال فيسبوك بنجاح!" }
    ),
    toasts: Object.assign(
      (messages["ar"].translations.connections || {}).toasts || {},
      {
        deleted: "تم حذف الاتصال بنجاح!",
        webhookCopied: "تم نسخ الويب هوك!",
        webhookNotReady: "لم يتم إنشاء الويب هوك لهذا الاتصال بعد. احفظ الاتصال وحاول مرة أخرى.",
      }
    ),
  });
  messages["ar"].translations.officialCall = Object.assign(messages["ar"].translations.officialCall || {}, {
    permissionTitle: "طلب إذن الاتصال",
    permissionBody: "تسمح Meta بالمكالمات التي تبدأها الشركة فقط بعد موافقة جهة الاتصال — واستقبال مكالمة منها لا يُعد موافقة. يمكننا إرسال الطلب الآن: ستصلها رسالة بأزرار السماح أو الرفض. بعد الموافقة تعمل المكالمة لفترة قصيرة.",
    permissionLater: "ليس الآن",
    permissionAsk: "إرسال الطلب",
    toasts: Object.assign(
      (messages["ar"].translations.officialCall || {}).toasts || {},
      {
        permissionSent: "تم إرسال طلب الإذن. بمجرد موافقة جهة الاتصال يمكنك الاتصال.",
        permissionFailed: "تعذر إرسال طلب الإذن.",
      }
    ),
  });
}

// === i18n: telas de Agendamento + Google Agenda ===
//
// As chaves destas duas telas ficam aqui, num merge explícito, e não
// inseridas no meio do objeto acima. Motivo concreto: estes arquivos têm
// indentação irregular, e ao inserir por texto os blocos caíram FORA de
// `translations` no arquivo turco — sem erro nenhum, apenas sem tradução.
// O merge abaixo escreve no lugar certo por referência, não por posição.
//
// O spread preserva o que já existir: se alguma chave for traduzida à mão
// mais acima, ela continua valendo.
const _t = messages.ar.translations;
Object.assign(_t, {
  scheduleGoogle: {
    ...(_t.scheduleGoogle || {}),
    ...{
  "title": "تكامل تقويم Google و Meet",
  "connectedAs": "متصل:",
  "connectAccount": "ربط حساب",
  "notConnectedHint": "لا يوجد حساب Google مرتبط. اربط حساباً لمزامنة هذه الجدولة مع التقويم وإنشاء رابط Meet.",
  "syncCalendar": "المزامنة مع تقويم Google",
  "generateMeet": "إنشاء رابط Google Meet",
  "eventTitle": "عنوان الاجتماع / الموضوع",
  "eventTitlePlaceholder": "مثال: اجتماع مع العميل",
  "duration": "المدة",
  "minutes": "دقيقة",
  "hour": "ساعة",
  "hours": "ساعات",
  "copyLink": "نسخ الرابط",
  "copied": "تم النسخ!",
  "openMeet": "فتح Meet"
}
  },
  schedulesHeader: {
    ...(_t.schedulesHeader || {}),
    ...{
  "title": "جدولة الرسائل",
  "subtitle": "جدولة ومتابعة الإرسال التلقائي والتذكيرات في تقويم تفاعلي",
  "programmed": "عمليات إرسال مجدولة",
  "schedulesWord": "جدولة",
  "cardTotal": "إجمالي المجدول",
  "cardTotalHint": "عمليات الإرسال المسجلة في النظام",
  "cardToday": "مجدول لليوم",
  "cardTodayHint": "عمليات الإرسال المخططة لليوم",
  "cardWeek": "الأيام السبعة القادمة",
  "cardWeekHint": "توقعات الأسبوع",
  "cardPending": "قيد الانتظار",
  "cardPendingHint": "بانتظار موعد الإرسال",
  "googleCalendar": "تقويم Google",
  "newSchedule": "جدولة جديدة"
}
  },
  googleCalendar: {
    ...(_t.googleCalendar || {}),
    ...{
  "title": "Google Calendar & Google Meet integration",
  "step1": "1. Google API credentials (OAuth 2.0)",
  "step1Sub": "Set the Client ID and Client Secret generated in Google Cloud Console",
  "clientId": "Google Client ID",
  "clientSecret": "Google Client Secret",
  "redirectUri": "Authorized redirect URI (paste into Google Cloud)",
  "jsOrigin": "Authorized JavaScript origin (paste into Google Cloud)",
  "saveCredentials": "Save API credentials",
  "credentialsSaved": "Credentials saved.",
  "credentialsFail": "Could not save the credentials.",
  "copied": "Copied!",
  "howToTitle": "Step by step: how to create the Client ID and Client Secret in Google Cloud (2 minutes)",
  "how1": "Go to console.cloud.google.com and create (or pick) a project.",
  "how2": "Under APIs & Services → Library, enable the Google Calendar API.",
  "how3": "Under OAuth consent screen, set it to External and publish.",
  "how4": "Under Credentials → Create credentials → OAuth client ID, choose Web application.",
  "how5": "Paste the two values above into the authorized origins and redirect URIs fields.",
  "how6": "Copy the generated Client ID and Client Secret and paste them above.",
  "step2": "2. Google account connection",
  "step2Sub": "Connect the account that will manage meetings and Meet",
  "connectionStatus": "CONNECTION STATUS",
  "connectedAccount": "CONNECTED ACCOUNT",
  "connected": "Connected",
  "connectedAs": "Connected",
  "disconnect": "Disconnect",
  "disconnectAccount": "Disconnect account",
  "openCalendar": "Open Google Calendar",
  "connect": "Connect Google Calendar",
  "notConnected": "No Google account connected for this company.",
  "confirmDisconnect": "Disconnect the Google account from this company?",
  "defaultCalendar": "Default calendar",
  "primary": "primary (default)",
  "main": "main",
  "defaultDuration": "Default meeting length",
  "timezone": "Time zone",
  "timezoneHelp": "e.g. America/Sao_Paulo",
  "save": "Save settings",
  "saving": "Saving...",
  "subtitle": "Connect a Google account to create events and meetings from your schedules.",
  "prefsTitle": "Google Meet & scheduling preferences",
  "prefsSubtitle": "Choose how events and meetings are created",
  "autoMeet": "Generate Google Meet automatically",
  "autoMeetHelp": "Creates a unique video call link on every schedule",
  "syncEvents": "Sync events to Google Calendar",
  "syncEventsHelp": "Adds scheduled messages to your Google calendar",
  "sendInvite": "Email the invite to the customer",
  "sendInviteHelp": "Google sends an automatic invite when the contact has an email on file",
  "errors": {
    "credentialsMissing": "Google Calendar has not been enabled on this platform yet. Ask the administrator to register the Google Client ID and Client Secret.",
    "redirectMissing": "Could not determine the server address for the Google callback. Please tell the administrator."
  },
  "toast": {
    "connected": "Google Calendar connected!",
    "connectFail": "Could not connect: ",
    "unknownError": "unknown error",
    "authUrlError": "Could not start the Google connection.",
    "disconnected": "Account disconnected.",
    "disconnectError": "Could not disconnect.",
    "saved": "Settings saved.",
    "saveError": "Could not save."
  }
}
  },
});

// i18n: telas novas (212 chaves)
(() => {
  const target = messages.ar.translations;
  const extra = {
    "googleSettings": {
      "navTitle": "Google",
      "navSubtitle": "تسجيل الدخول وبيانات الاعتماد",
      "title": "Google (تسجيل الدخول والتقويم)",
      "subtitle": "بيانات اعتماد Google OAuth لتسجيل الدخول الاجتماعي وتكامل تقويم Google.",
      "whereToGet": "Google Cloud Console → واجهات برمجة التطبيقات والخدمات → بيانات الاعتماد",
      "loginSection": "تسجيل الدخول بـ Google (OAuth)",
      "clientId": "معرّف العميل Google",
      "clientSecret": "المفتاح السري للعميل Google",
      "calendarSection": "تقويم Google",
      "calendarClientId": "معرّف العميل لتقويم Google",
      "calendarClientSecret": "المفتاح السري لعميل تقويم Google",
      "hint": "تلميح: يمكنك استخدام نفس عميل OAuth لتسجيل الدخول والتقويم، بشرط تمكين نطاق التقويم.",
      "save": "حفظ",
      "saved": "تم حفظ بيانات اعتماد Google بنجاح.",
      "saveError": "حدث خطأ أثناء حفظ بيانات اعتماد Google."
    },
    "voiceCampaign": {
      "enable": "حملة صوتية (تتصل بجهة الاتصال وتشغّل مقطعًا صوتيًا)",
      "audioTitle": "صوت المكالمة",
      "record": "تسجيل",
      "stop": "إيقاف",
      "upload": "تحميل ملف",
      "remove": "إزالة الصوت",
      "savedAudio": "الصوت المحفوظ",
      "hint": "سجّل بالميكروفون أو حمّل ملفًا صوتيًا.",
      "ringSeconds": "مدة الرنين (ث)",
      "ringSecondsHelp": "المدة قبل اعتبار المكالمة بدون رد",
      "attempts": "المحاولات",
      "attemptsHelp": "عدد المكالمات لكل جهة اتصال",
      "sendText": "إرسال رسالة نصية بعد المكالمة مباشرة",
      "sendTextHelp": "الرسالة هي المحددة في خطوة \"الرسالة\"، مع المتغيرات والمرفق. أوقف هذا الخيار لإجراء المكالمة فقط دون نص.",
      "retryMinutes": "الفاصل بين المحاولات (دقيقة)",
      "retryMinutesHelp": "مدة الانتظار قبل إعادة الاتصال",
      "errors": {
        "noRecorder": "هذا المتصفح لا يستطيع تسجيل الصوت. حمّل ملفًا بدلاً من ذلك.",
        "noMic": "تعذّر الوصول إلى الميكروفون. تحقق من إذن المتصفح.",
        "recordFailed": "فشل بدء التسجيل."
      }
    },
    "googleCalendar": {
      "menu": "تقويم Google"
    },
    "flowFormModal": {
      "anyMessageHelper": "سيتم تشغيل المسار عند أي رسالة واردة.",
      "firstContactHelper": "سيتم تشغيل المسار فقط عند أول تواصل من العميل.",
      "outOfHoursHelper": "سيتم تشغيل المسار عند وصول الرسالة خارج ساعات العمل.",
      "regexPattern": "تعبير نمطي",
      "regexPatternPlaceholder": "مثال: ^(مرحبا|السلام|صباح الخير)",
      "regexHelper": "استخدم صيغة JavaScript RegExp (بدون شرطات مائلة).",
      "regexFlags": "الرايات",
      "regexFlagsPlaceholder": "مثال: i, gi",
      "webhookUrl": "رابط Webhook",
      "webhookUrlPlaceholder": "https://your-service.com/webhook",
      "webhookHelper": "رابط خارجي يستقبل الطلب لتشغيل المسار.",
      "integrationId": "معرّف التكامل",
      "manualToken": "رمز API",
      "manualTokenHelper": "استخدم هذا الرمز في ترويسة Authorization عند استدعاء نقطة النهاية.",
      "manualEndpoint": "نقطة النهاية",
      "generateToken": "توليد رمز",
      "copy": "نسخ"
    },
    "common": {
      "loading": "جارٍ التحميل..."
    },
    "integrationNode": {
      "loading": "جارٍ التحميل...",
      "loadingIntegrations": "جارٍ تحميل التكاملات...",
      "available": "{{count}} تكامل متاح",
      "select": "اختر...",
      "empty": "لم يتم العثور على تكامل",
      "advanced": "إعدادات متقدمة",
      "drawerTitle": "إعدادات متقدمة",
      "tabGeneral": "عام",
      "tabExecution": "التنفيذ",
      "tabVariables": "المتغيرات",
      "tabFallback": "الاحتياطي",
      "nodeName": "اسم العقدة",
      "beforeMsg": "رسالة قبل التشغيل",
      "afterMsg": "رسالة بعد التنفيذ",
      "continueFlow": "متابعة المسار بعد التكامل",
      "timeout": "المهلة (ثانية)",
      "retries": "إعادة المحاولة عند الفشل",
      "retryDelay": "الفاصل بين المحاولات (مللي ثانية)",
      "async": "الوضع غير المتزامن (بدون انتظار الرد)",
      "varsSend": "المتغيرات المُرسلة",
      "responseVar": "حفظ الرد في متغير",
      "urlOverride": "رابط Webhook (تجاوز)",
      "method": "طريقة HTTP",
      "headers": "ترويسات مخصصة",
      "bodyExtra": "محتوى إضافي (JSON)",
      "fallbackMsg": "رسالة عند الفشل",
      "transferOnFail": "تحويل التذكرة عند الفشل",
      "transferQueueId": "معرّف قائمة الانتظار للتحويل",
      "transferUserId": "معرّف المستخدم للتحويل",
      "add": "إضافة",
      "emptyKV": "لا توجد عناصر.",
      "save": "حفظ",
      "cancel": "إلغاء"
    },
    "kanbanBoards": {
      "title": "لوحات كانبان",
      "buttons": {
        "backToKanban": "العودة إلى كانبان",
        "newBoard": "+ لوحة جديدة"
      },
      "filters": {
        "allBoards": "كل اللوحات",
        "myBoards": "لوحاتي"
      },
      "emptyState": "لا توجد لوحة بعد. اضغط على <b>+ لوحة جديدة</b> للبدء.",
      "table": {
        "name": "الاسم",
        "description": "الوصف",
        "columns": "الأعمدة",
        "visibility": "الظهور",
        "owner": "المالك",
        "default": "افتراضي",
        "actions": "الإجراءات",
        "user": "المستخدم"
      },
      "visibility": {
        "shared": "مشتركة",
        "private": "خاصة"
      },
      "actions": {
        "removeDefault": "إزالة كافتراضية",
        "setDefault": "تعيين كافتراضية",
        "openInKanban": "فتح في كانبان",
        "edit": "تعديل",
        "delete": "حذف"
      },
      "dialog": {
        "newTitle": "لوحة جديدة",
        "editTitle": "تعديل اللوحة",
        "nameLabel": "اسم اللوحة",
        "descriptionLabel": "الوصف",
        "color": "اللون:",
        "shareWithCompany": "المشاركة مع الشركة بالكامل",
        "sharedHelp": "<b>مشتركة:</b> سيرى جميع مستخدمي الشركة هذه اللوحة في محدد كانبان ويمكنهم عرضها وتعديلها. المُنشئ فقط يمكنه حذفها.",
        "privateHelp": "<b>خاصة:</b> أنت فقط ترى هذه اللوحة. لن يتمكن مستخدمو الشركة الآخرون من الوصول إليها في محدد كانبان.",
        "templateOptional": "قالب (اختياري)",
        "blankTemplate": "فارغ",
        "blankTemplateDesc": "إنشاء لوحة بدون أعمدة محددة مسبقًا",
        "cancel": "إلغاء",
        "save": "حفظ",
        "saving": "جارٍ الحفظ..."
      },
      "confirmDelete": {
        "title": "حذف اللوحة",
        "message": "هل أنت متأكد من حذف اللوحة <b>{{name}}</b>؟ لن يتم حذف الوسوم/الأعمدة."
      },
      "toasts": {
        "loadError": "خطأ في تحميل اللوحات",
        "nameRequired": "أدخل اسمًا",
        "updated": "تم تحديث اللوحة",
        "created": "تم إنشاء اللوحة",
        "saveError": "خطأ في الحفظ",
        "defaultRemoved": "تم إزالة اللوحة الافتراضية",
        "defaultSet": "تم تعيين اللوحة الافتراضية",
        "defaultError": "خطأ في تغيير الافتراضي",
        "deleted": "تم حذف اللوحة",
        "deleteError": "خطأ في الحذف"
      }
    },
    "whatsappHealth": {
      "title": "صحة رقم واتساب (الواجهة الرسمية)",
      "updatedAt": "آخر تحديث",
      "refresh": "تحديث",
      "empty": "لا يوجد رقم واتساب رسمي مُهيأ.",
      "unknown": "غير معروف",
      "verifiedName": "الاسم الموثّق",
      "messagingLimit": "حد الرسائل (24 ساعة)",
      "platform": "المنصة",
      "codeVerification": "التحقق بالرمز",
      "nameStatus": "حالة الاسم",
      "accountReview": "مراجعة الحساب",
      "businessVerification": "التحقق من النشاط التجاري",
      "wabaName": "اسم WABA",
      "phoneNumberId": "معرّف رقم الهاتف",
      "throughput": "معدل الإرسال"
    },
    "campaignWizard": {
      "subtitle": "هيّئ حملاتك الجماعية بذكاء",
      "previewClient": "العميل",
      "previewOnline": "متصل",
      "previewToday": "اليوم",
      "previewMsg1Placeholder": "اكتب الرسالة 1 لمعاينتها هنا…",
      "previewTemplatePlaceholder": "اختر قالبًا لمعاينته هنا…"
    },
    "ivr": {
      "menu": "الرد الآلي / قوائم الانتظار",
      "title": "مسارات الرد الآلي",
      "help": "أنشئ قوائم مكالمات DTMF. يمكن للخيارات التوجيه إلى قوائم الانتظار أو الوكلاء أو الأرقام الداخلية. يعمل الاحتياطي عند انتهاء المهلة أو الإدخال غير الصالح.",
      "new": "مسار جديد",
      "newTitle": "مسار رد آلي جديد",
      "editTitle": "تعديل مسار الرد الآلي",
      "empty": "لا توجد مسارات بعد",
      "disabled": "معطّل",
      "save": "حفظ",
      "cancel": "إلغاء",
      "saved": "تم حفظ المسار",
      "confirmDelete": "حذف هذا المسار؟",
      "errors": {
        "nameRequired": "الاسم مطلوب",
        "summaryTitle": "صحّح الأخطاء التالية قبل الحفظ:",
        "digitRequired": "المفتاح مطلوب",
        "digitInvalid": "استخدم فقط 0-9 أو * أو #",
        "digitDuplicate": "مفتاح مكرر",
        "targetRequired": "الهدف مطلوب",
        "extensionRequired": "أدخل الرقم الداخلي",
        "submenuRequired": "اختر الرد الآلي الهدف",
        "submenuSelf": "لا يمكن للقائمة الفرعية أن تشير إلى نفسها",
        "submenuMissing": "الرد الآلي الهدف غير موجود",
        "fallbackRequired": "حدّد إجراءً احتياطيًا",
        "followMeNeedsUser": "Follow-me يعمل فقط مع هدف الوكيل",
        "submenuCycle": "سلسلة القوائم الفرعية تُشكّل حلقة مغلقة",
        "submenuTooDeep": "سلسلة القوائم الفرعية تتجاوز حد 5 مستويات"
      },
      "list": {
        "options": "الخيارات",
        "status": "الحالة"
      },
      "fields": {
        "name": "الاسم",
        "did": "DID (الرقم الوارد)",
        "didHelp": "اختياري. فارغ = المسار الافتراضي",
        "isDefault": "افتراضي",
        "enabled": "مُفعّل",
        "greetingText": "نص الترحيب (TTS)",
        "greetingAudioUrl": "رابط صوت الترحيب",
        "timeout": "المهلة (ث)",
        "maxRetries": "المحاولات"
      },
      "options": {
        "title": "خيارات DTMF",
        "add": "إضافة خيار",
        "digit": "المفتاح",
        "label": "الوصف",
        "action": "الإجراء",
        "target": "الهدف",
        "empty": "لا توجد خيارات بعد. أضف مفاتيح (1، 2، 3...)."
      },
      "action": {
        "queue": "قائمة انتظار",
        "user": "وكيل",
        "extension": "رقم داخلي خارجي",
        "submenu": "قائمة فرعية (رد آلي آخر)",
        "voicemail": "البريد الصوتي",
        "hangup": "إنهاء المكالمة"
      },
      "target": {
        "queue": "قائمة انتظار",
        "user": "وكيل",
        "extension": "رقم داخلي/رقم",
        "submenu": "الرد الآلي الهدف"
      },
      "fallback": {
        "title": "الاحتياطي (مهلة / غير صالح)",
        "useFollowMe": "استخدم Follow-me للوكيل عند عدم توفره"
      },
      "preview": {
        "title": "معاينة المسار",
        "help": "كيف سيتصرف الرد الآلي مع كل مفتاح DTMF، بما في ذلك القوائم الفرعية المتسلسلة."
      }
    }
  };
  const deepFill = (t, s) => {
    for (const k of Object.keys(s)) {
      if (s[k] && typeof s[k] === "object" && !Array.isArray(s[k])) {
        if (!t[k] || typeof t[k] !== "object") t[k] = {};
        deepFill(t[k], s[k]);
      } else if (t[k] === undefined) {
        t[k] = s[k];
      }
    }
  };
  deepFill(target, extra);
})();
